/* (4) toki-wheel.part2.js — UI build + wiring skeleton (no spin logic here) */ 
(function(){
  'use strict';

  var TW = window.TokiWheel, U = TW && TW.util;
  if(!TW || !U) return;
  var T = TW.i18n && TW.i18n.t ? TW.i18n.t : function(value){ return value; };

  /* Production safety: every visible wheel must originate in page Liquid.
     Missing presets fail closed before the UI builder can paint demo data. */
  var initialPreset = window.TOKI_WHEEL_PRESET || window.TokiWheelPreset || null;
  if(window.TOKI_REQUIRE_PAGE_PRESET !== false &&
     !(initialPreset && Array.isArray(initialPreset.segments) && initialPreset.segments.length >= 2)){
    var missingPresetRoot = document.getElementById('toki-wheel-root');
    if(missingPresetRoot){
      missingPresetRoot.innerHTML = '<div class="tw-homeLoadError" role="alert"><strong>Wheel temporarily unavailable</strong><span>The page wheel preset could not be loaded. Please refresh to try again.</span></div>';
    }
    try{ console.error('Spin the Wheel Lab did not initialize because this page did not provide a valid Liquid preset.'); }catch(_){}
    return;
  }

  // Keep image validation available even if Shopify temporarily serves a cached older Part 1.
  if(typeof U.safeImageSource !== 'function'){
    U.safeImageSource = function(value){
      value = String(value == null ? '' : value).trim();
      if(!value) return '';
      if(value.length <= 2800000 && /^data:image\/(?:png|jpe?g|webp|gif);base64,[a-z0-9+/=\s]+$/i.test(value)) return value;
      if(value.length > 4096) return '';
      try{
        var parsed = new URL(value, window.location.origin);
        return (parsed.protocol === 'https:' || parsed.protocol === 'http:') ? parsed.href : '';
      }catch(_){ return ''; }
    };
  }
  if(typeof U.safeImageFile !== 'function'){
    U.safeImageFile = function(file){
      if(!file || !(file.size >= 0) || file.size > 15 * 1024 * 1024) return false;
      var type = String(file.type || '').toLowerCase();
      var name = String(file.name || '').toLowerCase();
      return /^(image\/png|image\/jpeg|image\/webp|image\/gif|image\/hei[cf])$/.test(type) ||
        (!type && /\.(png|jpe?g|webp|gif|hei[cf])$/.test(name));
    };
  }

  TW.ensureState();

  var SVG_NS = 'http://www.w3.org/2000/svg';

  // ✅ SURGICAL: the “Clear badge” should revert to this image
  var RESET_BADGE_URL = 'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/resetbadgewhitecircle.png?v=1770572903';
  var DASHBOARD_PAGE_PATH = '/pages/dashboard';

  function R(){
    var r = TW.refs;
    r.root = r.root || document.getElementById('toki-wheel-root');
    return r;
  }

  function clamp(v, a, b){ return Math.max(a, Math.min(b, v)); }

  function placeMenuPanel(btn, node){
    if(!btn || !node) return;
    node.style.position = 'fixed';
    node.style.zIndex = '100010';

    var rect = btn.getBoundingClientRect();
    var pad = 12;
    var w = Math.min(280, Math.max(200, (window.innerWidth || 320) - pad*2));
    node.style.width = w + 'px';
    node.style.boxSizing = 'border-box';

    var left = clamp(rect.left, pad, (window.innerWidth || 320) - w - pad);
    var top = rect.bottom + 8;
    var estH = Math.min(320, (window.innerHeight || 600) - pad*2);
    if(top + estH > (window.innerHeight || 600) - pad){
      top = rect.top - 8 - estH;
    }
    top = clamp(top, pad, (window.innerHeight || 600) - pad - 120);

    node.style.left = left + 'px';
    node.style.top = top + 'px';
  }

  function enhanceSelectMenu(sel, opts){
    if(!sel || sel._twMenuEnhanced) return sel && sel._twMenuButton;
    opts = opts || {};

    var wrap = U.el('div', { class:'tw-selectWrap' });
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    sel.classList.add('tw-nativeSelect');

    var btn = U.el('button', {
      class:'tw-btn tw-selectMenu' + (opts.buttonClass ? (' ' + opts.buttonClass) : ''),
      type:'button',
      'aria-haspopup':'listbox',
      'aria-expanded':'false'
    }, [
      U.el('span', { class:'tw-selectMenuLabel', text:'' }),
      U.el('span', { class:'tw-selectMenuCaret', text:'▾' })
    ]);
    wrap.appendChild(btn);

    var labelNode = btn.querySelector('.tw-selectMenuLabel');
    var panel = null;

    function syncLabel(){
      var opt = sel.options[sel.selectedIndex] || null;
      labelNode.textContent = opt ? (opt.textContent || opt.innerText || '') : (opts.placeholder || 'Select');
      btn.title = labelNode.textContent;
    }

    function closePanel(){
      if(panel && panel.parentNode) panel.parentNode.removeChild(panel);
      panel = null;
      btn.setAttribute('aria-expanded', 'false');
      window.removeEventListener('resize', onMove, { passive:true });
      window.removeEventListener('scroll', onMove, { passive:true });
    }

    function onMove(){ if(panel) placeMenuPanel(btn, panel); }

    function openPanel(){
      closePanel();
      panel = U.el('div', { class:'tw-menuPanel' });
      var list = U.el('div', { class:'tw-menuList', role:'listbox', 'aria-label': (opts.ariaLabel || btn.title || 'Options') });

      Array.prototype.forEach.call(sel.options, function(opt){
        var optionBtn = U.el('button', {
          class:'tw-menuOption' + (opt.value === sel.value ? ' isSelected' : ''),
          type:'button',
          role:'option',
          'aria-selected': (opt.value === sel.value ? 'true' : 'false')
        }, [
          U.el('span', { text:(opt.textContent || opt.innerText || '') }),
          U.el('span', { class:'tw-menuCheck', text:(opt.value === sel.value ? '✓' : '') })
        ]);
        optionBtn.addEventListener('click', function(){
          if(sel.value !== opt.value){
            sel.value = opt.value;
            sel.dispatchEvent(new Event('change', { bubbles:true }));
          }else{
            syncLabel();
          }
          closePanel();
          btn.focus();
        });
        list.appendChild(optionBtn);
      });

      panel.appendChild(list);
      document.body.appendChild(panel);
      btn.setAttribute('aria-expanded', 'true');
      placeMenuPanel(btn, panel);
      window.addEventListener('resize', onMove, { passive:true });
      window.addEventListener('scroll', onMove, { passive:true });

      setTimeout(function(){
        document.addEventListener('click', function once(ev){
          if(!panel) return;
          var t = ev.target;
          if(t === btn || btn.contains(t) || t === panel || panel.contains(t)) return;
          closePanel();
          document.removeEventListener('click', once);
        });
      }, 0);
    }

    btn.addEventListener('click', function(ev){
      ev.preventDefault();
      ev.stopPropagation();
      if(panel){ closePanel(); return; }
      openPanel();
    });

    btn.addEventListener('keydown', function(ev){
      if(ev.key === 'Enter' || ev.key === ' ' || ev.key === 'ArrowDown'){
        ev.preventDefault();
        if(!panel) openPanel();
      }else if(ev.key === 'Escape'){
        closePanel();
      }
    });

    sel.addEventListener('change', syncLabel);
    new MutationObserver(function(){
      syncLabel();
      if(panel) openPanel();
    }).observe(sel, { childList:true, subtree:true, attributes:true, attributeFilter:['selected','label'] });

    syncLabel();
    sel._twMenuSyncLabel = syncLabel;
    sel._twMenuEnhanced = true;
    sel._twMenuButton = btn;
    sel._twCloseMenuPanel = closePanel;
    return btn;
  }

  // ✅ SURGICAL: ensure inputs/selects reflect current state (supports per-page presets applied in part5)
  function syncUIFromState(){
    var r = R();
    if(!r || !TW.state || !TW.state.ui) return;

    var ui = TW.state.ui;

    // header text nodes
    if(r.hTitle) r.hTitle.textContent = (ui.title || 'WHEEL').toUpperCase();
    if(r.hSub) r.hSub.textContent = ui.desc || '';

    // snippet-driven header text color should only affect section headers
    if(r.root && r.root.style){
      var headerText = String(ui.headerTextColor || '').trim();
      r.root.style.setProperty('--tw-headerText', headerText || 'var(--tw-white)');
    }

    // title/desc inputs
    if(r.inTitle) r.inTitle.value = (ui.title || '').toUpperCase();
    if(r.inDesc) r.inDesc.value = ui.desc || '';

    // speed/confetti/countdown
    if(r.selSpeed){ r.selSpeed.value = ui.speed || 'normal'; if(r.selSpeed._twMenuSyncLabel) r.selSpeed._twMenuSyncLabel(); }
    if(r.selConfetti){ r.selConfetti.value = ui.confettiOn || 'yes'; if(r.selConfetti._twMenuSyncLabel) r.selConfetti._twMenuSyncLabel(); }
    if(r.bizPopup){ r.bizPopup.value = ui.spinBizPopup || 'no'; if(r.bizPopup._twMenuSyncLabel) r.bizPopup._twMenuSyncLabel(); }
    if(r.bizPopupMedia){ r.bizPopupMedia.value = ui.spinBizPopupMedia || 'none'; if(r.bizPopupMedia._twMenuSyncLabel) r.bizPopupMedia._twMenuSyncLabel(); }
    if(r.bizPopupStyle){ r.bizPopupStyle.value = ui.spinBizPopupStyle || 'classic'; if(r.bizPopupStyle._twMenuSyncLabel) r.bizPopupStyle._twMenuSyncLabel(); }
    if(r.bizPopupEntrance){ r.bizPopupEntrance.value = ui.spinBizPopupEntrance || 'pop'; if(r.bizPopupEntrance._twMenuSyncLabel) r.bizPopupEntrance._twMenuSyncLabel(); }
    if(r.bizPopupHeadline){ r.bizPopupHeadline.value = ui.spinBizPopupHeadline == null ? 'Winner!' : ui.spinBizPopupHeadline; }
    if(r.bizPopupMessage){ r.bizPopupMessage.value = ui.spinBizPopupMessage || ''; }
    if(r.bizPopupButton){ r.bizPopupButton.value = ui.spinBizPopupButton == null ? 'Claim Prize' : ui.spinBizPopupButton; }
    if(r.bizUrl){ r.bizUrl.value = ui.spinBizUrl || ''; }
    if(r.bizPopupImageUrl){ r.bizPopupImageUrl.value = String(ui.spinBizPopupImage || '').indexOf('data:image') === 0 ? '' : (ui.spinBizPopupImage || ''); }
    if(r.bizPopupImageFile){ try{ r.bizPopupImageFile.value = ''; }catch(_){} }
    if(r.bizQrFg){ r.bizQrFg.value = '#' + String(ui.spinBizQrFg || '2c0a71').replace(/^#/, ''); }
    if(r.bizQrFgHex){ r.bizQrFgHex.value = '#' + String(ui.spinBizQrFg || '2c0a71').replace(/^#/, ''); }
    if(r.bizQrBg){ r.bizQrBg.value = '#' + String(ui.spinBizQrBg || 'ffffff').replace(/^#/, ''); }
    if(r.bizQrBgHex){ r.bizQrBgHex.value = '#' + String(ui.spinBizQrBg || 'ffffff').replace(/^#/, ''); }
    if(r.bizQrLogoUrl){ r.bizQrLogoUrl.value = String(ui.spinBizQrLogo || '').indexOf('data:image') === 0 ? '' : (ui.spinBizQrLogo || ''); }
    if(r.bizQrLogoFile){ try{ r.bizQrLogoFile.value = ''; }catch(_){} }
    if(r.bizConfettiMode){ r.bizConfettiMode.value = (ui.spinBizConfettiMode === 'emoji' ? 'standard' : (ui.spinBizConfettiMode || 'standard')); if(r.bizConfettiMode._twMenuSyncLabel) r.bizConfettiMode._twMenuSyncLabel(); }
    if(r.bizCelebrationEffect){ r.bizCelebrationEffect.value = ui.spinBizCelebrationEffect || 'classic'; if(r.bizCelebrationEffect._twMenuSyncLabel) r.bizCelebrationEffect._twMenuSyncLabel(); }
    if(TW.syncCreativeEffectOrbs) TW.syncCreativeEffectOrbs();
    if(r.bizCelebrationIntensity){ r.bizCelebrationIntensity.value = ui.spinBizCelebrationIntensity || 'standard'; if(r.bizCelebrationIntensity._twMenuSyncLabel) r.bizCelebrationIntensity._twMenuSyncLabel(); }
    if(r.bizCelebrationColor){ r.bizCelebrationColor.value = ui.spinBizCelebrationColor || 'wheel'; if(r.bizCelebrationColor._twMenuSyncLabel) r.bizCelebrationColor._twMenuSyncLabel(); }
    if(r.bizCelebrationCustomColor){ r.bizCelebrationCustomColor.value = '#' + String(ui.spinBizCelebrationCustomColor || 'ff4fa3').replace(/^#/, ''); }
    if(r.bizCelebrationCustomHex){ r.bizCelebrationCustomHex.value = '#' + String(ui.spinBizCelebrationCustomColor || 'ff4fa3').replace(/^#/, ''); }
    if(r.bizConfettiUrl){ r.bizConfettiUrl.value = String(ui.spinBizConfettiImage || '').indexOf('data:image') === 0 ? '' : (ui.spinBizConfettiImage || ''); }
    if(r.bizConfettiFile){ try{ r.bizConfettiFile.value = ''; }catch(_){} }
    if(TW.updateSpinBizPreviews) TW.updateSpinBizPreviews();
    if(TW.updateCreativeConditionalFields) TW.updateCreativeConditionalFields();
    if(r.selCountdownOn){ r.selCountdownOn.value = ui.countdownOn || 'no'; if(r.selCountdownOn._twMenuSyncLabel) r.selCountdownOn._twMenuSyncLabel(); }

    if(r.inCountdownSec){
      var cs = parseInt(ui.countdownSec == null ? 3 : ui.countdownSec, 10);
      if(!isFinite(cs)) cs = 3;
      cs = U.clamp(cs, 1, 10);
      r.inCountdownSec.value = String(cs);
    }

    if(r.expClassicBtn && r.expFakeoutBtn && r.expBlackoutBtn && r.expReactorBtn){
      var exp = String(ui.spinExperience || 'classic');
      var map = {
        classic: r.expClassicBtn,
        fakeout_frenzy: r.expFakeoutBtn,
        blackout_drop: r.expBlackoutBtn,
        reactor_surge: r.expReactorBtn
      };
      [r.expClassicBtn, r.expFakeoutBtn, r.expBlackoutBtn, r.expReactorBtn].forEach(function(btn){
        if(!btn) return;
        btn.classList.remove('isActive');
      });
      if(map[exp]) map[exp].classList.add('isActive');
      if(r.expStatus){
        r.expStatus.textContent = exp === 'classic'
          ? 'Classic wheel behavior is active.'
          : 'This experience overrides speed, countdown, and confetti while it runs. Sound and voice still follow the user settings.';
      }
    }

    // sound selects + volumes
    if(r.selSpinSound){ r.selSpinSound.value = ui.spinSoundId || (TW.CONST.PRESPIN_SOUNDS[0] && TW.CONST.PRESPIN_SOUNDS[0].id) || ''; if(r.selSpinSound._twMenuSyncLabel) r.selSpinSound._twMenuSyncLabel(); }
    if(r.selWinSound){ r.selWinSound.value = ui.winSoundId || (TW.CONST.CELEBRATION_SOUNDS[0] && TW.CONST.CELEBRATION_SOUNDS[0].id) || ''; if(r.selWinSound._twMenuSyncLabel) r.selWinSound._twMenuSyncLabel(); }

    if(r.rangeSpinVol){
      var sv = (ui.spinVolume == null) ? 0.85 : parseFloat(ui.spinVolume);
      if(!isFinite(sv)) sv = 0.85;
      r.rangeSpinVol.value = String(U.clamp(sv, 0, 1));
    }
    if(r.rangeWinVol){
      var wv = (ui.winVolume == null) ? 0.95 : parseFloat(ui.winVolume);
      if(!isFinite(wv)) wv = 0.95;
      r.rangeWinVol.value = String(U.clamp(wv, 0, 1));
    }
    if(r.rangeVoiceVol){
      var vv = (ui.voiceVolume == null) ? 0.85 : parseFloat(ui.voiceVolume);
      if(!isFinite(vv)) vv = 0.85;
      r.rangeVoiceVol.value = String(U.clamp(vv, 0, 1));
    }

    if(r.inWinnerPhrase) r.inWinnerPhrase.value = ui.winnerPhrase || '';

    // badge controls
    // ✅ SURGICAL:
    // - treat "__none__" as blank input
    // - ALSO treat RESET_BADGE_URL as blank input (we don’t want to show it in the text field)
    if(r.badgeUrl){
      var cur = ui.centerBadgeUrl || '';
      var curStr = String(cur);
      var isNone = (curStr === '__none__');
      var isReset = (curStr === RESET_BADGE_URL);
      r.badgeUrl.value = (!isNone && !isReset && cur && curStr.indexOf('data:') !== 0) ? curStr : '';
    }

    if(r.selBadgeMask){ r.selBadgeMask.value = ui.centerBadgeMask || 'circle'; if(r.selBadgeMask._twMenuSyncLabel) r.selBadgeMask._twMenuSyncLabel(); }

    if(r.rangeBadgeScale){
      var sc = parseFloat(ui.centerBadgeScale == null ? 1 : ui.centerBadgeScale);
      if(!isFinite(sc)) sc = 1;
      r.rangeBadgeScale.value = String(U.clamp(sc, 0.6, 1.4));
    }

    // button labels that depend on state
    if(r.btnElimTop){
      var on = (ui.eliminateOn === 'yes');
      var elimLabel = r.btnElimTop.querySelector('.tw-btnLabel');
      if(elimLabel) elimLabel.textContent = T('Eliminate');
      r.btnElimTop.classList.toggle('isOn', on);
      r.btnElimTop.setAttribute('aria-pressed', on ? 'true' : 'false');
      r.btnElimTop.setAttribute('title', on ? 'Eliminate winner is on' : 'Eliminate winner is off');
    }

    if(r.btnBadgeEdit){
      var eon = (ui.centerBadgeEditOn === 'yes');
      r.btnBadgeEdit.textContent = 'Edit badge: ' + (eon ? 'On' : 'Off');
    }
  }

  TW.syncUIFromState = syncUIFromState;

  function build(){
    var r = R();
    if(!r.root) return;

    r.root.innerHTML = '';
    r.root.className = '';

    // overlay back
    r.overlayBack = U.el('div', { class:'tw-overlayBack', hidden:'' });

    // header utilities only (wheel-specific title/subtitle live inside the wheel card)
    r.hTitle = U.el('div', { class:'tw-title', text: (TW.state.ui.title || 'WHEEL').toUpperCase() });
    r.hSub = U.el('div', { class:'tw-subtitle', text: TW.state.ui.desc || '' });

    r.btnDashboardSave = U.el('button', { class:'tw-btn tw-btnIcon tw-btnHeaderMini', type:'button', id:'twDashboardSave', title:'Save this wheel on this device', 'aria-label':'Save this wheel on this device' }, [
      U.el('span', { class:'tw-btnLabel', text:'+' })
    ]);

    r.challengeBanner = U.el('div', { class:'tw-challengeBanner', hidden:'' });
    var titles = U.el('div', { class:'tw-titles' }, [ r.challengeBanner, r.hTitle, r.hSub ]);

    r.btnOverlay = U.el('button', { class:'tw-btn tw-btnGhost tw-btnIcon', type:'button' }, [
      U.el('span', { class:'tw-btnGlyph', text:'◫' }),
      U.el('span', { text:'Overlay' })
    ]);
    r.btnShare = U.el('button', { class:'tw-btn tw-btnGhost tw-btnIcon', type:'button' }, [
      U.el('span', { class:'tw-btnGlyph', text:'↗' }),
      U.el('span', { text:T('Share') })
    ]);

    // Reset + Elimination toggle in top panel
    r.btnResetAllTop = U.el('button', { class:'tw-btn tw-btnDanger tw-btnIcon', type:'button' }, [
      U.el('span', { class:'tw-btnGlyph', text:'⟳' }),
      U.el('span', { text:T('Reset') })
    ]);
    r.btnElimTop = U.el('button', { class:'tw-btn tw-btnGhost tw-btnIcon tw-eliminateToggle', type:'button', 'aria-pressed':'false' }, [
      U.el('span', { class:'tw-btnGlyph', text:'✂' }),
      U.el('span', { class:'tw-btnLabel', text:T('Eliminate') })
    ]);
    r.btnSoundSettings = U.el('button', { class:'tw-btn tw-btnGhost tw-btnIcon tw-soundToggle', type:'button' }, [
      U.el('span', { class:'tw-btnGlyph', text:'🔊', 'aria-hidden':'true' }),
      U.el('span', { class:'tw-btnLabel', text:T('Sound') })
    ]);
    r.btnVoiceSettings = U.el('button', { class:'tw-btn tw-btnGhost tw-btnIcon tw-voiceToggle', type:'button', id:'twVoiceToggle' }, [
      U.el('span', { class:'tw-btnGlyph', text:'🗣️', 'aria-hidden':'true' }),
      U.el('span', { class:'tw-btnLabel', text:T('Voice') })
    ]);
    r.btnMore = U.el('button', { class:'tw-btn tw-btnGhost tw-settingsButton', type:'button', title:T('Wheel settings'), 'aria-label':T('Wheel settings'), 'aria-haspopup':'menu', 'aria-expanded':'false' }, [
      U.el('span', { class:'tw-settingsGlyph', text:'⚙', 'aria-hidden':'true' })
    ]);
    r.morePanel = U.el('div', { class:'tw-menuPanel tw-headerMoreMenu', hidden:'' }, [
      U.el('div', { class:'tw-menuList', role:'menu', 'aria-label':T('Wheel settings') }, [
        r.btnSoundSettings,
        r.btnVoiceSettings,
        r.btnOverlay,
        r.btnShare,
        r.btnResetAllTop,
        r.btnElimTop
      ])
    ]);

    r.header = U.el('div', { class:'tw-header tw-headerSlim', hidden:'' }, [
      U.el('div', { class:'tw-headerUtility' }, [
        U.el('div', { class:'tw-actions tw-actionsCompact' })
      ])
    ]);

    // wheel card
    r.wheelWrap = U.el('div', { class:'tw-wheelWrap', id:'twWheelWrap' });
    r.pointer = U.el('div', { class:'tw-pointer', 'aria-hidden':'true' });

    // ✅ IMPORTANT FIX: create a real SVG element (namespace-correct)
    r.wheelSvg = document.createElementNS(SVG_NS, 'svg');
    r.wheelSvg.setAttribute('class', 'tw-wheelSvg');
    r.wheelSvg.setAttribute('id', 'twWheelSvg');
    r.wheelSvg.setAttribute('viewBox', '0 0 1000 1000');
    r.wheelSvg.setAttribute('role', 'img');
    r.wheelSvg.setAttribute('aria-label', T('Spinner wheel'));
    r.wheelSvg.setAttribute('xmlns', SVG_NS);

    r.wheelWrap.appendChild(r.pointer);
    r.wheelWrap.appendChild(r.wheelSvg);

    r.btnSpin = U.el('button', { class:'tw-btn tw-btnPrimary tw-bigBtn tw-spinIdlePulse', type:'button', id:'twSpin' }, [T('Spin')]);
    r.btnMulti = U.el('button', { class:'tw-btn tw-btnSecondary tw-bigBtn', type:'button', id:'twMulti' }, [T('Multi-pick')]);
    r.btnUndo = U.el('button', { class:'tw-btn tw-btnDanger tw-bigBtn', type:'button', id:'twUndo' }, [T('Undo')]);

    r.controls = U.el('div', { class:'tw-controls' }, [ r.btnSpin, r.btnMulti, r.btnUndo ]);
    r.btnStartEditing = U.el('button', { class:'tw-startEditing', type:'button', 'aria-controls':'twOptions' }, [
      U.el('span', { class:'tw-startEditingIcon' }, [
        U.el('img', { src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/customizeicon.png?v=1786551564', alt:'', 'aria-hidden':'true' })
      ]),
      U.el('span', { class:'tw-startEditingCopy' }, [
        U.el('span', { class:'tw-startEditingKicker', text:T('START CREATING') }),
        U.el('strong', { text:T('Personalize this wheel') }),
        U.el('small', { text:T('Take a quick tour of colors, stickers, sound, and voice') })
      ]),
      U.el('img', { class:'tw-startEditingArrow', src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/mainwheelpanelsilverarrow.png?v=1789302960', alt:'', 'aria-hidden':'true' })
    ]);
    r.hint = U.el('div', { class:'tw-hint', text:T('Press Spin once to enable flick-to-spin.') });

    r.wheelMetaActions = U.el('div', { class:'tw-wheelMetaActions' }, [
      r.btnMore,
      r.btnDashboardSave
    ]);
    r.wheelMeta = U.el('div', { class:'tw-wheelMeta' }, [
      U.el('div', { class:'tw-wheelMetaText' }, [ titles ]),
      r.wheelMetaActions
    ]);

    r.wheelStage = U.el('div', { class:'tw-wheelStage' }, [ r.wheelWrap ]);
    r.wheelTrust = U.el('div', { class:'tw-wheelTrustRail' }, [
      U.el('img', { class:'tw-wheelTrustBadge', alt:T('Fair Spin Verified'), src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/verifiedbadge2.png?v=1776696814' }),
      U.el('div', { class:'tw-wheelTrustCopy' }, [
        U.el('div', { class:'tw-wheelTrustTitle', text:T('Fair spin verified') }),
        U.el('div', { class:'tw-wheelTrustSub', text:T('Run the 10,000-spin check anytime in Spin Science.') })
      ])
    ]);

    r.wheelCard = U.el('div', { class:'tw-card tw-wheelCard' }, [
      r.wheelMeta,
      r.wheelStage,
      r.controls,
      r.hint,
      r.wheelTrust
    ]);

    // pins side
    r.pinsTitle = U.el('h3', { class:'tw-accordTitle tw-headerText tw-vaultTitle' }, [
      U.el('img', { class:'tw-vaultTrophy', src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/winnersvaultgoldentrophy.png?v=1789303097', alt:'', 'aria-hidden':'true' }),
      U.el('span', { text:'Winners Vault' })
    ]);
    r.btnClearPins = U.el('button', { class:'tw-btn', type:'button' }, ['Clear']);
    r.pinsTop = U.el('div', { class:'tw-vaultHeader' }, [
      r.pinsTitle,
      U.el('div', { style:'display:flex; gap:10px; flex-wrap:wrap; justify-content:flex-end;' }, [ r.btnClearPins ])
    ]);
    r.pinsList = U.el('div', { class:'tw-list tw-accordBody tw-vaultBody', id:'twPinsList' });

    r.side = U.el('section', { class:'tw-accord tw-vaultRebuilt' }, [
      r.pinsTop,
      r.pinsList
    ]);

    // main grid
    r.main = U.el('div', { class:'tw-main' }, [
      r.wheelCard,
      r.side
    ]);

    // On two-column layouts, align the Vault's outer top edge to the actual
    // gear/plus row instead of relying on accumulated card padding.
    TW.alignVaultToWheelActions = function(){
      if(!r.side || !r.wheelCard || !r.wheelMetaActions) return;
      r.side.style.removeProperty('margin-top');
      var ui = TW.state && TW.state.ui;
      if((ui && (ui.overlay || ui.streamMode)) || window.innerWidth <= 980) return;
      var wheelRect = r.wheelCard.getBoundingClientRect();
      var sideRect = r.side.getBoundingClientRect();
      var actionRect = r.wheelMetaActions.getBoundingClientRect();
      // Only apply while the Vault is genuinely sitting to the wheel's right.
      if(sideRect.left <= wheelRect.left + 40) return;
      var offset = Math.round((actionRect.top - 2) - sideRect.top);
      if(Math.abs(offset) <= 420) r.side.style.setProperty('margin-top', offset + 'px', 'important');
    };
    if(!TW._vaultActionAlignmentBound){
      TW._vaultActionAlignmentBound = true;
      window.addEventListener('resize', function(){
        window.requestAnimationFrame(function(){ TW.alignVaultToWheelActions && TW.alignVaultToWheelActions(); });
      }, { passive:true });
    }
    window.requestAnimationFrame(function(){ TW.alignVaultToWheelActions && TW.alignVaultToWheelActions(); });
    // Free wheels change invitation/lock geometry after access UI resolves.
    // Observe the actual cards so alignment is plan-independent and re-runs
    // after late font, access, invitation, and viewport layout changes.
    if(window.ResizeObserver && !TW._vaultActionResizeObserver){
      TW._vaultActionResizeObserver = new ResizeObserver(function(){
        window.requestAnimationFrame(function(){ TW.alignVaultToWheelActions && TW.alignVaultToWheelActions(); });
      });
      TW._vaultActionResizeObserver.observe(r.wheelCard);
      TW._vaultActionResizeObserver.observe(r.wheelMetaActions);
    }
    [80,260,700,1400].forEach(function(delay){
      window.setTimeout(function(){ TW.alignVaultToWheelActions && TW.alignVaultToWheelActions(); }, delay);
    });

    function buildPanelSummary(title, description, iconUrl, pro){
      var copy = U.el('div', { class:'tw-panelHeaderCopy' }, [
        U.el('div', { class:'tw-accordTitle tw-headerText', text:title }),
        U.el('div', { class:'tw-panelHeaderSubtext', text:description })
      ]);
      if(pro) copy.appendChild(U.el('span', { class:'tw-panelProBadge' }, [
        U.el('img', {
          class:'tw-panelProIcon',
          src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexproglassesicon.png?v=1789304505',
          alt:'Vortex Pro'
        })
      ]));
      return U.el('summary', { class:'tw-accordSummary tw-panelSummary' }, [
        U.el('img', { class:'tw-panelHeaderIcon', src:iconUrl, alt:'', 'aria-hidden':'true' }),
        copy,
        U.el('img', {
          class:'tw-panelPushButton',
          src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/mainwheelpanelpushbutton.png?v=1789304499',
          alt:'',
          'aria-hidden':'true'
        })
      ]);
    }

    // Quick Tweaks starts open; the native summary still lets a person close it.
    r.optDetails = U.el('details', { class:'tw-accord', id:'twOptions', open:'' });

    r.optSummary = buildPanelSummary('Quick Tweaks', 'Add, import, reorder, and clean up your wheel choices.', 'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/quicktweakspanelicon.png?v=1789304480', false);

    // Add-one with button (mobile-safe)
    r.optAddOne = U.el('input', { class:'tw-input', type:'text', placeholder:'Add one segment' });
    r.btnAddOneSeg = U.el('button', { class:'tw-btn tw-btnPrimary', type:'button' }, ['Add']);

    r.optBulk = U.el('textarea', { class:'tw-textarea', placeholder:'Paste a spreadsheet column, new lines, or comma-separated names' });
    r.btnBulkAdd = U.el('button', { class:'tw-btn tw-btnPrimary', type:'button' }, ['Add Bulk']);
    r.btnImportEntries = U.el('button', { class:'tw-btn', type:'button' }, ['Import CSV / TSV / TXT']);
    r.entryFileInput = U.el('input', { type:'file', accept:'.csv,.tsv,.txt,text/csv,text/tab-separated-values,text/plain', 'aria-label':'Import entries from a CSV, TSV, or text file', style:'display:none' });
    r.btnShuffle = U.el('button', { class:'tw-btn', type:'button' }, ['Shuffle']);
    r.btnSortAZ = U.el('button', { class:'tw-btn', type:'button' }, ['Sort A→Z']);
    r.btnSortZA = U.el('button', { class:'tw-btn', type:'button' }, ['Sort Z→A']);
    r.btnRemoveDuplicates = U.el('button', { class:'tw-btn', type:'button' }, ['Remove Duplicates']);
    r.btnClearSegs = U.el('button', { class:'tw-btn tw-btnDanger', type:'button' }, ['Clear Segments']);

    r.segCount = U.el('div', { class:'tw-pill', id:'twSegCount', text:'' });

    r.optToolbar = U.el('div', { class:'tw-toolbar' }, [
      r.btnBulkAdd, r.btnImportEntries, r.entryFileInput, r.btnShuffle, r.btnSortAZ, r.btnSortZA, r.btnRemoveDuplicates, r.btnClearSegs, r.segCount
    ]);

    r.segList = U.el('div', { class:'tw-segList', id:'twSegList' });

    // SURGICAL 2026-05-20C: compact sticker-pack promo inside Quick Tweaks.
    // Kept hidden for Vortex Pro / Vortex Pro customers, matching the main Lab Drops suppression.
    function buildQuickStickerPackPromo(){
      var canShow = !(TW.access && TW.access.canSeeInternalAds) || TW.access.canSeeInternalAds();
      var featuredHalloweenPackIds = { haunted:true, monster:true, phantom_quest:true, spooky_quest:true };
      var packs = (TW.STICKER_PACKS || []).filter(function(pack){
        return !!featuredHalloweenPackIds[String(pack && pack.id || '')];
      });
      var promo = U.el('div', { class:'tw-quickStickerPromo' + (canShow ? '' : ' tw-quickStickerPromoHidden') });
      if(!canShow || !packs.length){ promo.hidden = true; return promo; }
      var cursor = 0;
      var art = U.el('img', { class:'tw-quickStickerPromoArt', src:packs[0].banner, alt:packs[0].name || 'Lab Pack', loading:'lazy' });
      var title = U.el('div', { class:'tw-quickStickerPromoTitle', text:packs[0].name || 'Lab Pack' });
      var samples = U.el('div', { class:'tw-quickStickerPromoSamples' });
      var viewBtn = U.el('button', { class:'tw-quickStickerPromoBtn', type:'button' }, ['Get This Pack']);
      promo.appendChild(U.el('div', { class:'tw-quickStickerPromoKicker', text:'ONE-TIME · $4.99 USD' }));
      promo.appendChild(U.el('div', { class:'tw-quickStickerPromoInner' }, [
        U.el('div', { class:'tw-quickStickerPromoMedia' }, [art]),
        U.el('div', { class:'tw-quickStickerPromoCopy' }, [
          title,
          U.el('div', { class:'tw-quickStickerPromoText', text:'Use this themed collection on any wheel and keep it forever—no subscription required.' }),
          U.el('div', { class:'tw-adFeaturePills' }, [
            U.el('span', { text:'12 stickers' }),
            U.el('span', { text:'1 center vortex' }),
            U.el('span', { text:'3 textures' }),
            U.el('span', { text:'Use on every wheel' })
          ]),
          samples,
          U.el('div', { class:'tw-quickStickerPromoActions' }, [viewBtn])
        ])
      ]));
      function render(){
        var pack = packs[cursor % packs.length] || packs[0];
        art.src = pack.banner || '';
        art.alt = pack.name || 'Lab Pack';
        title.textContent = pack.name || 'Lab Pack';
        samples.innerHTML = '';
        ((pack.stickers || pack.sample) || []).slice(0,12).forEach(function(src){ samples.appendChild(U.el('img', { src:src, alt:'', loading:'lazy' })); });
        var packUrl = pack.productUrl || TW.STICKER_PACKS_URL || 'https://spinthewheellab.com/collections/lab-packs';
        function selectPack(){
          TW.track && TW.track('select_promotion', {
            promotion_id:'wheel_lab_packs', promotion_name:'Lab Packs', creative_slot:'quick_tweaks_lab_packs',
            items:[{ item_id:String(pack.id || pack.tag || 'lab_pack'), item_name:String(pack.name || 'Lab Pack') }]
          });
          window.location.href = packUrl;
        }
        viewBtn.onclick = selectPack;
        art.style.cursor = 'pointer';
        art.setAttribute('role','link');
        art.setAttribute('tabindex','0');
        art.onclick = selectPack;
        art.onkeydown = function(ev){ if(ev.key === 'Enter' || ev.key === ' '){ ev.preventDefault(); selectPack(); } };
      }
      function preloadPack(pack, done){
        var urls = [pack && pack.banner].concat(((pack && (pack.stickers || pack.sample)) || []).slice(0,12)).filter(Boolean);
        if(!urls.length){ done(); return; }
        var remaining = urls.length;
        var finished = false;
        var finishOne = function(){
          remaining--;
          if(remaining <= 0 && !finished){ finished = true; done(); }
        };
        urls.forEach(function(src){
          var img = new Image();
          var settled = false;
          var settle = function(){ if(settled) return; settled = true; finishOne(); };
          img.onload = settle;
          img.onerror = settle;
          img.src = src;
          if(img.complete) setTimeout(settle, 0);
        });
        setTimeout(function(){ if(!finished){ finished = true; done(); } }, 2200);
      }
      render();
      if(packs.length > 1){
        try{
          var quickPackTransitioning = false;
          window.setInterval(function(){
            if(promo.hidden || !promo.parentNode || quickPackTransitioning) return;
            quickPackTransitioning = true;
            var nextCursor = (cursor + 1) % packs.length;
            var nextPack = packs[nextCursor] || packs[0];
            preloadPack(nextPack, function(){
              if(!promo.parentNode){ quickPackTransitioning = false; return; }
              promo.classList.add('isChanging');
              setTimeout(function(){
                cursor = nextCursor;
                render();
                window.requestAnimationFrame(function(){
                  window.requestAnimationFrame(function(){
                    promo.classList.remove('isChanging');
                    setTimeout(function(){ quickPackTransitioning = false; }, 620);
                  });
                });
              }, 520);
            });
          }, 5600);
        }catch(_){ }
      }
      TW.analytics && TW.analytics.observePromotion && TW.analytics.observePromotion(promo, {
        promotion_id:'wheel_lab_packs', promotion_name:'Lab Packs', creative_slot:'quick_tweaks_lab_packs'
      });
      return promo;
    }
    r.quickStickerPromo = buildQuickStickerPackPromo();

    // Compact collection gateway. This keeps the featured pack focused on one
    // product while giving the full Lab Pack library its own deliberate home.
    function buildQuickAllPacksPromo(){
      var canShow = !(TW.access && TW.access.canSeeInternalAds) || TW.access.canSeeInternalAds();
      var packs = (TW.STICKER_PACKS || []).slice();
      var allUrl = TW.STICKER_PACKS_URL || 'https://spinthewheellab.com/collections/lab-packs';
      var promo = U.el('div', { class:'tw-quickAllPacksPromo' + (canShow ? '' : ' tw-quickStickerPromoHidden') });
      if(!canShow || !packs.length){ promo.hidden = true; return promo; }

      var preview = U.el('div', { class:'tw-quickAllPacksPreview', 'aria-hidden':'true' });
      packs.slice(0,3).forEach(function(pack){
        if(!pack || !pack.banner) return;
        preview.appendChild(U.el('img', {
          src:pack.banner,
          alt:'',
          loading:'lazy',
          decoding:'async'
        }));
      });

      var button = U.el('button', { class:'tw-quickAllPacksBtn', type:'button' }, ['Explore All Lab Packs']);
      function openAllPacks(){
        TW.track && TW.track('select_promotion', {
          promotion_id:'wheel_lab_packs',
          promotion_name:'Lab Packs',
          creative_slot:'quick_tweaks_all_lab_packs',
          items:[{ item_id:'all_lab_packs', item_name:'Explore All Lab Packs' }]
        });
        window.location.href = allUrl;
      }
      button.onclick = openAllPacks;
      promo.appendChild(preview);
      promo.appendChild(U.el('div', { class:'tw-quickAllPacksCopy' }, [
        U.el('div', { class:'tw-quickAllPacksKicker', text:'THE COMPLETE COLLECTION' }),
        U.el('div', { class:'tw-quickAllPacksTitle', text:'Find a Lab Pack for every kind of wheel' }),
        U.el('div', { class:'tw-quickAllPacksText', text:'Browse every themed set of stickers, center vortices, and textures.' })
      ]));
      promo.appendChild(button);
      TW.analytics && TW.analytics.observePromotion && TW.analytics.observePromotion(promo, {
        promotion_id:'wheel_lab_packs', promotion_name:'Lab Packs', creative_slot:'quick_tweaks_all_lab_packs'
      });
      return promo;
    }
    // Reuse the established full Lab Pack panel here so the collection area
    // has the same banner-and-sticker treatment as the featured pack above.
    r.quickAllPacksPromo = buildLabPackChoicePanel();
    r.quickAllPacksPromo.classList.add('tw-quickAllPacksFull');

    // Restore the established Vortex Pro card treatment, but keep it out of
    // Quick Tweaks. It is mounted once at the bottom of the wheel panel.
    function buildQuickSubscriptionPromo(creativeSlot){
      var canShow = !(TW.access && TW.access.canSeeInternalAds) || TW.access.canSeeInternalAds();
      creativeSlot = creativeSlot || 'wheel_panel_vortex_pro';
      var url = 'https://spinthewheellab.com/pages/vortexpro';
      var promo = U.el('section', { class:'tw-quickSubscriptionPromo tw-subscriptionChoicePanel tw-bottomVortexPromo' + (canShow ? '' : ' tw-quickStickerPromoHidden') });
      if(!canShow){ promo.hidden = true; return promo; }

      var ads = [
        {
          key:'vortexPro',
          name:'Vortex Pro',
          banner:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexproadbanner.png?v=1789230453',
          title:'Unlock the complete Lab',
          text:'Create, customize, generate, save, and organize with every premium tool and collection.',
          price:'$9.99 USD / month',
          features:['All stickers, textures + centers','Vortex AI wheel generation','Creator Lab spin effects','Save + organize dashboards'],
          cta:'Get Vortex Pro'
        }
      ];

      promo.appendChild(U.el('div', { class:'tw-subscriptionChoiceHead' }, [
        U.el('div', { class:'tw-subscriptionChoiceKicker', text:'VORTEX PRO' }),
        U.el('div', { class:'tw-subscriptionChoiceTitle', text:'Everything in the Lab. One membership.' })
      ]));

      var grid = U.el('div', { class:'tw-subscriptionChoiceGrid' });
      ads.forEach(function(ad){
        var button = U.el('button', { class:'tw-subscriptionChoiceBtn', type:'button' }, [ad.cta]);
        function selectSubscription(){
          TW.track && TW.track('select_promotion', {
            promotion_id:'wheel_subscriptions', promotion_name:'Vortex Pro', creative_slot:creativeSlot,
            items:[{ item_id:String(ad.key || ''), item_name:String(ad.name || '') }]
          });
          window.location.href = url;
        }
        button.onclick = selectSubscription;
        var bannerImg = U.el('img', { src:ad.banner, alt:ad.name + ' subscription upgrade', loading:'lazy', decoding:'async', role:'link', tabindex:'0' });
        bannerImg.style.cursor = 'pointer';
        bannerImg.onclick = selectSubscription;
        bannerImg.onkeydown = function(ev){ if(ev.key === 'Enter' || ev.key === ' '){ ev.preventDefault(); selectSubscription(); } };
        grid.appendChild(U.el('article', { class:'tw-subscriptionChoiceCard is' + ad.key }, [
          U.el('div', { class:'tw-subscriptionChoiceMedia' }, [bannerImg]),
          U.el('div', { class:'tw-subscriptionChoiceCopy' }, [
            U.el('div', { class:'tw-subscriptionChoicePlan', text:ad.name }),
            U.el('div', { class:'tw-subscriptionChoicePrice', text:ad.price }),
            U.el('div', { class:'tw-subscriptionChoiceCardTitle', text:ad.title }),
            U.el('div', { class:'tw-subscriptionChoiceText', text:ad.text }),
            U.el('div', { class:'tw-adFeaturePills' }, ad.features.map(function(feature){ return U.el('span', { text:feature }); })),
            button
          ])
        ]));
      });
      promo.appendChild(grid);

      TW.analytics && TW.analytics.observePromotion && TW.analytics.observePromotion(promo, {
        promotion_id:'wheel_subscriptions', promotion_name:'Vortex Pro', creative_slot:creativeSlot
      });
      return promo;
    }
    r.subscriptionDrops = buildQuickSubscriptionPromo('wheel_panel_vortex_pro');
    r.subscriptionDrops.id = 'twSubscriptionDrops';
    r.subscriptionDrops.classList.add('tw-lowerQuickClone', 'tw-lowerQuickClonePlans');

    r.optBody = U.el('div', { class:'tw-accordBody' }, [
      U.el('div', { class:'tw-row' }, [
        U.el('div', { class:'tw-field' }, [
          U.el('label', { text:'Add one' }),
          U.el('div', { style:'display:flex; gap:10px; align-items:center;' }, [ r.optAddOne, r.btnAddOneSeg ]),
        ]),
        U.el('div', { class:'tw-field' }, [
          U.el('label', { text:'Paste names' }),
          r.optBulk
        ])
      ]),
      r.optToolbar,
      U.el('div', { class:'tw-divider' }),
      r.segList,
      r.quickStickerPromo,
      r.quickAllPacksPromo,
      U.el('div', { class:'tw-privacyNote tw-localPrivacyNote' }, [
        U.el('span', { class:'tw-privacyNoteBadge', text:'Privacy note' }),
        U.el('span', { class:'tw-privacyNoteText', text:'Wheel segments, settings, dashboard saves, sound/voice choices, and temporary spin state may be stored only in this browser and device. Clearing browser data, using private browsing, changing devices or browsers, storage limits, updates, or device failure may remove them. Spin the Wheel Lab is not a backup service, so keep an independent copy of anything important. Do not enter confidential, financial, medical, student, child, government ID, or other sensitive personal information.' })
      ])
    ]);

    r.optDetails.appendChild(r.optSummary);
    r.optDetails.appendChild(r.optBody);
    TW.markCustomizationEngaged = function(source){
      TW._rt = TW._rt || {};
      if(TW._rt.customizationEngaged) return;
      TW._rt.customizationEngaged = true;
      try{ sessionStorage.setItem('twQuickTweaksVisited','1'); }catch(_){ }
      if(r.btnStartEditing) r.btnStartEditing.classList.remove('tw-activationFirstResult','tw-activationSecondSpin');
      try{ TW.track && TW.track('quick_tweaks_engaged', { source:source || 'quick_tweaks' }); }catch(_){ }
    };
    r.optDetails.addEventListener('toggle', function(){
      if(r.optDetails.open) TW.markCustomizationEngaged('quick_tweaks_open');
    });
    r.btnStartEditing.addEventListener('click', function(){
      TW.markCustomizationEngaged('wheel_card');
      r.optDetails.open = true;
      try{ TW.track && TW.track('quick_tweaks_activation_click', { source:'wheel_card' }); }catch(_){}
      window.setTimeout(function(){
        try{ r.optDetails.scrollIntoView({ behavior:'smooth', block:'start' }); }catch(_){ }
      }, 30);
    });

    // Vortex AI (collapsed by default)
    r.aiDetails = U.el('details', { class:'tw-accord', id:'twVortexAI' });
    r.aiDetails.removeAttribute('open');

    r.aiSummary = buildPanelSummary('Inventor Lab', 'Generate, remix, and refine wheel ideas with Vortex AI.', 'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/inventorlabpanelicon.png?v=1789304499', true);

    // Controls
    r.aiTopic = U.el('textarea', { class:'tw-textarea tw-aiTopic', rows:'5', maxlength:'300', placeholder:'Example: fun skateboard tricks' });
    r.btnAIClearTopic = U.el('button', { class:'tw-btn tw-btnDanger tw-bizTinyBtn', type:'button' }, ['Clear']);
    r.aiPromptCount = U.el('span', { class:'tw-mini tw-aiPromptCount', text:'0 / 300' });

    // Segment count presets + custom
    r.aiCountWrap = U.el('div', { class:'tw-pillRow' });
    r.aiCountCustomLink = U.el('span', { class:'tw-aiTinyLink', text:'Custom…' });
    r.aiCountCustom = U.el('input', { class:'tw-input', type:'number', min:'2', max:'12', value:'6', style:'display:none;' });

    // Mode / personality pills
    r.aiModeWrap = U.el('div', { class:'tw-pillRow tw-aiLaneGrid' });
    r.aiToneWrap = U.el('div', { class:'tw-pillRow tw-aiLaneGrid' });
    r.aiColorMode = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'follow', text:'Follow This Wheel' }),
      U.el('option', { value:'curate', text:'Curate to Mood' })
    ]);
    r.aiStickerMode = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'off', text:'No Stickers' }),
      U.el('option', { value:'apply', text:'Smart Apply Stickers' }),
      U.el('option', { value:'suggest', text:'Suggest Only (Do Not Apply)' })
    ]);
    r.aiApplyPlan = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'replace', text:'Replace the current wheel' }),
      U.el('option', { value:'add', text:'Add to the current wheel' })
    ]);
    r.aiRevealMode = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'standard', text:'Show result normally' }),
      U.el('option', { value:'reveal', text:'Hide answer until Reveal' })
    ]);
    r.aiPrizeExperience = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'standard', text:'Standard Wheel' }),
      U.el('option', { value:'giveaway', text:'Giveaway' }),
      U.el('option', { value:'competition', text:'Competition' }),
      U.el('option', { value:'classroom', text:'Classroom Rewards' }),
      U.el('option', { value:'custom', text:'Custom Prize Set' })
    ]);
    r.aiAudience = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'mixed', text:'Mixed audience' }),
      U.el('option', { value:'young_children', text:'Young children' }),
      U.el('option', { value:'elementary', text:'Elementary' }),
      U.el('option', { value:'teens', text:'Teens' }),
      U.el('option', { value:'adults', text:'Adults' })
    ]);
    r.aiReadingLevel = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'standard', text:'Standard' }),
      U.el('option', { value:'simple', text:'Simple' }),
      U.el('option', { value:'advanced', text:'Advanced' })
    ]);
    r.aiLaneDescription = U.el('div', { class:'tw-aiLaneDescription', role:'dialog', 'aria-modal':'false', hidden:'' });

    // Actions
    r.btnAIGenerate = U.el('button', { class:'tw-btn tw-btnPrimary', type:'button' }, ['Generate']);
    r.btnAISurprise = U.el('button', { class:'tw-btn tw-btnSurprise', type:'button' }, ['Surprise Me']);
    r.btnAIRefine = U.el('button', { class:'tw-btn tw-btnRefine', type:'button', title:'Get a different take using the same topic and vibe.' }, ['Remix']);
    r.btnAIMakeShorter = U.el('button', { class:'tw-btn', type:'button', title:'Rewrite the current list into clearer, plainer, everyday language without changing the core ideas.' }, ['Simplify Current']);
    r.btnAIMakeHarder  = U.el('button', { class:'tw-btn', type:'button', title:'Rewrite the current list into richer, more polished, more expressive language without changing the core ideas.' }, ['Elevate Current']);
    r.aiQuickActions = U.el('div', { class:'tw-field tw-aiFieldStack tw-aiQuickActions' }, [
      U.el('label', { text:'Create your wheel' }),
      U.el('div', { class:'tw-toolbar tw-aiPrimaryActionRow' }, [r.btnAIGenerate, r.btnAISurprise])
    ]);
    r.aiAdvancedBody = U.el('div', { class:'tw-aiAdvancedBody' });
    r.aiAdvancedDetails = U.el('details', { class:'tw-aiAdvancedDetails' }, [
      U.el('summary', { text:'Customize generation' }),
      r.aiAdvancedBody
    ]);

    // Optional feedback
    r.btnAIReport = U.el('button', { class:'tw-btn tw-btnReport', type:'button', title:'Report an Inventor Lab issue (optional). Sends a report to the SpinTheWheelLab team.' }, ['Report AI Issue']);

    // Output preview + apply
    r.aiOut = U.el('textarea', { class:'tw-textarea tw-aiOut', placeholder:'Your generated segments will appear here…', spellcheck:'false' });
    r.aiReview = U.el('div', { class:'tw-aiReview' });
    r.aiSuccess = U.el('div', { class:'tw-aiSuccess', hidden:'' });
    r.aiReviewDetails = U.el('details', { class:'tw-aiReviewDetails' });
    r.aiOut.hidden = true;
    r.btnAIApplyReplace = U.el('button', { class:'tw-btn tw-btnPrimary', type:'button' }, ['Replace Wheel']);
    r.btnAIApplyAdd     = U.el('button', { class:'tw-btn', type:'button' }, ['Add To Wheel']);

    r.aiLockNotice = U.el('div', { class:'tw-aiLockNotice tw-aiPremiumNotice', hidden:'' }, [
      U.el('div', { class:'tw-aiLockBadge' }, [
        U.el('img', { src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexproglassesicon.png?v=1789304505', alt:'Vortex Pro' })
      ]),
      U.el('div', { class:'tw-aiLockCopy' }, [
        U.el('div', { class:'tw-aiLockKicker', text:'Inventor Lab Preview' }),
        U.el('div', { class:'tw-aiLockText', text:'Turn a prompt into a ready-to-spin wheel with Vortex AI.' }),
        U.el('div', { class:'tw-previewFeaturePills' }, [
          U.el('span', { class:'tw-previewFeatureText', text:'Generate ideas' }),
          U.el('span', { class:'tw-previewFeatureText', text:'Smart remixes' }),
          U.el('span', { class:'tw-previewFeatureText', text:'Save faster' })
        ])
      ]),
      U.el('button', { class:'tw-btn tw-btnPrimary tw-aiPreviewCta', type:'button' }, ['Unlock Inventor Lab'])
    ]);
    function openVortexAIPreviewUpsell(){
      TW.openPlanUpsell && TW.openPlanUpsell('vortex_pro', {
        title:'🧠 Inventor Lab is ready…',
        message:'Unlock instant wheel creation with Vortex Pro. Create games, lessons, or content in seconds.',
        subtext:'AI wheel creation • smart remixes • faster setup',
        previewHtml:'<div class="tw-blurLine">SKATE GAME</div><div class="tw-blurLine">ALIEN QUIZ</div>',
        href:'https://spinthewheellab.com/pages/vortexpro'
      });
    }
    r.aiLockNotice.addEventListener('click', openVortexAIPreviewUpsell);
    r.aiMsg = U.el('div', { class:'tw-aiMsg' });
    r.aiUpsellBtn = U.el('button', { class:'tw-btn tw-aiUpsellBtn', type:'button' }, ['Unlock Vortex Pro']);
    r.aiUpsellBtn.addEventListener('click', function(){
      TW.openPlanUpsell && TW.openPlanUpsell('vortex_pro', {
        title:'🧠 Inventor Lab is ready…',
        message:'Unlock instant wheel creation with Vortex Pro. Create games, lessons, or content in seconds.',
        subtext:'AI wheel creation • smart remixes • faster setup',
        previewHtml:'<div class="tw-blurLine">SKATE GAME</div><div class="tw-blurLine">ALIEN QUIZ</div>',
        href:'https://spinthewheellab.com/pages/vortexpro'
      });
    });
    r.aiErr = U.el('div', { class:'tw-aiErr' });
    r.aiThinking = U.el('div', { class:'tw-aiThinking', hidden:'' }, [
      U.el('img', { class:'tw-aiThinkingIcon', alt:'Inventor Lab is thinking', src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexaithinkingicon_a4368144-376e-4624-a551-74400b8bbd60.png?v=1774379917' }),
      U.el('span', { class:'tw-aiThinkingText', text:'Vortex Is Thinking…' })
    ]);

    // Report modal (privacy-friendly: user must click Send)
    // 2026 AI Issue Report upgrade: warmer Lab Note styling + deeper AI request context.
    (function(){
      var css = [
        '.tw-reportOverlay{position:fixed;inset:0;z-index:999999;display:none;align-items:center;justify-content:center;background:rgba(32,9,52,.72);padding:18px;overflow:auto;scrollbar-width:none;-ms-overflow-style:none;}',
        '.tw-reportOverlay::-webkit-scrollbar,.tw-reportCard::-webkit-scrollbar,.tw-reportBody .tw-textarea::-webkit-scrollbar{width:0!important;height:0!important;display:none!important;}',
        '.tw-reportCard{position:relative;width:min(850px,100%);max-height:min(92vh,920px);overflow:auto;scrollbar-width:none;-ms-overflow-style:none;border-radius:28px;background:linear-gradient(180deg,rgba(255,255,255,.90),rgba(255,255,255,.74)),#FFF8EE;border:1px solid rgba(44,10,113,.12);box-shadow:0 28px 80px rgba(32,9,52,.30),inset 0 1px 0 rgba(255,255,255,.75);font-family:Fredoka,system-ui,sans-serif;color:#401268;}',
        '.tw-reportCard.is-sending .tw-reportRepairman{animation:none!important;}',
        '.tw-reportRepairman{position:absolute;left:50%;top:16px;width:clamp(68px,6.2vw,86px);height:auto;z-index:3;pointer-events:none;filter:drop-shadow(0 14px 18px rgba(32,9,52,.18));transform:translateX(-50%) rotate(2deg);transform-origin:50% 85%;animation:none!important;}',
        '@keyframes twReportRepairmanBob{0%,100%{transform:translateX(-50%) translateY(0) rotate(2deg);}50%{transform:translateX(-50%) translateY(-5px) rotate(-2deg);}}',
        '@keyframes twReportRepairmanWork{0%,100%{transform:translateX(-50%) translateY(0) rotate(3deg);}50%{transform:translateX(-50%) translateY(-2px) rotate(-4deg);}}',
        '.tw-reportHead{display:block;position:static;padding:96px 28px 18px;border-bottom:1px solid rgba(44,10,113,.08);background:radial-gradient(circle at top,rgba(204,0,126,.08),transparent 38%);}',
        '.tw-reportEyebrow{margin:0 0 8px;font-size:13px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#cc007e;}',
        '.tw-reportTitle{margin:0 0 8px;font-size:clamp(28px,3.5vw,42px);line-height:1.02;font-weight:800;color:#2c0a71;}',
        '.tw-reportIntro{margin:0;max-width:660px;font-size:16px;line-height:1.55;color:#401268;}',
        '.tw-reportClose{position:absolute;top:18px;right:18px;appearance:none;border:0;background:#cc007e;color:#FFF8EE;font-size:24px;line-height:1;cursor:pointer;width:46px;height:46px;border-radius:999px;box-shadow:0 14px 28px rgba(204,0,126,.18);z-index:10;display:inline-flex;align-items:center;justify-content:center;}',
        '.tw-reportClose:hover{transform:translateY(-1px);}',
        '.tw-reportBody{padding:20px 28px 8px;}',
        '.tw-reportGrid{display:grid;grid-template-columns:1fr 1fr;gap:14px;}',
        '.tw-reportBody .tw-field{margin:0;}',
        '.tw-reportBody .tw-field--mainIssue{padding-top:7px;}',
        '.tw-reportBody .tw-field>label{display:block!important;margin:0 0 7px!important;font-size:13px!important;font-weight:800!important;letter-spacing:.05em!important;text-transform:uppercase!important;color:#2c0a71!important;background:transparent!important;text-shadow:none!important;}',
        '.tw-reportBody .tw-input,.tw-reportBody .tw-textarea,.tw-reportBody select{width:100%;box-sizing:border-box;border-radius:18px;border:1px solid rgba(44,10,113,.12);background:#fff!important;color:#401268!important;-webkit-text-fill-color:#401268!important;font-family:Fredoka,system-ui,sans-serif;font-size:15px;line-height:1.4;padding:14px 15px;outline:none;transition:border-color .18s ease,box-shadow .18s ease;}',
        '.tw-reportBody .tw-textarea{overflow-y:auto!important;-webkit-overflow-scrolling:touch;}',
        '.tw-reportBody .tw-input::placeholder,.tw-reportBody .tw-textarea::placeholder{color:rgba(64,18,104,.72)!important;opacity:1!important;}',
        '.tw-reportBody select{appearance:none!important;-webkit-appearance:none!important;-moz-appearance:none!important;padding-right:42px!important;background-color:#fff!important;background-image:linear-gradient(45deg,transparent 50%,#401268 50%),linear-gradient(135deg,#401268 50%,transparent 50%)!important;background-position:calc(100% - 24px) calc(50% - 2px),calc(100% - 18px) calc(50% - 2px)!important;background-size:6px 6px,6px 6px!important;background-repeat:no-repeat!important;}',
        '.tw-reportBody .tw-input:focus,.tw-reportBody .tw-textarea:focus,.tw-reportBody select:focus{border-color:rgba(204,0,126,.35);box-shadow:0 0 0 4px rgba(204,0,126,.10);}',
        '.tw-reportBody .tw-textarea{min-height:104px;max-height:240px;resize:vertical;overflow:auto!important;scrollbar-width:none;-ms-overflow-style:none;}',
        '.tw-reportBody .tw-reportResult{min-height:118px;max-height:260px;overflow:auto!important;font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:13px;}',
        '.tw-reportBody .tw-reportTiny{margin:7px 0 0;font-size:12px;line-height:1.45;color:rgba(64,18,104,.72);}',
        '.tw-reportNotice{margin:14px 0 0;padding:14px 15px;border-radius:16px;background:#fff4fa;border:1px solid rgba(204,0,126,.16);font-size:13px;line-height:1.5;color:#401268;}',
        '.tw-reportNotice strong{color:#2c0a71;}',
        '.tw-reportConsent{display:flex!important;align-items:flex-start;gap:10px;margin:14px 0 0!important;padding:14px 15px;border-radius:16px;background:#fff;border:1px solid rgba(44,10,113,.12);font-size:13px!important;line-height:1.5!important;font-weight:600!important;letter-spacing:0!important;text-transform:none!important;color:#401268!important;}',
        '.tw-reportConsent input{width:18px;height:18px;flex:0 0 auto;margin:1px 0 0;accent-color:#cc007e;}',
        '.tw-reportConsent a{color:#2c0a71;font-weight:800;text-decoration:underline;}',
        '.tw-reportBody .tw-reportHiddenContext{display:none!important;}',
        '.tw-reportBody .tw-reportContextGrid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px;margin-top:14px;}',
        '.tw-reportBody .tw-reportMiniCard{border-radius:16px;background:rgba(255,255,255,.72);border:1px solid rgba(44,10,113,.08);padding:11px 12px;min-width:0;}',
        '.tw-reportBody .tw-reportMiniLabel{margin:0 0 4px;font-size:11px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:#cc007e;}',
        '.tw-reportBody .tw-reportMiniValue{margin:0;font-size:13px;line-height:1.35;color:#401268;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
        '.tw-reportBody .tw-reportReadonly{background:rgba(255,255,255,.96)!important;color:#401268!important;-webkit-text-fill-color:#401268!important;opacity:1!important;}',
        '.tw-reportFoot{display:flex;gap:12px;justify-content:flex-end;align-items:center;padding:16px 28px 26px;}.tw-reportFoot .tw-btn:not(.tw-btnPrimary){background:#ffffff!important;color:#2c0a71!important;-webkit-text-fill-color:#2c0a71!important;border:1px solid rgba(44,10,113,.16)!important;box-shadow:0 8px 18px rgba(44,10,113,.08)!important;}',
        '.tw-reportStatus{margin-right:auto;font-size:14px;line-height:1.4;color:#401268;font-weight:700;}',
        '.tw-btnReport{border:1px solid rgba(255,255,255,.22)!important;color:var(--tw-black-95,#12091c)!important;background:linear-gradient(180deg,var(--tw-accent,#f6c95c) 0%,var(--tw-accent2,#f28c8c) 100%)!important;text-shadow:0 1px 0 rgba(255,255,255,.22)!important;}',
        '.tw-btnReport:hover{filter:brightness(1.03)!important;}',
        '.tw-reportFoot .tw-btnPrimary{background:#cc007e!important;color:#FFF8EE!important;box-shadow:0 14px 28px rgba(204,0,126,.18)!important;}',
        '@media(max-width:749px){.tw-reportOverlay{align-items:flex-start;padding:12px;}.tw-reportCard{border-radius:22px;max-height:calc(100vh - 24px);}.tw-reportRepairman{position:static;display:block;width:44px;margin:18px auto 8px;transform:none!important;animation:none!important;}.tw-reportHead{display:block;position:static;padding:8px 20px 18px;text-align:center;}.tw-reportClose{position:absolute;top:12px;right:12px;width:40px;height:40px;}.tw-reportEyebrow{font-size:12px;letter-spacing:.12em;margin-top:0;}.tw-reportTitle{font-size:clamp(24px,7vw,32px);}.tw-reportIntro{font-size:15px;line-height:1.48;margin-left:auto;margin-right:auto;}.tw-reportBody{padding:18px 20px 6px;}.tw-reportGrid{grid-template-columns:1fr;}.tw-reportBody .tw-reportContextGrid{grid-template-columns:1fr 1fr;gap:9px;}.tw-reportBody .tw-textarea{max-height:220px;overflow-y:auto!important;-webkit-overflow-scrolling:touch;}.tw-reportFoot{padding:14px 20px 22px;align-items:stretch;flex-direction:column;}.tw-reportStatus{margin-right:0;text-align:center;}.tw-reportFoot .tw-btn{width:100%;justify-content:center;}}',
        '@media(prefers-reduced-motion:reduce){.tw-reportRepairman,.tw-reportCard.is-sending .tw-reportRepairman{animation:none!important;}}'
      ].join('');
      try{
        var old = document.querySelector('style[data-tw-report="1"]');
        if(old) old.remove();
        var st = document.createElement('style');
        st.setAttribute('data-tw-report','1');
        st.textContent = css;
        document.head.appendChild(st);
      }catch(e){}

      r.reportOverlay = U.el('div', { class:'tw-reportOverlay', role:'dialog', 'aria-modal':'true', 'aria-label':'Report an AI issue' });
      r.reportCard = U.el('div', { class:'tw-reportCard' });
      r.reportRepairman = U.el('img', { class:'tw-reportRepairman', src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexrepairman.png?v=1777572295', alt:'Professor Vortex repairman', loading:'lazy' });
      r.reportHead = U.el('div', { class:'tw-reportHead' }, [
        U.el('div', { class:'tw-reportHeadCopy' }, [
          U.el('p', { class:'tw-reportEyebrow', text:'SPIN THE WHEEL LAB' }),
          U.el('h3', { class:'tw-reportTitle', text:'Report an AI Issue' }),
          U.el('p', { class:'tw-reportIntro', text:'Something strange in the machine? Tell Professor Vortex what happened. The latest request ID and limited diagnostic details will be attached automatically.' })
        ]),
        (r.reportClose = U.el('button', { class:'tw-reportClose', type:'button', text:'×', title:'Close report form', 'aria-label':'Close report form' }))
      ]);

      r.reportType = U.el('select', { class:'tw-input' }, [
        U.el('option', { value:'Vortex AI Issue', text:'Vortex AI Issue' }),
        U.el('option', { value:'Inaccurate result', text:'Inaccurate result' }),
        U.el('option', { value:'Wrong topic', text:'Wrong topic' }),
        U.el('option', { value:'Formatting problem', text:'Formatting problem' }),
        U.el('option', { value:'Repeated or weak results', text:'Repeated or weak results' }),
        U.el('option', { value:'Unsafe or strange output', text:'Unsafe or strange output' }),
        U.el('option', { value:'AI did not respond', text:'AI did not respond' }),
        U.el('option', { value:'Other', text:'Other' })
      ]);
      r.reportMessage = U.el('textarea', { class:'tw-textarea', placeholder:'Tell the Lab what went wrong. What did you expect instead?', spellcheck:'true' });
      r.reportConsent = U.el('input', { type:'checkbox' });
      r.reportOut = U.el('textarea', { class:'tw-textarea tw-reportResult tw-reportReadonly', readonly:'true', spellcheck:'false', placeholder:'The latest AI preview will appear here automatically when available.' });

      r.reportPageUrl = U.el('input', { class:'tw-input tw-reportReadonly', type:'text', readonly:'true' });
      r.reportWheelName = U.el('input', { class:'tw-input tw-reportReadonly', type:'text', readonly:'true' });
      r.reportTopic = U.el('input', { class:'tw-input tw-reportReadonly', type:'text', readonly:'true' });
      r.reportAction = U.el('input', { class:'tw-input tw-reportReadonly', type:'text', readonly:'true' });
      r.reportLane = U.el('input', { class:'tw-input tw-reportReadonly', type:'text', readonly:'true' });
      r.reportCount = U.el('input', { class:'tw-input tw-reportReadonly', type:'text', readonly:'true' });
      r.reportCurrent = U.el('textarea', { class:'tw-textarea tw-reportReadonly', readonly:'true', spellcheck:'false' });
      r.reportPrompt = U.el('textarea', { class:'tw-textarea tw-reportReadonly', readonly:'true', spellcheck:'false' });
      r.reportMiniWheel = U.el('p', { class:'tw-reportMiniValue', text:'Captured when available' });
      r.reportMiniAction = U.el('p', { class:'tw-reportMiniValue', text:'Captured when available' });
      r.reportMiniTopic = U.el('p', { class:'tw-reportMiniValue', text:'Captured when available' });
      r.reportMiniLane = U.el('p', { class:'tw-reportMiniValue', text:'Captured when available' });
      r.reportMiniCount = U.el('p', { class:'tw-reportMiniValue', text:'Captured when available' });
      r.reportMiniPage = U.el('p', { class:'tw-reportMiniValue', text:'This page' });

      r.reportStatus = U.el('div', { class:'tw-reportStatus' });
      r.btnReportSend = U.el('button', { class:'tw-btn tw-btnPrimary', type:'button' }, ['Send to the Lab']);
      r.btnReportCancel = U.el('button', { class:'tw-btn', type:'button' }, ['Cancel']);

      r.reportBody = U.el('div', { class:'tw-reportBody' }, [
        U.el('div', { class:'tw-reportGrid' }, [
          U.el('div', { class:'tw-field' }, [ U.el('label',{text:'What kind of issue?'}), r.reportType ])
        ]),
        U.el('div', { style:'height:14px;' }),
        U.el('div', { class:'tw-field tw-field--mainIssue' }, [ U.el('label',{text:'What should we fix?'}), r.reportMessage, U.el('p',{class:'tw-reportTiny',text:'Example: The wheel gave off-topic answers, repeated the same ideas, or ignored my request.'}) ]),
        U.el('div', { class:'tw-reportNotice' }, [
          U.el('strong', { text:'Please do not include sensitive information. ' }),
          document.createTextNode('Do not send passwords, payment card details, government IDs, medical information, or private information about another person. The report includes your latest Vortex request ID, the displayed AI result, wheel name, topic, action, page path, and basic device details.')
        ]),
        U.el('label', { class:'tw-reportConsent' }, [
          r.reportConsent,
          U.el('span', {}, [
            document.createTextNode('I have reviewed the '),
            U.el('a', { href:'https://spinthewheellab.com/pages/legal-lab', target:'_blank', rel:'noopener noreferrer', text:'Legal Lab' }),
            document.createTextNode(', consent to sending this report and its listed diagnostic details, and confirm that I have not included sensitive information.')
          ])
        ]),
        U.el('div', { class:'tw-reportContextGrid' }, [
          U.el('div', { class:'tw-reportMiniCard' }, [ U.el('p',{class:'tw-reportMiniLabel',text:'Wheel'}), r.reportMiniWheel ]),
          U.el('div', { class:'tw-reportMiniCard' }, [ U.el('p',{class:'tw-reportMiniLabel',text:'Action'}), r.reportMiniAction ]),
          U.el('div', { class:'tw-reportMiniCard' }, [ U.el('p',{class:'tw-reportMiniLabel',text:'Topic'}), r.reportMiniTopic ]),
          U.el('div', { class:'tw-reportMiniCard' }, [ U.el('p',{class:'tw-reportMiniLabel',text:'Lane'}), r.reportMiniLane ]),
          U.el('div', { class:'tw-reportMiniCard' }, [ U.el('p',{class:'tw-reportMiniLabel',text:'Segments'}), r.reportMiniCount ]),
          U.el('div', { class:'tw-reportMiniCard' }, [ U.el('p',{class:'tw-reportMiniLabel',text:'Page'}), r.reportMiniPage ])
        ]),
        U.el('div', { style:'height:14px;' }),
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'AI result included with this report'}), r.reportOut, U.el('p',{class:'tw-reportTiny',text:'Review this captured result before sending. Your full prompt, current wheel list, email, customer tags, and access snapshot are not included.'}) ]),
        U.el('details', { class:'tw-reportHiddenContext', open:'' }, [
          U.el('summary', { text:'Captured lab clues' }),
          U.el('div', { class:'tw-reportContextGrid' }, [
            U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Wheel'}), r.reportWheelName ]),
            U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Action'}), r.reportAction ]),
            U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Topic'}), r.reportTopic ]),
            U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Lane'}), r.reportLane ]),
            U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Segment count'}), r.reportCount ]),
            U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Page'}), r.reportPageUrl ])
          ]),
          U.el('div', { style:'height:10px;' }),
          U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Current list before transform'}), r.reportCurrent ]),
          U.el('div', { style:'height:10px;' }),
          U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Prompt sent to AI'}), r.reportPrompt ])
        ])
      ]);

      r.reportFoot = U.el('div', { class:'tw-reportFoot' }, [
        r.reportStatus,
        r.btnReportCancel,
        r.btnReportSend
      ]);

      r.reportCard.appendChild(r.reportRepairman);
      r.reportCard.appendChild(r.reportHead);
      r.reportCard.appendChild(r.reportBody);
      r.reportCard.appendChild(r.reportFoot);
      r.reportOverlay.appendChild(r.reportCard);
      document.body.appendChild(r.reportOverlay);

      function aiTitleCaseWords(v){
        return String(v || '').replace(/\b([a-z])/g, function(m, ch){ return ch.toUpperCase(); });
      }

      function mapAIActionLabel(action){
        var raw = String(action || '').trim().toLowerCase();
        if(raw === 'generate') return 'Generate / New Request';
        if(raw === 'refine' || raw === 'remix') return 'Remix';
        if(raw === 'shorter' || raw === 'simplify') return 'Simplify Current';
        if(raw === 'harder' || raw === 'elevate') return 'Elevate Current';
        return aiTitleCaseWords(action || 'Generate');
      }

      function getViewportInfo(){
        try{
          return String(window.innerWidth || '') + 'x' + String(window.innerHeight || '') + ' @' + String(window.devicePixelRatio || 1) + 'x';
        }catch(_){ return ''; }
      }

      function getAccessSnapshot(){
        try{
          return {
            requiredPlan: window.TOKI_WHEEL_REQUIRED_PLAN || '',
            customerTags: window.TOKI_WHEEL_CUSTOMER_TAGS || [],
            access: window.TOKI_WHEEL_ACCESS || window.__TW_ACCESS || {}
          };
        }catch(_){ return {}; }
      }


      function getVortexCustomerIdentityForReport(){
        var out = { customerId:'', customerEmail:'' };
        try{
          var access = window.TOKI_WHEEL_ACCESS || window.__TW_ACCESS || {};
          var customer = window.TOKI_WHEEL_CUSTOMER || window.__TW_CUSTOMER || {};

          out.customerId = String(
            window.TOKI_WHEEL_CUSTOMER_ID ||
            window.__TW_CUSTOMER_ID ||
            access.customerId ||
            access.customer_id ||
            access.shopifyCustomerId ||
            customer.id ||
            customer.customerId ||
            ''
          ).trim();

          out.customerEmail = String(
            window.TOKI_WHEEL_CUSTOMER_EMAIL ||
            window.__TW_CUSTOMER_EMAIL ||
            access.customerEmail ||
            access.customer_email ||
            access.email ||
            customer.email ||
            customer.customerEmail ||
            ''
          ).trim().toLowerCase();

          if(!out.customerId && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page){
            out.customerId = String(window.ShopifyAnalytics.meta.page.customerId || '').trim();
          }
        }catch(_){ }
        return out;
      }

      function twReportAutoGrow(el){
        if(!el) return;
        try{
          el.style.height = 'auto';
          el.style.height = Math.max(el.scrollHeight, 104) + 'px';
        }catch(_){}
      }

      function pageUrlValueForMini(){
        try{ return location.hostname + location.pathname; }catch(_){ return 'Current page'; }
      }

      function openReport(){
        var laneTypeLabel = (String(r.aiLastLaneType || selectedLaneType || 'mode') === 'mode') ? 'Mode' : 'Personality';
        var laneName = String(r.aiLastLaneLabel || r.aiLastLane || selectedLane || 'Direct Mode').trim();
        var actionValue = mapAIActionLabel(r.aiLastAction || 'generate');
        var countValue = Number(r.aiLastCount || (r.aiCountCustom && r.aiCountCustom.value) || selectedCount || 0) || '';

        r.reportType.value = 'Vortex AI Issue';
        r.reportConsent.checked = false;
        r.reportMessage.value = '';
        r.reportPageUrl.value = location.href;
        r.reportWheelName.value = (TW.state && TW.state.ui && TW.state.ui.title) ? TW.state.ui.title : (document.title || '');
        r.reportTopic.value = String(r.aiLastTopic || (r.aiTopic && r.aiTopic.value) || '').trim();
        r.reportAction.value = actionValue;
        r.reportLane.value = laneTypeLabel + ': ' + laneName;
        r.reportCount.value = countValue;
        r.reportOut.value = String(r.aiLastOutputAfter || r.aiLastOutput || (r.aiOut && r.aiOut.value) || '').trim();
        r.reportCurrent.value = String(r.aiLastCurrentText || '').trim();
        r.reportPrompt.value = String(r.aiLastPrompt || '').trim();
        if(r.reportMiniWheel) r.reportMiniWheel.textContent = r.reportWheelName.value || 'Captured when available';
        if(r.reportMiniAction) r.reportMiniAction.textContent = r.reportAction.value || 'Captured when available';
        if(r.reportMiniTopic) r.reportMiniTopic.textContent = r.reportTopic.value || 'No topic captured';
        if(r.reportMiniLane) r.reportMiniLane.textContent = r.reportLane.value || 'Captured when available';
        if(r.reportMiniCount) r.reportMiniCount.textContent = String(r.reportCount.value || 'Captured when available');
        if(r.reportMiniPage) r.reportMiniPage.textContent = (location && location.hostname ? location.hostname + location.pathname : pageUrlValueForMini());
        twReportAutoGrow(r.reportMessage);
        if(r.reportOut){ r.reportOut.scrollTop = 0; }
        r.reportStatus.textContent = '';
        r.reportOverlay.style.display='flex';
      }

      function closeReport(){
        r.reportOverlay.style.display='none';
        if(r.btnReportSend) r.btnReportSend.disabled = false;
        if(r.reportCard) r.reportCard.classList.remove('is-sending');
      }

      async function submitReportToAppsScript_(url, payload){
        if(!url) throw new Error('Missing report endpoint.');

        var sessionRes = await fetch('/apps/vortex/session', {
          method:'GET',
          credentials:'same-origin',
          cache:'no-store'
        });
        var sessionData = null;
        try{ sessionData = await sessionRes.json(); }catch(_){}
        if(!sessionRes.ok || !sessionData || !sessionData.token){
          throw new Error((sessionData && sessionData.error) || 'Sign in with Vortex Pro to send a report.');
        }

        var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var timer = controller ? setTimeout(function(){ controller.abort(); }, 15000) : null;
        try{
          var response = await fetch(url, {
            method:'POST',
            headers:{
              'Content-Type':'application/json',
              'Authorization':'Bearer ' + sessionData.token
            },
            body:JSON.stringify(payload || {}),
            signal:controller ? controller.signal : undefined
          });
          var data = null;
          try{ data = await response.json(); }catch(_){}
          if(!response.ok || !data || data.ok === false){
            throw new Error((data && data.error) || ('Report failed with status ' + response.status));
          }
          return data;
        }finally{
          if(timer) clearTimeout(timer);
        }
      }

      function sendReport(){
        var outputValue = String(r.reportOut && r.reportOut.value || '').trim();
        var messageValue = String(r.reportMessage && r.reportMessage.value || '').trim();
        var topicValue = String(r.reportTopic && r.reportTopic.value || '').trim();
        var typeValue = String(r.reportType && r.reportType.value || 'Vortex AI Issue').trim();
        var pageUrlValue = String(r.reportPageUrl && r.reportPageUrl.value || location.href).trim();
        var wheelNameValue = String(r.reportWheelName && r.reportWheelName.value || ((TW.state && TW.state.ui && TW.state.ui.title) ? TW.state.ui.title : (document.title || ''))).trim();
        var actionValue = String(r.reportAction && r.reportAction.value || mapAIActionLabel(r.aiLastAction || 'generate')).trim();
        var laneValue = String(r.reportLane && r.reportLane.value || '').trim();
        var countValue = String(r.reportCount && r.reportCount.value || '').trim();
        var currentValue = String(r.reportCurrent && r.reportCurrent.value || '').trim();
        var promptValue = String(r.reportPrompt && r.reportPrompt.value || '').trim();

        if(!messageValue){
          r.reportStatus.textContent = 'Add a quick note before sending.';
          if(r.reportMessage) r.reportMessage.focus();
          return;
        }
        if(!r.reportConsent || !r.reportConsent.checked){
          r.reportStatus.textContent = 'Please review and check the consent box before sending.';
          if(r.reportConsent) r.reportConsent.focus();
          return;
        }

        r.reportStatus.textContent = 'Repairman Vortex is tightening the bolts...';
        if(r.btnReportSend) r.btnReportSend.disabled = true;
        if(r.reportCard) r.reportCard.classList.add('is-sending');

        try{
          var payload = {
            notes: messageValue,
            issueType: typeValue,
            requestId: String(r.aiLastRequestId || '').trim(),
            consent: true,
            wheel: {
              name: wheelNameValue,
              topic: topicValue,
              action: actionValue,
              lane: laneValue,
              segmentCount: countValue,
              result: outputValue,
              pagePath: (function(){ try{ return location.pathname || '/'; }catch(_){ return '/'; } })(),
              viewport: getViewportInfo(),
              language: navigator.language || ''
            },
            userAgent: navigator.userAgent || ''
          };

          var reportEndpoint = (TW.ai && TW.ai.reportEndpoint) ? TW.ai.reportEndpoint : '';
          if(!reportEndpoint) throw new Error('Missing Vortex AI report endpoint.');

          submitReportToAppsScript_(reportEndpoint, payload).then(function(){
            r.reportStatus.textContent = 'Message sent. Professor Vortex is checking the dials.';
            if(r.btnReportSend) r.btnReportSend.disabled = false;
            if(r.reportCard) r.reportCard.classList.remove('is-sending');
            setTimeout(closeReport, 900);
          }).catch(function(err){
            r.reportStatus.textContent = 'Something jammed in the machine. Please try again. ' + ((err && err.message) ? '(' + err.message + ')' : '');
            if(r.btnReportSend) r.btnReportSend.disabled = false;
            if(r.reportCard) r.reportCard.classList.remove('is-sending');
          });
        }catch(e){
          r.reportStatus.textContent = 'Something jammed in the machine. Please try again. ' + ((e && e.message) ? '(' + e.message + ')' : '');
          if(r.btnReportSend) r.btnReportSend.disabled = false;
          if(r.reportCard) r.reportCard.classList.remove('is-sending');
        }
      }

      r.reportMessage && r.reportMessage.addEventListener('input', function(){ twReportAutoGrow(r.reportMessage); });
      r.btnAIReport && r.btnAIReport.addEventListener('click', openReport);
      r.reportClose && r.reportClose.addEventListener('click', closeReport);
      r.btnReportCancel && r.btnReportCancel.addEventListener('click', closeReport);
      r.btnReportSend && r.btnReportSend.addEventListener('click', sendReport);
      r.reportOverlay && r.reportOverlay.addEventListener('click', function(ev){
        if(ev.target === r.reportOverlay) closeReport();
      });
    })();

    r.aiBody = U.el('div', { class:'tw-accordBody tw-aiBodyStack' }, [
      U.el('div', { class:'tw-accordTitle tw-labSubTitle', text:'Vortex AI' }),
      U.el('div', { class:'tw-aiHero' }, [
        U.el('div', { class:'tw-aiTitle', text:'Professor Vortex\'s personality engine.' }),
        U.el('div', { class:'tw-mini', text:'Type a focused topic, choose one lane, choose up to 12 segments, then generate or transform the current result.' })
      ]),

      U.el('div', { class:'tw-field tw-aiFieldStack' }, [
        U.el('label',{text:'Topic'}),
        r.aiTopic,
        U.el('div', { class:'tw-toolbar tw-aiPromptTools' }, [r.btnAIClearTopic, r.aiPromptCount])
      ]),

      U.el('div', { class:'tw-field tw-aiFieldStack' }, [
        U.el('label',{text:'Choose one lane'}),
        U.el('div', { class:'tw-mini', text:'Modes prioritize accuracy and structure. Personalities add style. Direct Mode is used by default.' }),
        U.el('div', { class:'tw-aiLaneSection' }, [ U.el('div', { class:'tw-mini tw-aiLaneHeading', text:'Modes' }), r.aiModeWrap ]),
        U.el('div', { class:'tw-aiLaneSection' }, [ U.el('div', { class:'tw-mini tw-aiLaneHeading', text:'Personalities' }), r.aiToneWrap ]),
        r.aiLaneDescription
      ]),

      U.el('div', { class:'tw-field tw-aiFieldStack' }, [
        U.el('label',{text:'Segment count'}),
        r.aiCountWrap,
        U.el('div', { class:'tw-aiCountTools' }, [
          r.aiCountCustomLink,
          r.aiCountCustom
        ])
      ]),

      r.aiQuickActions,
      r.aiAdvancedDetails,

      U.el('div', { class:'tw-aiSmartOptions' }, [
        U.el('div', { class:'tw-field tw-aiFieldStack', style:'margin:0;' }, [
          U.el('label',{text:'Wheel colors'}),
          r.aiColorMode,
          U.el('div', { class:'tw-mini', text:'Follow keeps this wheel\'s every-third palette rhythm. Curate chooses only from this page\'s palette.' })
        ]),
        U.el('div', { class:'tw-field tw-aiFieldStack', style:'margin:0;' }, [
          U.el('label',{text:'Sticker help'}),
          r.aiStickerMode,
          U.el('div', { class:'tw-mini', text:'Suggestions use real sticker IDs and respect plan access. Smart Apply places only strong matches.' })
        ])
      ]),

      U.el('div', { class:'tw-aiSmartOptions tw-aiPrizeOptions' }, [
        U.el('div', { class:'tw-field tw-aiFieldStack', style:'margin:0;' }, [
          U.el('label',{text:'Prize experience'}),
          r.aiPrizeExperience,
          U.el('div', { class:'tw-mini', text:'Choose a giveaway, competition, classroom reward, or custom prize treatment. Standard leaves prize framing off.' })
        ])
      ]),

      U.el('div', { class:'tw-aiSmartOptions' }, [
        U.el('div', { class:'tw-field tw-aiFieldStack', style:'margin:0;' }, [
          U.el('label',{text:'Audience'}), r.aiAudience,
          U.el('div', { class:'tw-mini', text:'Adapts examples, clues, descriptions, and winner copy for the people using the wheel.' })
        ]),
        U.el('div', { class:'tw-field tw-aiFieldStack', style:'margin:0;' }, [
          U.el('label',{text:'Reading level'}), r.aiReadingLevel,
          U.el('div', { class:'tw-mini', text:'Simple is plain and short; Advanced allows richer vocabulary and detail.' })
        ])
      ]),

      U.el('div', { class:'tw-aiSmartOptions' }, [
        U.el('div', { class:'tw-field tw-aiFieldStack', style:'margin:0;' }, [
          U.el('label',{text:'Build this result for'}),
          r.aiApplyPlan,
          U.el('div', { class:'tw-mini', text:'Add mode counts the segments already on this wheel before Vortex writes the new labels.' })
        ]),
        U.el('div', { class:'tw-field tw-aiFieldStack', style:'margin:0;' }, [
          U.el('label',{text:'Winner answer'}),
          r.aiRevealMode,
          U.el('div', { class:'tw-mini', text:'Reveal mode shows a clue first, then displays the answer only when the presenter clicks Reveal.' })
        ])
      ]),

      U.el('div', { class:'tw-field tw-aiFieldStack' }, [
        U.el('label',{text:'Transform current result'}),
        U.el('div', { class:'tw-toolbar tw-aiActionRow', style:'flex-wrap:wrap;' }, [
          r.btnAIRefine, r.btnAIMakeShorter, r.btnAIMakeHarder, r.btnAIReport
        ])
      ]),

      U.el('div', { class:'tw-divider' }),
      r.aiOut,
      r.aiSuccess,
      U.el('div', { class:'tw-field tw-aiFieldStack' }, [
        U.el('label',{text:'Presentation View — everything viewers may see'}),
        r.aiReview
      ]),
      U.el('div', { class:'tw-toolbar tw-aiApplyRow', style:'margin-top:10px; flex-wrap:wrap;' }, [ r.btnAIApplyReplace, r.btnAIApplyAdd ]),
      r.aiThinking,
      r.aiMsg,
      r.aiErr,
      U.el('div', { class:'tw-mini tw-aiFootnote', text:'Note: Pick one lane before generating. Modes focus on accuracy and structure. Personalities change style, not topic. Transform actions work on the current list. Wheels save to this device.' }),
      U.el('div', { class:'tw-privacyNote tw-aiPrivacyNote' }, [
        U.el('span', { class:'tw-privacyNoteBadge', text:'AI privacy & accuracy' }),
        U.el('span', { class:'tw-privacyNoteText', text:'Do not enter confidential, financial, medical, student, child, government ID, or other sensitive personal information. AI requests, relevant wheel context, and outputs may be processed by service providers in different countries or regions to provide the feature, prevent abuse, and improve reliability. AI output may be incomplete, inaccurate, biased, or unsuitable, so review it before use and do not rely on it for legal, medical, financial, safety-critical, or other high-stakes decisions.' })
      ]),
      r.aiLockNotice
    ]);

    // Presentation View stays visible so every result can be reviewed and controlled.
    if(r.aiReviewDetails) r.aiReviewDetails.setAttribute('hidden','');
    (function compactAIOptions(){
      if(!r.aiAdvancedBody) return;
      var optionSelects = [r.aiColorMode, r.aiPrizeExperience, r.aiAudience, r.aiApplyPlan];
      var moved = [];
      optionSelects.forEach(function(select){
        var group = select && select.closest ? select.closest('.tw-aiSmartOptions') : null;
        if(group && moved.indexOf(group) === -1){ moved.push(group); r.aiAdvancedBody.appendChild(group); }
      });
      var transformField = r.btnAIRefine && r.btnAIRefine.closest ? r.btnAIRefine.closest('.tw-aiFieldStack') : null;
      var reviewField = r.aiReview && r.aiReview.parentNode;
      if(transformField && reviewField && reviewField.parentNode) reviewField.parentNode.insertBefore(transformField, reviewField);
    })();

    r.aiDetails.appendChild(r.aiSummary);
    r.aiDetails.appendChild(r.aiBody);

    try{
      if(r.aiThinking && document.body && r.aiThinking.parentNode !== document.body){
        document.body.appendChild(r.aiThinking);
      }
    }catch(e){}


    // Spin Biz (Vortex Pro business tools; collapsed by default)
    r.bizDetails = U.el('details', { class:'tw-accord', id:'twSpinBiz' });
    r.bizDetails.removeAttribute('open');

    r.bizSummary = buildPanelSummary('Creator Lab', 'Build branded winner moments, QR actions, and custom celebrations.', 'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/creatorlabpanelicon.png?v=1789304486', true);

    r.bizPopup = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'no', text:'Standard popup (unchanged)' }),
      U.el('option', { value:'yes', text:'Custom winner experience' })
    ]);
    r.bizPopupMedia = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'none', text:'No popup media' }),
      U.el('option', { value:'qr', text:'QR code' }),
      U.el('option', { value:'image', text:'Uploaded image' }),
      U.el('option', { value:'both', text:'Image + QR code' })
    ]);
    r.bizPopupStyle = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'classic', text:'Classic card' }),
      U.el('option', { value:'spotlight', text:'Spotlight' }),
      U.el('option', { value:'prize', text:'Prize card' }),
      U.el('option', { value:'fullscreen', text:'Full screen celebration' })
    ]);
    r.bizPopupEntrance = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'pop', text:'Pop' }),
      U.el('option', { value:'zoom', text:'Zoom reveal' }),
      U.el('option', { value:'drop', text:'Drop in' }),
      U.el('option', { value:'fade', text:'Soft fade' })
    ]);
    r.bizPopupHeadline = U.el('input', { class:'tw-input', type:'text', maxlength:'70', placeholder:'Winner!' });
    r.bizPopupMessage = U.el('input', { class:'tw-input', type:'text', maxlength:'160', placeholder:'Optional message below the winner' });
    r.bizPopupButton = U.el('input', { class:'tw-input', type:'text', maxlength:'40', placeholder:'Claim Prize (leave blank for no button)' });
    r.bizUrl = U.el('input', { class:'tw-input', type:'url', placeholder:'https://yourbusiness.com/claim-prize' });
    r.bizPopupImageFile = U.el('input', { class:'tw-input', type:'file', accept:'image/*' });
    r.bizPopupImageUrl = U.el('input', { class:'tw-input', type:'url', placeholder:'Or paste image URL for winner popup' });
    r.bizRemovePopupImage = U.el('button', { class:'tw-btn tw-btnDanger tw-bizTinyBtn', type:'button' }, ['Remove popup image']);
    r.bizPopupImagePreview = U.el('div', { class:'tw-bizPopupImagePreview' });
    r.bizQrFg = U.el('input', { class:'tw-bizColorSwatch', type:'color', value:'#2c0a71', 'aria-label':'QR foreground color' });
    r.bizQrBg = U.el('input', { class:'tw-bizColorSwatch', type:'color', value:'#ffffff', 'aria-label':'QR background color' });
    r.bizQrFgHex = U.el('input', { class:'tw-input tw-bizHexInput', type:'text', value:'#2c0a71', maxlength:'7', spellcheck:'false', inputmode:'text' });
    r.bizQrBgHex = U.el('input', { class:'tw-input tw-bizHexInput', type:'text', value:'#ffffff', maxlength:'7', spellcheck:'false', inputmode:'text' });
    r.bizQrLogoFile = U.el('input', { class:'tw-input', type:'file', accept:'image/*' });
    r.bizQrLogoUrl = U.el('input', { class:'tw-input', type:'url', placeholder:'Optional logo URL for QR center' });
    r.bizRemoveQrLogo = U.el('button', { class:'tw-btn tw-btnDanger tw-bizTinyBtn', type:'button' }, ['Remove QR logo']);
    r.bizQrPreview = U.el('div', { class:'tw-bizQrPreview' });
    r.bizConfettiMode = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'standard', text:'Color particles' }),
      U.el('option', { value:'logo', text:'Custom image / logo' }),
      U.el('option', { value:'mixed', text:'Colors + custom image' })
    ]);
    r.bizCelebrationEffect = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'classic', text:'Classic confetti' }),
      U.el('option', { value:'burst', text:'Center burst' }),
      U.el('option', { value:'cannons', text:'Side cannons' }),
      U.el('option', { value:'rain', text:'Celebration rain' }),
      U.el('option', { value:'sparkles', text:'Floating sparkles' })
    ]);
    var creativeEffectDefs = [
      { id:'classic', label:'Classic', img:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/classicconfettiiconcelebrationlab.png?v=1784293844' },
      { id:'burst', label:'Center Burst', img:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/centerbursticoncelebrationlab.png?v=1784293828' },
      { id:'cannons', label:'Side Cannons', img:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/sidecannonsiconcelebrationlab.png?v=1784293821' },
      { id:'rain', label:'Rain', img:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/celebrationrainiconcreativelab.png?v=1784293838' },
      { id:'sparkles', label:'Sparkles', img:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/floatingsparklesiconcreativelab.png?v=1784293852' }
    ];
    r.bizCelebrationEffectOrbs = U.el('div', { class:'tw-spinExpGrid tw-creativeEffectOrbs', role:'group', 'aria-label':'Celebration effect' });
    creativeEffectDefs.forEach(function(def){
      var btn = U.el('button', { class:'tw-pill tw-aiIconPill tw-spinExpOrb tw-creativeEffectOrb', type:'button', 'data-effect':def.id, title:def.label, 'aria-label':def.label }, [
        U.el('img', { class:'tw-aiIconImg tw-spinExpImg', src:def.img, alt:def.label }),
        U.el('span', { class:'tw-aiIconText tw-creativeEffectGhostLabel', text:def.label, 'aria-hidden':'true' })
      ]);
      r.bizCelebrationEffectOrbs.appendChild(btn);
    });
    TW.syncCreativeEffectOrbs = function(){
      if(!r.bizCelebrationEffectOrbs) return;
      var active = String((TW.state && TW.state.ui && TW.state.ui.spinBizCelebrationEffect) || (r.bizCelebrationEffect && r.bizCelebrationEffect.value) || 'classic');
      Array.prototype.forEach.call(r.bizCelebrationEffectOrbs.querySelectorAll('.tw-creativeEffectOrb'), function(btn){
        var on = btn.getAttribute('data-effect') === active;
        btn.classList.toggle('isActive', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    };
    r.bizCelebrationIntensity = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'light', text:'Light' }),
      U.el('option', { value:'standard', text:'Standard' }),
      U.el('option', { value:'huge', text:'Huge' })
    ]);
    r.bizCelebrationColor = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'wheel', text:'Wheel colors' }),
      U.el('option', { value:'winner', text:'Winning segment color' }),
      U.el('option', { value:'custom', text:'Custom color' })
    ]);
    r.bizCelebrationCustomColor = U.el('input', { class:'tw-bizColorSwatch', type:'color', value:'#ff4fa3', 'aria-label':'Custom celebration color' });
    r.bizCelebrationCustomHex = U.el('input', { class:'tw-input tw-bizHexInput', type:'text', value:'#ff4fa3', maxlength:'7', spellcheck:'false' });
    r.bizConfettiFile = U.el('input', { class:'tw-input', type:'file', accept:'image/*' });
    r.bizConfettiUrl = U.el('input', { class:'tw-input', type:'url', placeholder:'Or paste image URL for confetti' });
    r.bizRemoveConfetti = U.el('button', { class:'tw-btn tw-btnDanger tw-bizTinyBtn', type:'button' }, ['Remove confetti image']);
    r.bizConfettiPreview = U.el('div', { class:'tw-bizConfettiPreview' });
    r.bizMsg = U.el('div', { class:'tw-mini tw-bizMsg' });

    r.bizLockNotice = U.el('div', { class:'tw-aiLockNotice tw-aiPremiumNotice tw-bizLockNotice', hidden:'' }, [
      U.el('div', { class:'tw-aiLockBadge' }, [
        U.el('img', { src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexproglassesicon.png?v=1789304505', alt:'Vortex Pro' })
      ]),
      U.el('div', { class:'tw-aiLockCopy' }, [
        U.el('div', { class:'tw-aiLockKicker', text:'Creator Lab Preview' }),
        U.el('div', { class:'tw-aiLockText', text:'Create more dramatic spins and branded winner moments.' }),
        U.el('div', { class:'tw-previewFeaturePills' }, [
          U.el('span', { class:'tw-previewFeatureText', text:'Spin effects' }),
          U.el('span', { class:'tw-previewFeatureText', text:'Winner popups' }),
          U.el('span', { class:'tw-previewFeatureText', text:'QR + confetti' })
        ])
      ]),
      U.el('button', { class:'tw-btn tw-btnPrimary tw-aiPreviewCta', type:'button' }, ['Unlock Creator Lab'])
    ]);
    function openSpinBizUpsell(){
      TW.openPlanUpsell && TW.openPlanUpsell('vortex_pro', {
        title:'🎨 Creator Lab is ready…',
        message:'Unlock Vortex Pro for Spin Experiences, promo winner popups, QR codes, popup images, and custom confetti.',
        subtext:'Spin effects • winner popups • QR/image • custom confetti',
        href:'https://spinthewheellab.com/pages/vortexpro'
      });
    }
    r.bizLockNotice.addEventListener('click', openSpinBizUpsell);

    function updateBizPreviews(){
      var ui = TW.state && TW.state.ui ? TW.state.ui : {};
      var rawUrl = String((r.bizUrl && r.bizUrl.value) || ui.spinBizUrl || '').trim();
      var url = U.safeHttpUrl ? U.safeHttpUrl(rawUrl) : rawUrl;
      if(r.bizQrPreview){
        r.bizQrPreview.innerHTML = '';
        var fg = String((r.bizQrFgHex && r.bizQrFgHex.value) || (r.bizQrFg && r.bizQrFg.value) || ('#' + (ui.spinBizQrFg || '2c0a71'))).replace('#','');
        var bg = String((r.bizQrBgHex && r.bizQrBgHex.value) || (r.bizQrBg && r.bizQrBg.value) || ('#' + (ui.spinBizQrBg || 'ffffff'))).replace('#','');
        var logoRaw = String((r.bizQrLogoUrl && r.bizQrLogoUrl.value) || ui.spinBizQrLogo || '').trim();
        var logo = U.safeImageSource ? U.safeImageSource(logoRaw) : logoRaw;
        if(url){
          var qr = U.makeQrDataUrl ? U.makeQrDataUrl(url, fg, bg) : '';
          if(qr){
            var wrap = U.el('div', { class:'tw-bizQrFrame' }, [ U.el('img', { src:qr, alt:'QR code preview' }) ]);
            if(logo) wrap.appendChild(U.el('img', { class:'tw-bizQrLogo', src:logo, alt:'QR logo preview' }));
            r.bizQrPreview.appendChild(wrap);
            r.bizQrPreview.appendChild(U.el('div', { class:'tw-mini tw-bizPreviewNote', text:'QR and Claim Prize open the same link.' }));
          }
        }
      }
      if(r.bizPopupImagePreview){
        r.bizPopupImagePreview.innerHTML = '';
        var popImgRaw = String((r.bizPopupImageUrl && r.bizPopupImageUrl.value) || ui.spinBizPopupImage || '').trim();
        var popImg = U.safeImageSource ? U.safeImageSource(popImgRaw) : popImgRaw;
        if(popImg){
          r.bizPopupImagePreview.appendChild(U.el('img', { class:'tw-bizPopupImageThumb', src:popImg, alt:'Winner popup image preview' }));
          r.bizPopupImagePreview.appendChild(U.el('div', { class:'tw-mini tw-bizPreviewNote', text:'Winner popup image is ready.' }));
        }
      }
      if(r.bizConfettiPreview){
        r.bizConfettiPreview.innerHTML = '';
        var imgRaw = String((r.bizConfettiUrl && r.bizConfettiUrl.value) || ui.spinBizConfettiImage || '').trim();
        var img = U.safeImageSource ? U.safeImageSource(imgRaw) : imgRaw;
        if(img){
          r.bizConfettiPreview.appendChild(U.el('img', { class:'tw-bizConfettiThumb', src:img, alt:'Custom confetti preview' }));
          r.bizConfettiPreview.appendChild(U.el('div', { class:'tw-mini tw-bizPreviewNote', text:'Custom confetti image is ready.' }));
        }
      }
    }
    TW.updateSpinBizPreviews = updateBizPreviews;
    function updateCreativeConditionalFields(){
      var ui = TW.state && TW.state.ui ? TW.state.ui : {};
      var mode = String((r.bizConfettiMode && r.bizConfettiMode.value) || ui.spinBizConfettiMode || 'standard');
      var colorMode = String((r.bizCelebrationColor && r.bizCelebrationColor.value) || ui.spinBizCelebrationColor || 'wheel');
      var imageFields = r.bizBody ? r.bizBody.querySelectorAll('.tw-bizParticleImageField') : [];
      Array.prototype.forEach.call(imageFields, function(el){ el.hidden = !(mode === 'logo' || mode === 'mixed'); });
      if(r.bizCustomColorField) r.bizCustomColorField.hidden = colorMode !== 'custom';
    }
    TW.updateCreativeConditionalFields = updateCreativeConditionalFields;

    r.bizBody = U.el('div', { class:'tw-bizBody tw-bizInlineBody tw-creativeBizTools', id:'twCreativeBizTools' }, [
      U.el('div', { class:'tw-accordTitle tw-bizSectionTitle', text:'Winner Experience' }),
      U.el('div', { class:'tw-mini tw-creativeWinnerHint', text:'Standard keeps the original winner popup untouched. Change any Winner Experience setting below and Custom Winner Experience turns on automatically.' }),
      U.el('div', { class:'tw-row tw-bizRow' }, [
        U.el('div', { class:'tw-field tw-aiFieldStack' }, [ U.el('label',{text:'Winner popup'}), r.bizPopup ]),
        U.el('div', { class:'tw-field tw-aiFieldStack' }, [ U.el('label',{text:'Popup style'}), r.bizPopupStyle ])
      ]),
      U.el('div', { class:'tw-row tw-bizRow' }, [
        U.el('div', { class:'tw-field tw-aiFieldStack' }, [ U.el('label',{text:'Entrance effect'}), r.bizPopupEntrance ]),
        U.el('div', { class:'tw-field tw-aiFieldStack' }, [ U.el('label',{text:'Popup media'}), r.bizPopupMedia ])
      ]),
      U.el('div', { class:'tw-row tw-bizRow' }, [
        U.el('div', { class:'tw-field tw-aiFieldStack' }, [ U.el('label',{text:'Headline'}), r.bizPopupHeadline ]),
        U.el('div', { class:'tw-field tw-aiFieldStack' }, [ U.el('label',{text:'Action button'}), r.bizPopupButton ])
      ]),
      U.el('div', { class:'tw-field tw-aiFieldStack' }, [ U.el('label',{text:'Supporting message'}), r.bizPopupMessage ]),
      U.el('div', { class:'tw-field tw-aiFieldStack' }, [ U.el('label',{text:'Destination link'}), r.bizUrl ]),
      U.el('div', { class:'tw-row tw-bizRow' }, [
        U.el('div', { class:'tw-field tw-aiFieldStack' }, [ U.el('label',{text:'Upload popup image'}), r.bizPopupImageFile ]),
        U.el('div', { class:'tw-field tw-aiFieldStack' }, [ U.el('label',{text:'Popup image URL'}), r.bizPopupImageUrl ])
      ]),
      U.el('div', { class:'tw-toolbar tw-bizToolRow' }, [ r.bizRemovePopupImage ]),
      r.bizPopupImagePreview,
      U.el('div', { class:'tw-divider' }),
      U.el('div', { class:'tw-accordTitle tw-bizSectionTitle', text:'QR Code' }),
      U.el('div', { class:'tw-row tw-bizRow' }, [
        U.el('div', { class:'tw-field tw-aiFieldStack' }, [ U.el('label',{text:'QR foreground'}), U.el('div', { class:'tw-bizColorLine' }, [ r.bizQrFg, r.bizQrFgHex ]) ]),
        U.el('div', { class:'tw-field tw-aiFieldStack' }, [ U.el('label',{text:'QR background'}), U.el('div', { class:'tw-bizColorLine' }, [ r.bizQrBg, r.bizQrBgHex ]) ])
      ]),
      U.el('div', { class:'tw-row tw-bizRow' }, [
        U.el('div', { class:'tw-field tw-aiFieldStack' }, [ U.el('label',{text:'QR logo upload'}), r.bizQrLogoFile ]),
        U.el('div', { class:'tw-field tw-aiFieldStack' }, [ U.el('label',{text:'QR logo URL'}), r.bizQrLogoUrl ])
      ]),
      U.el('div', { class:'tw-toolbar tw-bizToolRow' }, [ r.bizRemoveQrLogo ]),
      r.bizQrPreview,
      U.el('div', { class:'tw-divider' }),
      U.el('div', { class:'tw-accordTitle tw-bizSectionTitle', text:'Celebration Effects' }),
      U.el('div', { class:'tw-field tw-aiFieldStack tw-creativeEffectField' }, [ U.el('label',{text:'Effect'}), r.bizCelebrationEffectOrbs, r.bizCelebrationEffect ]),
      U.el('div', { class:'tw-field tw-aiFieldStack' }, [ U.el('label',{text:'Intensity'}), r.bizCelebrationIntensity ]),
      U.el('div', { class:'tw-row tw-bizRow' }, [
        U.el('div', { class:'tw-field tw-aiFieldStack' }, [ U.el('label',{text:'Particles'}), r.bizConfettiMode ]),
        U.el('div', { class:'tw-field tw-aiFieldStack' }, [ U.el('label',{text:'Color source'}), r.bizCelebrationColor ])
      ]),
      (r.bizCustomColorField = U.el('div', { class:'tw-field tw-aiFieldStack tw-bizCustomColorField' }, [ U.el('label',{text:'Custom celebration color'}), U.el('div', { class:'tw-bizColorLine' }, [ r.bizCelebrationCustomColor, r.bizCelebrationCustomHex ]) ])),
      U.el('div', { class:'tw-field tw-aiFieldStack tw-bizParticleImageField' }, [ U.el('label',{text:'Upload custom particle image'}), r.bizConfettiFile ]),
      U.el('div', { class:'tw-field tw-aiFieldStack tw-bizParticleImageField' }, [ U.el('label',{text:'Confetti image URL'}), r.bizConfettiUrl ]),
      U.el('div', { class:'tw-toolbar tw-bizToolRow' }, [ r.bizRemoveConfetti ]),
      r.bizConfettiPreview,
      r.bizMsg,
      U.el('div', { class:'tw-privacyNote tw-aiPrivacyNote' }, [
        U.el('span', { class:'tw-privacyNoteBadge', text:'Creator Lab responsibility' }),
        U.el('span', { class:'tw-privacyNoteText', text:'Spin the Wheel Lab does not collect customer emails or redemption records through these Creator Lab controls. QR codes and claim buttons send visitors to the destination you provide. You are responsible for that destination, your offer terms, eligibility, disclosures, permissions, privacy practices, fulfillment, and compliance with promotion, advertising, consumer, and other applicable laws.' })
      ])
    ]);

    r.bizDetails.appendChild(r.bizSummary);
    r.bizDetails.appendChild(r.bizBody);
    setTimeout(function(){ updateBizPreviews(); TW.syncCreativeEffectOrbs && TW.syncCreativeEffectOrbs(); TW.updateCreativeConditionalFields && TW.updateCreativeConditionalFields(); }, 0);

    // Spin Experience (collapsed by default)
    r.expDetails = U.el('details', { class:'tw-accord', id:'twSpinExperience' });
    r.expDetails.removeAttribute('open');

    r.expSummary = buildPanelSummary('Creator Lab', 'Choose dramatic spin effects and memorable winner reveals.', 'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/creatorlabpanelicon.png?v=1789304486', true);

    r.expClassicBtn = U.el('button', { class:'tw-pill tw-aiIconPill tw-spinExpOrb isActive', type:'button', title:'Classic' }, [
      U.el('img', { class:'tw-aiIconImg tw-spinExpImg', alt:'Classic', src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/classicspinexperience.png?v=1778610246' }),
      U.el('span', { class:'tw-aiIconText', text:'Classic' })
    ]);
    r.expFakeoutBtn = U.el('button', { class:'tw-pill tw-aiIconPill tw-spinExpOrb', type:'button', title:'Fakeout Frenzy' }, [
      U.el('img', { class:'tw-aiIconImg tw-spinExpImg', alt:'Fakeout Frenzy', src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/fakeoutfrenzyspinexperience.png?v=1778610271' }),
      U.el('span', { class:'tw-aiIconText', text:'Fakeout Frenzy' })
    ]);
    r.expBlackoutBtn = U.el('button', { class:'tw-pill tw-aiIconPill tw-spinExpOrb', type:'button', title:'Blackout Drop' }, [
      U.el('img', { class:'tw-aiIconImg tw-spinExpImg', alt:'Blackout Drop', src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/blackoutdropspinexperience.png?v=1778610239' }),
      U.el('span', { class:'tw-aiIconText', text:'Blackout Drop' })
    ]);
    r.expReactorBtn = U.el('button', { class:'tw-pill tw-aiIconPill tw-spinExpOrb', type:'button', title:'Reactor Surge' }, [
      U.el('img', { class:'tw-aiIconImg tw-spinExpImg', alt:'Reactor Surge', src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/reactorsurgespinexperience.png?v=1778610262' }),
      U.el('span', { class:'tw-aiIconText', text:'Reactor Surge' })
    ]);

    r.expStatus = U.el('div', { class:'tw-mini tw-spinExpStatus', text:'Classic wheel behavior is active.' });

    r.expLockNotice = U.el('div', { class:'tw-aiLockNotice tw-aiPremiumNotice tw-creativeLabLockNotice', hidden:'' }, [
      U.el('div', { class:'tw-aiLockBadge' }, [
        U.el('img', { src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexproglassesicon.png?v=1789304505', alt:'Vortex Pro' })
      ]),
      U.el('div', { class:'tw-aiLockCopy' }, [
        U.el('div', { class:'tw-aiLockKicker', text:'Creator Lab Preview' }),
        U.el('div', { class:'tw-aiLockText', text:'Transform every spin with dramatic effects and custom winner moments.' }),
        U.el('div', { class:'tw-previewFeaturePills' }, [
          U.el('span', { class:'tw-previewFeatureText', text:'Spin effects' }),
          U.el('span', { class:'tw-previewFeatureText', text:'Winner popups' }),
          U.el('span', { class:'tw-previewFeatureText', text:'Custom confetti' })
        ])
      ]),
      U.el('button', { class:'tw-btn tw-btnPrimary tw-aiPreviewCta', type:'button' }, ['Unlock Creator Lab'])
    ]);
    r.expLockNotice.addEventListener('click', function(){
      TW.openPlanUpsell && TW.openPlanUpsell('vortex_pro', {
        title:'🎨 Creator Lab is ready…',
        message:'Unlock Vortex Pro for Spin Experiences, promo winner popups, QR codes, popup images, and custom confetti.',
        subtext:'Spin effects • winner popups • QR/image • custom confetti',
        href:'https://spinthewheellab.com/pages/vortexpro'
      });
    });

    r.expBody = U.el('div', { class:'tw-accordBody tw-creativeLabBody' }, [
      U.el('div', { class:'tw-mini', text:'Choose how the spin feels, then customize winner popups, QR codes, popup images, and custom confetti.' }),
      U.el('div', { class:'tw-accordTitle tw-labSubTitle tw-spinExperiencesTitle', text:'Spin Experiences' }),
      U.el('div', { class:'tw-spinExpGrid' }, [
        r.expClassicBtn,
        r.expFakeoutBtn,
        r.expBlackoutBtn,
        r.expReactorBtn
      ]),
      r.expStatus,
      U.el('div', { class:'tw-divider' }),
      r.bizBody,
      r.expLockNotice
    ]);

    r.expDetails.appendChild(r.expSummary);
    r.expDetails.appendChild(r.expBody);

    // Customize / Make Your Own Wheel (collapsed by default)
    r.cusDetails = U.el('details', { class:'tw-accord', id:'twCustomize' });
    r.cusDetails.removeAttribute('open');

    r.cusSummary = buildPanelSummary('Spin Studio', 'Tune the spin, countdown, sound, voice, and wheel details.', 'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/spinstudiopanelicon.png?v=1789304468', false);

    // customize fields
    r.inTitle = U.el('input', { class:'tw-input', type:'text' });
    r.inDesc  = U.el('input', { class:'tw-input', type:'text' });

    r.selSpeed = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'slow', text:'Slow' }),
      U.el('option', { value:'normal', text:'Normal' }),
      U.el('option', { value:'turbo', text:'Turbo' })
    ]);

    r.selCountdownOn = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'no', text:'No countdown' }),
      U.el('option', { value:'yes', text:'Yes (countdown)' })
    ]);

    r.inCountdownSec = U.el('input', { class:'tw-input', type:'number', min:'1', max:'10', step:'1' });

    r.selConfetti = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'yes', text:'Yes (big confetti)' }),
      U.el('option', { value:'no', text:'No confetti' })
    ]);

    // Center Badge controls
    r.badgeUrl = U.el('input', { class:'tw-input', type:'text', placeholder:'Paste image URL (optional)' });
    r.badgeFile = U.el('input', { class:'tw-input', type:'file', accept:'image/*' });
    r.selBadgeMask = U.el('select', { class:'tw-select' }, [
      U.el('option', { value:'circle', text:'Circle mask (recommended)' }),
      U.el('option', { value:'none', text:'No mask' })
    ]);
    r.rangeBadgeScale = U.el('input', { type:'range', min:'0.25', max:'2.5', step:'0.02' });
    r.btnBadgeVortex = U.el('button', { class:'tw-btn tw-btnPrimary tw-vortexPickerBtn', type:'button' }, ['Choose Center Vortex']);
    r.btnBadgeReset = U.el('button', { class:'tw-btn', type:'button' }, ['Reset badge position']);
    r.btnBadgeDefault = U.el('button', { class:'tw-btn', type:'button' }, ['Use default badge']);
    r.btnBadgeClear = U.el('button', { class:'tw-btn tw-btnDanger', type:'button' }, ['Clear badge']);
    r.btnBadgeEdit = U.el('button', { class:'tw-btn tw-btnPrimary', type:'button' }, ['Edit badge: Off']);

    // teams
    r.teamName = U.el('input', { class:'tw-input', type:'text', placeholder:'Add team/player name' });
    r.btnAddTeam = U.el('button', { class:'tw-btn tw-btnPrimary', type:'button' }, ['Add']);
    r.btnResetPts = U.el('button', { class:'tw-btn', type:'button' }, ['Reset points']);
    r.btnClearTeams = U.el('button', { class:'tw-btn tw-btnDanger', type:'button' }, ['Clear teams']);
    r.teamsList = U.el('div', { class:'tw-list', id:'twTeamsList' });

    // history
    r.btnCSV = U.el('button', { class:'tw-btn', type:'button' }, ['Download CSV']);
    r.btnClearHist = U.el('button', { class:'tw-btn tw-btnDanger', type:'button' }, ['Clear history']);
    r.histBox = U.el('div', { class:'tw-scrollBox', style:'max-height:180px; white-space:normal;' });

    // sound + voice
    r.selSpinSound = U.el('select', { class:'tw-select' });
    r.selWinSound = U.el('select', { class:'tw-select' });
    r.rangeSpinVol = U.el('input', { type:'range', min:'0', max:'1', step:'0.01' });
    r.rangeWinVol = U.el('input', { type:'range', min:'0', max:'1', step:'0.01' });
    r.rangeVoiceVol = U.el('input', { type:'range', min:'0', max:'1', step:'0.01' });

    r.selVoice = U.el('select', { class:'tw-select' });
    r.btnTestVoice = U.el('button', { class:'tw-btn', type:'button' }, ['Test voice']);
    r.inWinnerPhrase = U.el('input', { class:'tw-input', type:'text' });

    r.btnRec = U.el('button', { class:'tw-btn', type:'button' }, ['Record phrase']);
    r.btnStopRec = U.el('button', { class:'tw-btn tw-btnDanger', type:'button', hidden:'' }, ['Stop']);
    r.btnClearRec = U.el('button', { class:'tw-btn tw-btnDanger', type:'button' }, ['Clear recording']);

    r.ownershipNotice = U.el('div', { class:'tw-privacyNote tw-ipNotice tw-studioIpNotice' }, [
      U.el('span', { class:'tw-privacyNoteBadge', text:'Protected Lab Materials' }),
      U.el('span', { class:'tw-privacyNoteText', text:'Spin the Wheel Lab, Professor Vortex, Lab Packs, Snap Spins, original wheel designs, artwork, graphics, branding, interface elements, code, and related Lab materials are protected and may not be copied, scraped, resold, redistributed, reverse engineered, or used to build a competing product except as permitted by our Terms or written permission. You retain any rights you have in your original labels, prompts, uploads, and other user content.' })
    ]);

    // compose customize body
    r.cusBody = U.el('div', { class:'tw-accordBody' }, [

      U.el('div', { class:'tw-accordTitle', text:'General' }),
      U.el('div', { class:'tw-row' }, [
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Title'}), r.inTitle ]),
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Subtitle'}), r.inDesc ])
      ]),
      U.el('div', { class:'tw-row' }, [
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Speed'}), r.selSpeed ]),
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Confetti'}), r.selConfetti ])
      ]),
      U.el('div', { class:'tw-row' }, [
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Countdown'}), r.selCountdownOn ]),
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Countdown seconds (1–10)'}), r.inCountdownSec ])
      ]),

      U.el('div', { class:'tw-divider' }),

      U.el('div', { class:'tw-accordTitle tw-centerBadgeTitle', text:'Center Badge' }),
      U.el('div', { class:'tw-mini tw-vortexPickerHint', text:'Choose a ready-made center vortex, or use your own image below.' }),
      U.el('div', { class:'tw-toolbar tw-vortexPickerToolbar' }, [ r.btnBadgeVortex ]),
      U.el('div', { class:'tw-row' }, [
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Upload image (best for mobile)'}), r.badgeFile ]),
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Or paste image URL'}), r.badgeUrl ])
      ]),
      U.el('div', { class:'tw-row' }, [
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Mask'}), r.selBadgeMask ]),
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Scale'}), r.rangeBadgeScale ])
      ]),
      U.el('div', { class:'tw-toolbar' }, [ r.btnBadgeEdit, r.btnBadgeReset, r.btnBadgeDefault, r.btnBadgeClear ]),
      U.el('div', { class:'tw-mini', text:'Turn on “Edit badge” to drag the badge on the wheel (desktop + mobile). Dragging is disabled during spins.' }),

      U.el('div', { class:'tw-divider' }),

      U.el('div', { class:'tw-accordTitle', text:'Teams / Players & Points' }),
      U.el('div', { class:'tw-toolbar' }, [ r.teamName, r.btnAddTeam, r.btnResetPts, r.btnClearTeams ]),
      r.teamsList,

      U.el('div', { class:'tw-divider' }),
      U.el('div', { class:'tw-accordTitle tw-historyTitle', text:'History (download CSV)' }),
      U.el('div', { class:'tw-toolbar' }, [ r.btnCSV, r.btnClearHist ]),
      r.histBox,

      U.el('div', { class:'tw-divider' }),
      U.el('div', { class:'tw-accordTitle', text:'Sound & Voice' }),
      U.el('div', { class:'tw-row' }, [
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Spin sound'}), r.selSpinSound ]),
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Celebration sound'}), r.selWinSound ])
      ]),
      U.el('div', { class:'tw-row tw-volumeRow tw-volumeRowFx' }, [
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Spin volume'}), r.rangeSpinVol ]),
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Celebration volume'}), r.rangeWinVol ])
      ]),
      U.el('div', { class:'tw-row tw-volumeRow tw-volumeRowVoice' }, [
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Voice volume'}), r.rangeVoiceVol ]),
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Winner phrase (spoken if no recording)'}), r.inWinnerPhrase ])
      ]),
      U.el('div', { class:'tw-row' }, [
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Winner phrase (spoken if no recording)'}), r.inWinnerPhrase ])
      ]),
      U.el('div', { class:'tw-row' }, [
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:'Voice'}), r.selVoice ]),
        U.el('div', { class:'tw-field' }, [ U.el('label',{text:' ' }), U.el('div',{style:'display:flex; gap:10px; flex-wrap:wrap;'}, [ r.btnTestVoice, r.btnRec, r.btnStopRec, r.btnClearRec ]) ])
      ]),
      U.el('div', { class:'tw-mini', text:', it plays first, then ONLY the winner name is spoken by your selected voice.' }),
      r.ownershipNotice
    ]);

    r.cusDetails.appendChild(r.cusSummary);
    r.cusDetails.appendChild(r.cusBody);

    // =========================================================
    // ✅ NEW: Fairness Test panel (under Make Your Own Wheel)
    // - UI only (logic + binding in part4)
    // =========================================================
    r.fairDetails = U.el('details', { class:'tw-accord', id:'twFairness' });
    r.fairDetails.removeAttribute('open');

    r.fairSummary = buildPanelSummary('Spin Science', 'Test 10,000 spins and compare expected and simulated outcomes.', 'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/spinsciencepanelicon.png?v=1789304468', false);

    r.btnFairRun = U.el('button', { class:'tw-btn tw-btnPrimary', type:'button', id:'twFairRun' }, ['Run 10,000']);
    r.fairProg = U.el('div', { class:'tw-mini', id:'twFairProg', text:'' });
    r.fairOut = U.el('div', { class:'tw-scrollBox', id:'twFairOut', style:'max-height:260px; white-space:normal;' });
    r.fairNotice = U.el('div', { class:'tw-privacyNote tw-fairnessNotice' }, [
      U.el('span', { class:'tw-privacyNoteBadge', text:'Weighted outcomes' }),
      U.el('span', { class:'tw-privacyNoteText', text:'Equal positive weights give segments equal selection probabilities. Changing a weight intentionally changes that segment’s probability relative to the total weight, so a weighted wheel is not an equal-chance wheel. The 10,000-spin test is a simulation of the current wheel state: actual percentages normally vary from expected percentages, and the test does not predict, certify, or guarantee any individual result or future sequence. Review and disclose weights before using a wheel for prizes, giveaways, contests, assignments, or other consequential decisions, and follow applicable rules.' })
    ]);

    r.fairBody = U.el('div', { class:'tw-accordBody' }, [
      U.el('div', { class:'tw-fairHero' }, [
        U.el('div', { class:'tw-mini', text:'Run 10,000 instant spins on your CURRENT wheel state, including weights, and review the distribution in one place.' }),
        U.el('img', { class:'tw-fairBadge', alt:'Lab Tested', src:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/verifiedbadge1.png?v=1776696815' })
      ]),
      U.el('div', { class:'tw-toolbar' }, [ r.btnFairRun ]),
      r.fairNotice,
      r.fairProg,
      U.el('div', { style:'height:10px;' }),
      r.fairOut
    ]);

    r.fairDetails.appendChild(r.fairSummary);
    r.fairDetails.appendChild(r.fairBody);


    try{
      if(!document.querySelector('style[data-tw-spin-experience="1"]')){
        var expSt = document.createElement('style');
        expSt.setAttribute('data-tw-spin-experience','1');
        expSt.textContent = [
          '.tw-spinExpGrid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:12px 14px;margin-top:14px;justify-items:center;}',
          '.tw-spinExpOrb{min-height:146px;padding:12px 4px 18px;}',
          '.tw-spinExpOrb::before{background:radial-gradient(circle, rgba(91,192,235,0.40) 0%, rgba(91,192,235,0.18) 40%, rgba(91,192,235,0.00) 74%);}',
          '.tw-spinExpOrb.isActive::before{width:128px;height:128px;background:radial-gradient(circle, rgba(91,192,235,0.72) 0%, rgba(91,192,235,0.28) 44%, rgba(91,192,235,0.00) 78%);}',
          '.tw-spinExpImg{width:112px;height:112px;}',
          '.tw-spinExpStatus{margin-top:8px;text-align:center;}',
          '@media (max-width:980px){.tw-spinExpGrid{grid-template-columns:repeat(4,minmax(0,1fr));gap:10px 10px;}.tw-spinExpOrb{min-height:124px;padding:8px 2px 14px;}.tw-spinExpImg{width:88px;height:88px;}}',
          '@media (max-width:640px){.tw-spinExpGrid{grid-template-columns:repeat(3,minmax(0,1fr));gap:8px 8px;}.tw-spinExpOrb{min-height:108px;padding:8px 1px 10px;}.tw-spinExpOrb::before{width:68px;height:68px;filter:blur(12px);}.tw-spinExpOrb.isActive::before{width:88px;height:88px;filter:blur(16px);}.tw-spinExpImg{width:74px;height:74px;}}'
        ].join('');
        document.head.appendChild(expSt);
      }
    }catch(e){}



    // SURGICAL 2026-05-20/21: non-subscriber internal sticker-pack cards under Spin Science.
    // Hidden for Vortex Pro / Vortex Pro customers so paid subscribers do not see internal ads.
    // Shows a rotating 3-pack window so the lab drops keep feeling fresh without changing any wheel logic.
    function buildStickerDropsPanel(){
      var canShow = !(TW.access && TW.access.canSeeInternalAds) || TW.access.canSeeInternalAds();
      var panel = U.el('section', { class:'tw-stickerDrops' + (canShow ? '' : ' tw-stickerDropsHidden'), id:'twStickerDrops' });
      if(!canShow){ panel.hidden = true; return panel; }

      var packs = (TW.STICKER_PACKS || []).slice();
      var cursor = 0;
      var pageSize = 3;

      panel.appendChild(U.el('div', { class:'tw-stickerDropsHead' }, [
        U.el('div', {}, [
          U.el('div', { class:'tw-stickerDropsKicker', text:'ONE-TIME · $4.99 USD EACH' }),
          U.el('h3', { class:'tw-stickerDropsTitle', text:'Give your wheel a complete theme' }),
          U.el('p', { class:'tw-stickerDropsText', text:'Each pack is a themed creative collection you can use on every wheel and keep forever—or unlock every pack with Vortex Pro.' })
        ]),
        U.el('button', { class:'tw-stickerDropsAll', type:'button' }, ['Explore All Packs'])
      ]));
      panel.querySelector('.tw-stickerDropsAll').onclick = function(){ window.location.href = TW.STICKER_PACKS_URL || 'https://spinthewheellab.com/collections/lab-packs'; };

      var rail = U.el('div', { class:'tw-stickerDropsRail', 'aria-live':'polite' });
      panel.appendChild(rail);

      function getVisiblePacks(){
        if(!packs.length) return [];
        var out = [];
        for(var i=0; i<Math.min(pageSize, packs.length); i++){
          out.push(packs[(cursor + i) % packs.length]);
        }
        return out;
      }

      function makeDropCard(pack){
        var owned = !!(TW.access && TW.access.hasTag && TW.access.hasTag(pack.tag));
        var card = U.el('article', { class:'tw-stickerDropCard' + (owned ? ' isOwned' : '') }, [
          U.el('div', { class:'tw-stickerDropArt' }, [
            U.el('img', { src:pack.banner, alt:pack.name || 'Lab Pack', loading:'lazy' })
          ]),
          U.el('div', { class:'tw-stickerDropCopy' }, [
            U.el('div', { class:'tw-stickerDropBadge', text: owned ? 'Unlocked' : '$4.99 · One time' }),
            U.el('div', { class:'tw-stickerDropName', text:pack.name || 'Lab Pack' }),
            U.el('div', { class:'tw-stickerDropSub', text:'12 stickers · 1 center vortex · 3 textures · Use them on every wheel.' }),
            U.el('div', { class:'tw-stickerDropSamples' })
          ]),
          U.el('div', { class:'tw-stickerDropActions' }, [
            U.el('button', { class:'tw-stickerDropBtn', type:'button' }, [owned ? 'Open Pack' : 'Get This Pack']),
            U.el('button', { class:'tw-stickerDropMini', type:'button' }, ['All Packs'])
          ])
        ]);
        var sampleWrap = card.querySelector('.tw-stickerDropSamples');
        ((pack.stickers || pack.sample) || []).slice(0,12).forEach(function(src){ sampleWrap.appendChild(U.el('img', { src:src, alt:'', loading:'lazy' })); });
        card.querySelector('.tw-stickerDropBtn').onclick = function(){ window.location.href = pack.productUrl || TW.STICKER_PACKS_URL; };
        card.querySelector('.tw-stickerDropMini').onclick = function(){ window.location.href = TW.STICKER_PACKS_URL || 'https://spinthewheellab.com/collections/lab-packs'; };
        return card;
      }

      function renderDrops(){
        rail.classList.add('isChanging');
        setTimeout(function(){
          rail.innerHTML = '';
          getVisiblePacks().forEach(function(pack){ rail.appendChild(makeDropCard(pack)); });
          window.requestAnimationFrame(function(){
            setTimeout(function(){ rail.classList.remove('isChanging'); }, 80);
          });
        }, 360);
      }

      renderDrops();
      if(packs.length > pageSize){
        try{
          window.setInterval(function(){
            if(panel.hidden || !panel.parentNode) return;
            cursor = (cursor + pageSize) % packs.length;
            renderDrops();
          }, 6200);
        }catch(_){ }
      }
      return panel;
    }
    function buildLabPackChoicePanel(){
      var canShow = !(TW.access && TW.access.canSeeInternalAds) || TW.access.canSeeInternalAds();
      var packs = (TW.STICKER_PACKS || []).slice();
      var panel = U.el('section', { class:'tw-labPackChoicePanel', id:'twStickerDrops' });
      if(!canShow || !packs.length){ panel.hidden = true; return panel; }

      var cursor = 0;
      var pageSize = 3;
      var allUrl = TW.STICKER_PACKS_URL || 'https://spinthewheellab.com/collections/lab-packs';
      var allBtn = U.el('button', { class:'tw-labPackChoiceAll', type:'button' }, ['Explore All Packs']);
      allBtn.onclick = function(){
        TW.track && TW.track('select_promotion', {
          promotion_id:'wheel_lab_packs', promotion_name:'Lab Packs', creative_slot:'spin_science_lab_packs',
          items:[{ item_id:'all_lab_packs', item_name:'Explore All Lab Packs' }]
        });
        window.location.href = allUrl;
      };

      panel.appendChild(U.el('div', { class:'tw-labPackChoiceHead' }, [
        U.el('div', {}, [
          U.el('div', { class:'tw-labPackChoiceKicker', text:'LAB PACKS · $4.99 USD EACH' }),
          U.el('div', { class:'tw-labPackChoiceTitle', text:'Choose a theme. Keep it forever.' })
        ]),
        allBtn
      ]));

      var grid = U.el('div', { class:'tw-labPackChoiceGrid', 'aria-live':'polite' });
      panel.appendChild(grid);

      function makeCard(pack){
        var owned = !!(TW.access && TW.access.hasTag && TW.access.hasTag(pack.tag));
        var button = U.el('button', { class:'tw-labPackChoiceBtn', type:'button' }, [owned ? 'Open Pack' : 'Get This Pack']);
        function selectPack(){
          TW.track && TW.track('select_promotion', {
            promotion_id:'wheel_lab_packs', promotion_name:'Lab Packs', creative_slot:'spin_science_lab_packs',
            items:[{ item_id:String(pack.id || pack.tag || 'lab_pack'), item_name:String(pack.name || 'Lab Pack') }]
          });
          window.location.href = pack.productUrl || allUrl;
        }
        button.onclick = selectPack;
        var samples = U.el('div', { class:'tw-labPackChoiceSamples', 'aria-hidden':'true' });
        ((pack.stickers || pack.sample) || []).slice(0,12).forEach(function(src){
          samples.appendChild(U.el('img', { src:src, alt:'', loading:'lazy' }));
        });
        var packBanner = U.el('img', { src:pack.banner, alt:pack.name || 'Lab Pack', loading:'lazy', decoding:'async', role:'link', tabindex:'0' });
        packBanner.style.cursor = 'pointer';
        packBanner.onclick = selectPack;
        packBanner.onkeydown = function(ev){ if(ev.key === 'Enter' || ev.key === ' '){ ev.preventDefault(); selectPack(); } };
        return U.el('article', { class:'tw-labPackChoiceCard' + (owned ? ' isOwned' : '') }, [
          U.el('div', { class:'tw-labPackChoiceMedia' }, [
            packBanner
          ]),
          U.el('div', { class:'tw-labPackChoiceCopy' }, [
            U.el('div', { class:'tw-labPackChoicePlan', text:owned ? 'UNLOCKED' : '$4.99 · ONE TIME' }),
            U.el('div', { class:'tw-labPackChoiceCardTitle', text:pack.name || 'Lab Pack' }),
            U.el('div', { class:'tw-labPackChoiceText', text:owned ? '12 stickers, 1 center vortex, and 3 textures—ready for every wheel.' : '12 stickers · 1 center vortex · 3 textures · Yours to keep.' }),
            samples,
            button
          ])
        ]);
      }

      function visiblePacks(startAt){
        var start = (typeof startAt === 'number') ? startAt : cursor;
        var out = [];
        for(var i=0; i<Math.min(pageSize,packs.length); i++) out.push(packs[(start+i)%packs.length]);
        return out;
      }

      function preloadVisiblePacks(packList, done){
        var urls = [];
        packList.forEach(function(pack){
          if(pack.banner) urls.push(pack.banner);
          ((pack.stickers || pack.sample) || []).slice(0,12).forEach(function(src){ if(src) urls.push(src); });
        });
        if(!urls.length){ done(); return; }
        var remaining = urls.length;
        var finished = false;
        urls.forEach(function(src){
          var img = new Image();
          var settled = false;
          var settle = function(){
            if(settled) return;
            settled = true;
            remaining--;
            if(remaining <= 0 && !finished){ finished = true; done(); }
          };
          img.onload = settle;
          img.onerror = settle;
          img.src = src;
          if(img.complete) setTimeout(settle,0);
        });
        setTimeout(function(){ if(!finished){ finished = true; done(); } },2600);
      }

      function paint(packList){
        grid.innerHTML = '';
        packList.forEach(function(pack){ grid.appendChild(makeCard(pack)); });
      }

      paint(visiblePacks());
      if(packs.length > pageSize){
        try{
          var labChoiceTransitioning = false;
          window.setInterval(function(){
            if(panel.hidden || !panel.parentNode || labChoiceTransitioning) return;
            labChoiceTransitioning = true;
            var nextCursor = (cursor + pageSize) % packs.length;
            var nextPacks = visiblePacks(nextCursor);
            preloadVisiblePacks(nextPacks, function(){
              if(!panel.parentNode){ labChoiceTransitioning = false; return; }
              var stableHeight = grid.getBoundingClientRect ? grid.getBoundingClientRect().height : 0;
              if(stableHeight) grid.style.minHeight = Math.ceil(stableHeight) + 'px';
              grid.classList.add('isChanging');
              setTimeout(function(){
                cursor = nextCursor;
                paint(nextPacks);
                window.requestAnimationFrame(function(){
                  window.requestAnimationFrame(function(){
                    grid.classList.remove('isChanging');
                    setTimeout(function(){
                      grid.style.minHeight = '';
                      labChoiceTransitioning = false;
                    },700);
                  });
                });
              },540);
            });
          },6400);
        }catch(_){ }
      }
      TW.analytics && TW.analytics.observePromotion && TW.analytics.observePromotion(panel, {
        promotion_id:'wheel_lab_packs', promotion_name:'Lab Packs', creative_slot:'spin_science_lab_packs'
      });
      return panel;
    }
    // Bottom Lab Pack advertising removed. Lab Packs now live only inside
    // Quick Tweaks, where they are relevant to active customization.

    // SURGICAL 2026-07-05C: subscription upgrade ads for free users, matching internal Lab Pack ad suppression.
    function buildSubscriptionDropsPanel(){
      var canShow = !(TW.access && TW.access.canSeeInternalAds) || TW.access.canSeeInternalAds();
      var url = 'https://spinthewheellab.com/pages/vortexpro';
      var panel = U.el('section', { class:'tw-subscriptionDrops' + (canShow ? '' : ' tw-subscriptionDropsHidden'), id:'twSubscriptionDrops' });
      if(!canShow){ panel.hidden = true; return panel; }

      var ads = [
        { key:'vortexPro', name:'Vortex Pro', banner:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexproadbanner.png?v=1789230453' }
      ];

      panel.appendChild(U.el('div', { class:'tw-subscriptionDropsHead' }, [
        U.el('div', {}, [
          U.el('div', { class:'tw-subscriptionDropsKicker', text:'UPGRADE LAB' }),
          U.el('h3', { class:'tw-subscriptionDropsTitle', text:'Unlock the Complete Lab' }),
          U.el('p', { class:'tw-subscriptionDropsText', text:'Get every sticker, texture, center, Creator Lab, Inventor Lab, and saved dashboard with Vortex Pro.' })
        ]),
        U.el('button', { class:'tw-subscriptionDropsAll', type:'button' }, ['Get Vortex Pro · $9.99'])
      ]));
      panel.querySelector('.tw-subscriptionDropsAll').onclick = function(){ window.location.href = url; };

      var rail = U.el('div', { class:'tw-subscriptionDropsRail' });
      ads.forEach(function(ad){
        var card = U.el('a', { class:'tw-subscriptionDropCard is' + ad.key, href:url, 'aria-label':'View ' + ad.name + ' subscription' }, [
          U.el('img', { src:ad.banner, alt:ad.name + ' subscription upgrade', loading:'eager', decoding:'async' })
        ]);
        rail.appendChild(card);
      });
      panel.appendChild(rail);
      return panel;
    }
    // Bottom Vortex Pro advertising removed. The purpose-built membership
    // feature now appears only inside Quick Tweaks.

    // mount
    r.wrap = U.el('div', { class:'tw-wrap', id:'twWrap' }, [
      r.header,
      r.main,
      r.optDetails,
      r.expDetails,
      r.aiDetails,
      r.cusDetails,
      r.fairDetails,
      r.subscriptionDrops,
      r.overlayBack
    ]);

    r.root.appendChild(r.wrap);
    r.root.appendChild(r.morePanel);

    // Record the first meaningful user action in each creation panel.
    // Opening a panel, viewing an internal ad, or clicking an upgrade lock does
    // not count as creation activity.
    function bindPanelEngagement(container, panelName, actionType){
      if(!container || container.__twPanelAnalyticsBound) return;
      container.__twPanelAnalyticsBound = true;
      function excluded(target){
        return !!(target && target.closest && target.closest('.tw-quickStickerPromo,.tw-quickSubscriptionPromo,.tw-aiLockNotice,.tw-planModalBack,.tw-btnReport'));
      }
      container.addEventListener('change', function(ev){
        if(!ev.isTrusted || excluded(ev.target)) return;
        if(ev.target && ev.target.matches && ev.target.matches('input,select,textarea')){
          TW.analytics && TW.analytics.markPanelEngaged && TW.analytics.markPanelEngaged(panelName, actionType);
        }
      }, true);
      container.addEventListener('click', function(ev){
        if(!ev.isTrusted || excluded(ev.target)) return;
        var button = ev.target && ev.target.closest ? ev.target.closest('button') : null;
        if(!button || button.closest('summary')) return;
        TW.analytics && TW.analytics.markPanelEngaged && TW.analytics.markPanelEngaged(panelName, actionType);
      }, true);
    }
    bindPanelEngagement(r.optDetails, 'quick_tweaks', 'edit_content');
    bindPanelEngagement(r.expDetails, 'creator_lab', 'apply_style');
    bindPanelEngagement(r.aiDetails, 'inventor_lab', 'generate_ai');
    bindPanelEngagement(r.cusDetails, 'spin_studio', 'apply_style');
    bindPanelEngagement(r.fairDetails, 'spin_science', 'run_analysis');

    // modals containers (created later)
    r.modalBack = U.el('div', { class:'tw-modalBack', hidden:'' });
    r.modal = U.el('div', { class:'tw-modal', hidden:'' });
    r.root.appendChild(r.modalBack);
    r.root.appendChild(r.modal);

    // countdown
    r.countOverlay = U.el('div', { class:'tw-countdownOverlay', hidden:'' });
    r.root.appendChild(r.countOverlay);

    // confetti canvas
    r.confetti = U.el('canvas', { class:'tw-confetti', hidden:'' });
    r.root.appendChild(r.confetti);

    // populate sound selects
    r.selSpinSound.innerHTML = '';
    TW.CONST.PRESPIN_SOUNDS.forEach(function(s){
      r.selSpinSound.appendChild(U.el('option', { value:s.id, text:s.name }));
    });
    r.selWinSound.innerHTML = '';
    TW.CONST.CELEBRATION_SOUNDS.forEach(function(s){
      r.selWinSound.appendChild(U.el('option', { value:s.id, text:s.name }));
    });

    enhanceSelectMenu(r.selSpeed, { ariaLabel:'Speed' });
    enhanceSelectMenu(r.selCountdownOn, { ariaLabel:'Countdown' });
    enhanceSelectMenu(r.selConfetti, { ariaLabel:'Confetti' });
    enhanceSelectMenu(r.bizPopup, { ariaLabel:'Creator Lab winner popup' });
    enhanceSelectMenu(r.bizPopupMedia, { ariaLabel:'Creator Lab popup display' });
    enhanceSelectMenu(r.bizPopupStyle, { ariaLabel:'Creator Lab popup style' });
    enhanceSelectMenu(r.bizPopupEntrance, { ariaLabel:'Creator Lab popup entrance' });
    enhanceSelectMenu(r.bizConfettiMode, { ariaLabel:'Creator Lab particles' });
    enhanceSelectMenu(r.bizCelebrationEffect, { ariaLabel:'Creator Lab celebration effect' });
    if(r.bizCelebrationEffect && r.bizCelebrationEffect.parentElement) r.bizCelebrationEffect.parentElement.classList.add('tw-creativeEffectNativeSelect');
    enhanceSelectMenu(r.bizCelebrationIntensity, { ariaLabel:'Creator Lab celebration intensity' });
    enhanceSelectMenu(r.bizCelebrationColor, { ariaLabel:'Creator Lab celebration color source' });
    enhanceSelectMenu(r.selBadgeMask, { ariaLabel:'Mask' });
    enhanceSelectMenu(r.selSpinSound, { ariaLabel:'Spin sound' });
    enhanceSelectMenu(r.selWinSound, { ariaLabel:'Celebration sound' });
    enhanceSelectMenu(r.selVoice, { ariaLabel:'Voice' });
    enhanceSelectMenu(r.aiColorMode, { ariaLabel:'AI wheel colors' });
    enhanceSelectMenu(r.aiStickerMode, { ariaLabel:'AI sticker help' });
    enhanceSelectMenu(r.aiApplyPlan, { ariaLabel:'Build result for' });
    enhanceSelectMenu(r.aiRevealMode, { ariaLabel:'Winner answer behavior' });
    enhanceSelectMenu(r.aiPrizeExperience, { ariaLabel:'Prize experience' });
    enhanceSelectMenu(r.aiAudience, { ariaLabel:'Audience' });
    enhanceSelectMenu(r.aiReadingLevel, { ariaLabel:'Reading level' });

    // initial bind (part4/part5 add more)
    bindBasic();

    TW.refreshAccessUI = function(){
      var userPlan = (TW.access && TW.access.getUserPlan) ? TW.access.getUserPlan() : 'free';
      var isPro = TW.access && TW.access.canUseAI ? TW.access.canUseAI() : true;
      var canUseDashboard = TW.access && TW.access.canUseDashboard ? TW.access.canUseDashboard() : true;

      if(r.btnDashboardSave){
        r.btnDashboardSave.classList.toggle('isLocked', !canUseDashboard);
        r.btnDashboardSave.setAttribute('aria-disabled', canUseDashboard ? 'false' : 'true');
      }
      var canUseSpinExperience = TW.access && TW.access.hasPlan ? TW.access.hasPlan('vortex_pro') : true;
      if(r.expDetails) r.expDetails.classList.toggle('isLocked', !canUseSpinExperience);
      if(r.expLockNotice) r.expLockNotice.hidden = !!canUseSpinExperience;
      if(r.expClassicBtn){ r.expClassicBtn.classList.toggle('isLocked', !canUseSpinExperience); r.expClassicBtn.setAttribute('aria-disabled', canUseSpinExperience ? 'false' : 'true'); }
      if(r.expFakeoutBtn){ r.expFakeoutBtn.classList.toggle('isLocked', !canUseSpinExperience); r.expFakeoutBtn.setAttribute('aria-disabled', canUseSpinExperience ? 'false' : 'true'); }
      if(r.expBlackoutBtn){ r.expBlackoutBtn.classList.toggle('isLocked', !canUseSpinExperience); r.expBlackoutBtn.setAttribute('aria-disabled', canUseSpinExperience ? 'false' : 'true'); }
      if(r.expReactorBtn){ r.expReactorBtn.classList.toggle('isLocked', !canUseSpinExperience); r.expReactorBtn.setAttribute('aria-disabled', canUseSpinExperience ? 'false' : 'true'); }
      if(!canUseSpinExperience && TW.state && TW.state.ui && String(TW.state.ui.spinExperience || 'classic') !== 'classic'){
        TW.state.ui.spinExperience = 'classic';
        try{ syncUIFromState(); }catch(_){ }
      }
      if(r.aiDetails) r.aiDetails.classList.toggle('isLocked', !isPro);
      if(r.aiLockNotice) r.aiLockNotice.hidden = !!isPro;
      if(r.bizDetails) r.bizDetails.classList.toggle('isLocked', !canUseSpinExperience);
      if(r.bizLockNotice) r.bizLockNotice.hidden = true;
      if(r.aiMsg) r.aiMsg.textContent = '';
      if(r.aiUpsellBtn) r.aiUpsellBtn.hidden = true;
      if(r.root){
        r.root.setAttribute('data-user-plan', userPlan);
        r.root.setAttribute('data-wheel-plan', 'free');
      }
      var customizationDismissed = false;
      try{ customizationDismissed = sessionStorage.getItem('twDismissCustomizeOffer') === '1'; }catch(_){ }
      if(r.btnStartEditing) r.btnStartEditing.hidden = customizationDismissed || userPlan === 'vortex_pro';
    };

    // ✅ SURGICAL: reflect current state after UI exists (supports page presets/local/hash)
    syncUIFromState();
    TW.refreshAccessUI && TW.refreshAccessUI();

    TW.renderAll && TW.renderAll();
    window.requestAnimationFrame(function(){ TW.alignVaultToWheelActions && TW.alignVaultToWheelActions(); });
  }

  function bindBasic(){
    var r = R();

    // title/desc inputs -> state
    r.inTitle.addEventListener('input', function(){
      TW.pushUndo();
      TW.state.ui.title = (r.inTitle.value || '').toUpperCase();
      TW.renderHeader && TW.renderHeader();
      TW.saveSoon && TW.saveSoon();
    });
    r.inDesc.addEventListener('input', function(){
      TW.pushUndo();
      TW.state.ui.desc = r.inDesc.value || '';
      TW.renderHeader && TW.renderHeader();
      TW.saveSoon && TW.saveSoon();
    });

    // speed/confetti/countdown
    r.selSpeed.addEventListener('change', function(){
      TW.pushUndo();
      TW.state.ui.speed = r.selSpeed.value;
      TW.saveSoon && TW.saveSoon();
    });
    r.selConfetti.addEventListener('change', function(){
      TW.pushUndo();
      TW.state.ui.confettiOn = r.selConfetti.value;
      TW.saveSoon && TW.saveSoon();
    });

    function canUseSpinBiz(){ return TW.access && TW.access.hasPlan ? TW.access.hasPlan('vortex_pro') : true; }
    function guardSpinBiz(){
      if(canUseSpinBiz()) return true;
      TW.openPlanUpsell && TW.openPlanUpsell('vortex_pro', {
        title:'🎨 Creator Lab is ready…',
        message:'Unlock Vortex Pro for Spin Experiences, promo winner popups, QR codes, popup images, and custom confetti.',
        subtext:'Spin effects • winner popups • QR/image • custom confetti',
        href:'https://spinthewheellab.com/pages/vortexpro'
      });
      return false;
    }
    if(r.bizPopup) r.bizPopup.addEventListener('change', function(){
      if(!guardSpinBiz()){ syncUIFromState(); return; }
      TW.pushUndo();
      TW.state.ui.spinBizPopup = r.bizPopup.value || 'no';
      TW.saveSoon && TW.saveSoon();
      TW.updateSpinBizPreviews && TW.updateSpinBizPreviews();
    });
    if(r.bizPopupMedia) r.bizPopupMedia.addEventListener('change', function(){
      if(!guardSpinBiz()){ syncUIFromState(); return; }
      TW.pushUndo();
      enableCustomWinnerExperience();
      TW.state.ui.spinBizPopupMedia = r.bizPopupMedia.value || 'none';
      TW.saveSoon && TW.saveSoon();
      TW.updateSpinBizPreviews && TW.updateSpinBizPreviews();
    });
    function enableCustomWinnerExperience(){
      if(!TW.state || !TW.state.ui) return;
      TW.state.ui.spinBizPopup = 'yes';
      if(r.bizPopup){ r.bizPopup.value = 'yes'; if(r.bizPopup._twMenuSyncLabel) r.bizPopup._twMenuSyncLabel(); }
    }
    function bindBizValue(el, key, fallback){
      if(!el) return;
      el.addEventListener(el.tagName === 'SELECT' ? 'change' : 'input', function(){
        if(!guardSpinBiz()){ syncUIFromState(); return; }
        if(key.indexOf('spinBizPopup') === 0) enableCustomWinnerExperience();
        TW.state.ui[key] = el.value == null ? fallback : el.value;
        if(key === 'spinBizCelebrationEffect' && TW.syncCreativeEffectOrbs) TW.syncCreativeEffectOrbs();
        if(key === 'spinBizCelebrationColor' && TW.updateCreativeConditionalFields) TW.updateCreativeConditionalFields();
        TW.saveSoon && TW.saveSoon();
      });
    }
    bindBizValue(r.bizPopupStyle, 'spinBizPopupStyle', 'classic');
    bindBizValue(r.bizPopupEntrance, 'spinBizPopupEntrance', 'pop');
    bindBizValue(r.bizPopupHeadline, 'spinBizPopupHeadline', 'Winner!');
    bindBizValue(r.bizPopupMessage, 'spinBizPopupMessage', '');
    bindBizValue(r.bizPopupButton, 'spinBizPopupButton', 'Claim Prize');
    bindBizValue(r.bizCelebrationEffect, 'spinBizCelebrationEffect', 'classic');
    if(r.bizCelebrationEffectOrbs) r.bizCelebrationEffectOrbs.addEventListener('click', function(e){
      var btn = e.target && e.target.closest ? e.target.closest('.tw-creativeEffectOrb') : null;
      if(!btn) return;
      if(!guardSpinBiz()){ syncUIFromState(); return; }
      var effect = btn.getAttribute('data-effect') || 'classic';
      TW.pushUndo();
      TW.state.ui.spinBizCelebrationEffect = effect;
      if(r.bizCelebrationEffect){ r.bizCelebrationEffect.value = effect; if(r.bizCelebrationEffect._twMenuSyncLabel) r.bizCelebrationEffect._twMenuSyncLabel(); }
      TW.syncCreativeEffectOrbs && TW.syncCreativeEffectOrbs();
      TW.saveSoon && TW.saveSoon();
    });
    bindBizValue(r.bizCelebrationIntensity, 'spinBizCelebrationIntensity', 'standard');
    bindBizValue(r.bizCelebrationColor, 'spinBizCelebrationColor', 'wheel');
    function applyCelebrationHex(val){
      if(!guardSpinBiz()){ syncUIFromState(); return; }
      var clean = cleanBizHex(val, 'ff4fa3');
      TW.state.ui.spinBizCelebrationCustomColor = clean;
      if(r.bizCelebrationCustomColor) r.bizCelebrationCustomColor.value = '#' + clean;
      if(r.bizCelebrationCustomHex) r.bizCelebrationCustomHex.value = '#' + clean;
      TW.saveSoon && TW.saveSoon();
    }
    if(r.bizCelebrationCustomColor) r.bizCelebrationCustomColor.addEventListener('input', function(){ applyCelebrationHex(r.bizCelebrationCustomColor.value); });
    if(r.bizCelebrationCustomHex) r.bizCelebrationCustomHex.addEventListener('change', function(){ applyCelebrationHex(r.bizCelebrationCustomHex.value); });
    if(r.bizUrl) r.bizUrl.addEventListener('input', function(){
      if(!guardSpinBiz()){ syncUIFromState(); return; }
      enableCustomWinnerExperience();
      var safe = U.safeHttpUrl ? U.safeHttpUrl(r.bizUrl.value) : String(r.bizUrl.value || '').trim();
      TW.state.ui.spinBizUrl = safe;
      if(safe && String(TW.state.ui.spinBizPopupMedia || 'none') === 'none'){
        TW.state.ui.spinBizPopupMedia = 'qr';
        if(r.bizPopupMedia){ r.bizPopupMedia.value = 'qr'; if(r.bizPopupMedia._twMenuSyncLabel) r.bizPopupMedia._twMenuSyncLabel(); }
      }
      TW.saveSoon && TW.saveSoon();
      TW.updateSpinBizPreviews && TW.updateSpinBizPreviews();
    });
    function finishBizUrlEdit(){
      var safe = U.safeHttpUrl ? U.safeHttpUrl(r.bizUrl.value) : String(r.bizUrl.value || '').trim();
      r.bizUrl.value = safe;
      TW.state.ui.spinBizUrl = safe;
      if(safe && String(TW.state.ui.spinBizPopupMedia || 'none') === 'none'){
        TW.state.ui.spinBizPopupMedia = 'qr';
        if(r.bizPopupMedia){ r.bizPopupMedia.value = 'qr'; if(r.bizPopupMedia._twMenuSyncLabel) r.bizPopupMedia._twMenuSyncLabel(); }
      }
      TW.saveSoon && TW.saveSoon();
      TW.updateSpinBizPreviews && TW.updateSpinBizPreviews();
    }
    if(r.bizUrl) r.bizUrl.addEventListener('change', finishBizUrlEdit);
    if(r.bizUrl) r.bizUrl.addEventListener('blur', finishBizUrlEdit);
    function cleanBizHex(v, fallback){
      v = String(v || '').replace('#','').trim();
      return /^[0-9a-fA-F]{6}$/.test(v) ? v.toLowerCase() : fallback;
    }
    function applyBizHex(which, val){
      if(!guardSpinBiz()){ syncUIFromState(); return; }
      var fallback = which === 'fg' ? '2c0a71' : 'ffffff';
      var clean = cleanBizHex(val, fallback);
      if(which === 'fg'){
        TW.state.ui.spinBizQrFg = clean;
        if(r.bizQrFg) r.bizQrFg.value = '#' + clean;
        if(r.bizQrFgHex) r.bizQrFgHex.value = '#' + clean;
      }else{
        TW.state.ui.spinBizQrBg = clean;
        if(r.bizQrBg) r.bizQrBg.value = '#' + clean;
        if(r.bizQrBgHex) r.bizQrBgHex.value = '#' + clean;
      }
      TW.saveSoon && TW.saveSoon();
      TW.updateSpinBizPreviews && TW.updateSpinBizPreviews();
    }
    if(r.bizQrFg) r.bizQrFg.addEventListener('input', function(){ applyBizHex('fg', r.bizQrFg.value); });
    if(r.bizQrFgHex) r.bizQrFgHex.addEventListener('change', function(){ applyBizHex('fg', r.bizQrFgHex.value); });
    if(r.bizQrBg) r.bizQrBg.addEventListener('input', function(){ applyBizHex('bg', r.bizQrBg.value); });
    if(r.bizQrBgHex) r.bizQrBgHex.addEventListener('change', function(){ applyBizHex('bg', r.bizQrBgHex.value); });
    function rejectUnsafeImageFile(input, error){
      try{ input.value = ''; }catch(_){}
      window.alert(
        (error && error.userMessage) ||
        (error && error.message) ||
        'Please choose a PNG, JPEG, WebP, GIF, HEIC, or HEIF image no larger than 15 MB.'
      );
    }
    if(r.bizQrLogoUrl) r.bizQrLogoUrl.addEventListener('input', function(){
      if(!guardSpinBiz()){ syncUIFromState(); return; }
      TW.state.ui.spinBizQrLogo = U.safeImageSource ? U.safeImageSource(r.bizQrLogoUrl.value) : (r.bizQrLogoUrl.value || '');
      TW.saveSoon && TW.saveSoon();
      TW.updateSpinBizPreviews && TW.updateSpinBizPreviews();
    });
    if(r.bizQrLogoUrl) r.bizQrLogoUrl.addEventListener('blur', function(){
      r.bizQrLogoUrl.value = U.safeImageSource ? U.safeImageSource(r.bizQrLogoUrl.value) : (r.bizQrLogoUrl.value || '');
    });
    if(r.bizQrLogoFile) r.bizQrLogoFile.addEventListener('change', function(){
      if(!guardSpinBiz()){ r.bizQrLogoFile.value = ''; return; }
      var file = r.bizQrLogoFile.files && r.bizQrLogoFile.files[0];
      if(!file) return;
      if(!U.prepareImageFile){ rejectUnsafeImageFile(r.bizQrLogoFile, new Error('The image processor is still loading. Please refresh and try again.')); return; }
      U.prepareImageFile(file, {
        maxDimension:512,
        targetBytes:180 * 1024
      }).then(function(safeImage){
        TW.pushUndo();
        TW.state.ui.spinBizQrLogo = safeImage;
        if(r.bizQrLogoUrl) r.bizQrLogoUrl.value = '';
        TW.saveSoon && TW.saveSoon();
        TW.updateSpinBizPreviews && TW.updateSpinBizPreviews();
      }).catch(function(error){ rejectUnsafeImageFile(r.bizQrLogoFile, error); });
    });
    if(r.bizPopupImageUrl) r.bizPopupImageUrl.addEventListener('input', function(){
      if(!guardSpinBiz()){ syncUIFromState(); return; }
      enableCustomWinnerExperience();
      TW.state.ui.spinBizPopupImage = U.safeImageSource ? U.safeImageSource(r.bizPopupImageUrl.value) : (r.bizPopupImageUrl.value || '');
      TW.saveSoon && TW.saveSoon();
      TW.updateSpinBizPreviews && TW.updateSpinBizPreviews();
    });
    if(r.bizPopupImageUrl) r.bizPopupImageUrl.addEventListener('blur', function(){
      r.bizPopupImageUrl.value = U.safeImageSource ? U.safeImageSource(r.bizPopupImageUrl.value) : (r.bizPopupImageUrl.value || '');
    });
    if(r.bizPopupImageFile) r.bizPopupImageFile.addEventListener('change', function(){
      if(!guardSpinBiz()){ r.bizPopupImageFile.value = ''; return; }
      var file = r.bizPopupImageFile.files && r.bizPopupImageFile.files[0];
      if(!file) return;
      if(!U.prepareImageFile){ rejectUnsafeImageFile(r.bizPopupImageFile, new Error('The image processor is still loading. Please refresh and try again.')); return; }
      U.prepareImageFile(file, {
        maxDimension:1200,
        targetBytes:450 * 1024
      }).then(function(safeImage){
        TW.pushUndo();
        enableCustomWinnerExperience();
        TW.state.ui.spinBizPopupImage = safeImage;
        TW.state.ui.spinBizPopupMedia = 'image';
        if(r.bizPopupMedia){ r.bizPopupMedia.value = 'image'; if(r.bizPopupMedia._twMenuSyncLabel) r.bizPopupMedia._twMenuSyncLabel(); }
        if(r.bizPopupImageUrl) r.bizPopupImageUrl.value = '';
        TW.saveSoon && TW.saveSoon();
        TW.updateSpinBizPreviews && TW.updateSpinBizPreviews();
      }).catch(function(error){ rejectUnsafeImageFile(r.bizPopupImageFile, error); });
    });
    if(r.bizRemovePopupImage) r.bizRemovePopupImage.addEventListener('click', function(){
      if(!guardSpinBiz()) return;
      TW.pushUndo();
      TW.state.ui.spinBizPopupImage = '';
      TW.state.ui.spinBizPopupMedia = TW.state.ui.spinBizUrl ? 'qr' : 'none';
      if(r.bizPopupMedia){ r.bizPopupMedia.value = 'qr'; if(r.bizPopupMedia._twMenuSyncLabel) r.bizPopupMedia._twMenuSyncLabel(); }
      if(r.bizPopupImageUrl) r.bizPopupImageUrl.value = '';
      if(r.bizPopupImageFile){ try{ r.bizPopupImageFile.value = ''; }catch(_){} }
      TW.saveSoon && TW.saveSoon();
      TW.updateSpinBizPreviews && TW.updateSpinBizPreviews();
    });
    if(r.bizConfettiMode) r.bizConfettiMode.addEventListener('change', function(){
      if(!guardSpinBiz()){ syncUIFromState(); return; }
      TW.pushUndo();
      TW.state.ui.spinBizConfettiMode = r.bizConfettiMode.value || 'standard';
      TW.updateCreativeConditionalFields && TW.updateCreativeConditionalFields();
      TW.saveSoon && TW.saveSoon();
      TW.updateSpinBizPreviews && TW.updateSpinBizPreviews();
    });
    if(r.bizConfettiUrl) r.bizConfettiUrl.addEventListener('input', function(){
      if(!guardSpinBiz()){ syncUIFromState(); return; }
      TW.state.ui.spinBizConfettiImage = U.safeImageSource ? U.safeImageSource(r.bizConfettiUrl.value) : (r.bizConfettiUrl.value || '');
      TW.saveSoon && TW.saveSoon();
      TW.updateSpinBizPreviews && TW.updateSpinBizPreviews();
    });
    if(r.bizConfettiUrl) r.bizConfettiUrl.addEventListener('blur', function(){
      r.bizConfettiUrl.value = U.safeImageSource ? U.safeImageSource(r.bizConfettiUrl.value) : (r.bizConfettiUrl.value || '');
    });
    if(r.bizConfettiFile) r.bizConfettiFile.addEventListener('change', function(){
      if(!guardSpinBiz()){ r.bizConfettiFile.value = ''; return; }
      var file = r.bizConfettiFile.files && r.bizConfettiFile.files[0];
      if(!file) return;
      if(!U.prepareImageFile){ rejectUnsafeImageFile(r.bizConfettiFile, new Error('The image processor is still loading. Please refresh and try again.')); return; }
      U.prepareImageFile(file, {
        maxDimension:640,
        targetBytes:220 * 1024
      }).then(function(safeImage){
        TW.pushUndo();
        TW.state.ui.spinBizConfettiImage = safeImage;
        TW.state.ui.spinBizConfettiMode = 'logo';
        if(r.bizConfettiMode){ r.bizConfettiMode.value = 'logo'; if(r.bizConfettiMode._twMenuSyncLabel) r.bizConfettiMode._twMenuSyncLabel(); }
        if(r.bizConfettiUrl) r.bizConfettiUrl.value = '';
        TW.saveSoon && TW.saveSoon();
        TW.updateSpinBizPreviews && TW.updateSpinBizPreviews();
      }).catch(function(error){ rejectUnsafeImageFile(r.bizConfettiFile, error); });
    });
    if(r.bizRemoveQrLogo) r.bizRemoveQrLogo.addEventListener('click', function(){
      if(!guardSpinBiz()) return;
      TW.pushUndo();
      TW.state.ui.spinBizQrLogo = '';
      if(r.bizQrLogoUrl) r.bizQrLogoUrl.value = '';
      if(r.bizQrLogoFile){ try{ r.bizQrLogoFile.value = ''; }catch(_){} }
      TW.saveSoon && TW.saveSoon();
      TW.updateSpinBizPreviews && TW.updateSpinBizPreviews();
    });
    if(r.bizRemoveConfetti) r.bizRemoveConfetti.addEventListener('click', function(){
      if(!guardSpinBiz()) return;
      TW.pushUndo();
      TW.state.ui.spinBizConfettiMode = 'standard';
      TW.state.ui.spinBizConfettiImage = '';
      if(r.bizConfettiMode){ r.bizConfettiMode.value = 'standard'; if(r.bizConfettiMode._twMenuSyncLabel) r.bizConfettiMode._twMenuSyncLabel(); }
      if(r.bizConfettiUrl) r.bizConfettiUrl.value = '';
      if(r.bizConfettiFile){ try{ r.bizConfettiFile.value = ''; }catch(_){} }
      TW.saveSoon && TW.saveSoon();
      TW.updateSpinBizPreviews && TW.updateSpinBizPreviews();
    });
    r.selCountdownOn.addEventListener('change', function(){
      TW.pushUndo();
      TW.state.ui.countdownOn = r.selCountdownOn.value;
      TW.saveSoon && TW.saveSoon();
    });
    r.inCountdownSec.addEventListener('change', function(){
      var v = parseInt(r.inCountdownSec.value||'3',10);
      v = U.clamp(isNaN(v)?3:v, 1, 10);
      TW.pushUndo();
      TW.state.ui.countdownSec = v;
      r.inCountdownSec.value = String(v);
      TW.saveSoon && TW.saveSoon();
    });

    function setSpinExperience(id){
      id = id || 'classic';
      if(!(TW.access && TW.access.hasPlan && TW.access.hasPlan('vortex_pro'))){
        TW.openPlanUpsell && TW.openPlanUpsell('vortex_pro', {
          title:'🎨 Creator Lab is ready…',
          message:'Unlock Vortex Pro for Spin Experiences, promo winner popups, QR codes, popup images, and custom confetti.',
          subtext:'Spin effects • winner popups • QR/image • custom confetti',
          href:'https://spinthewheellab.com/pages/vortexpro'
        });
        return;
      }
      TW.pushUndo();
      TW.state.ui.spinExperience = id;
      syncUIFromState();
      TW.saveSoon && TW.saveSoon();
    }
    if(r.expClassicBtn) r.expClassicBtn.addEventListener('click', function(){ setSpinExperience('classic'); });
    if(r.expFakeoutBtn) r.expFakeoutBtn.addEventListener('click', function(){ setSpinExperience('fakeout_frenzy'); });
    if(r.expBlackoutBtn) r.expBlackoutBtn.addEventListener('click', function(){ setSpinExperience('blackout_drop'); });
    if(r.expReactorBtn) r.expReactorBtn.addEventListener('click', function(){ setSpinExperience('reactor_surge'); });

    // sounds & volumes
    r.selSpinSound.addEventListener('change', function(){
      TW.pushUndo();
      TW.state.ui.spinSoundId = r.selSpinSound.value;
      TW.saveSoon && TW.saveSoon();
    });
    r.selWinSound.addEventListener('change', function(){
      TW.pushUndo();
      TW.state.ui.winSoundId = r.selWinSound.value;
      TW.saveSoon && TW.saveSoon();
    });
    if(r.rangeSpinVol) r.rangeSpinVol.addEventListener('input', function(){
      TW.state.ui.spinVolume = parseFloat(r.rangeSpinVol.value);
      TW.saveSoon && TW.saveSoon();
    });
    if(r.rangeWinVol) r.rangeWinVol.addEventListener('input', function(){
      TW.state.ui.winVolume = parseFloat(r.rangeWinVol.value);
      TW.saveSoon && TW.saveSoon();
    });
    if(r.rangeVoiceVol) r.rangeVoiceVol.addEventListener('input', function(){
      TW.state.ui.voiceVolume = parseFloat(r.rangeVoiceVol.value);
      TW.saveSoon && TW.saveSoon();
    });

    r.inWinnerPhrase.addEventListener('input', function(){
      TW.pushUndo();
      TW.state.ui.winnerPhrase = r.inWinnerPhrase.value || '';
      TW.saveSoon && TW.saveSoon();
    });

    // Options add one — Enter still works (desktop) + button works (mobile)
    function doAddOne(){
      var v = (r.optAddOne.value||'').trim();
      if(!v) return;
      TW.addSegments && TW.addSegments([v]);
      r.optAddOne.value = '';
    }
    r.optAddOne.addEventListener('keydown', function(e){
      if(e.key === 'Enter'){
        e.preventDefault();
        doAddOne();
      }
    });
    r.btnAddOneSeg.addEventListener('click', function(){
      doAddOne();
    });

    // bulk add
    r.btnBulkAdd.addEventListener('click', function(){
      var raw = r.optBulk.value || '';
      if(!raw.trim()) return;
      var parts = raw.split(/[\n,]+/g).map(function(s){ return (s||'').trim(); }).filter(Boolean);
      if(!parts.length) return;
      var result = TW.addSegments ? TW.addSegments(parts) : null;
      if(result && result.skipped > 0){
        alert('Added ' + result.added.toLocaleString() + ' entries. ' + result.skipped.toLocaleString() + ' were not added because this wheel supports up to 1,000 entries.');
      }
      r.optBulk.value = '';
    });

    function parseEntryFile(text, fileName){
      text = String(text == null ? '' : text).replace(/^\uFEFF/, '');
      var lowerName = String(fileName || '').toLowerCase();
      var delimiter = lowerName.endsWith('.tsv') || text.indexOf('\t') !== -1 ? '\t' : ',';
      if(delimiter === '\t'){
        return text.split(/\r?\n/).map(function(line){ return String(line.split('\t')[0] || '').trim(); }).filter(Boolean);
      }
      var rows = [], cell = '', row = [], quoted = false;
      for(var i=0; i<text.length; i++){
        var ch = text.charAt(i);
        if(ch === '"'){
          if(quoted && text.charAt(i + 1) === '"'){ cell += '"'; i++; }
          else quoted = !quoted;
        }else if(ch === ',' && !quoted){ row.push(cell); cell = ''; }
        else if((ch === '\n' || ch === '\r') && !quoted){
          if(ch === '\r' && text.charAt(i + 1) === '\n') i++;
          row.push(cell); rows.push(row); row = []; cell = '';
        }else cell += ch;
      }
      row.push(cell); rows.push(row);
      var names = rows.map(function(columns){ return String(columns[0] || '').trim(); }).filter(Boolean);
      if(names.length && /^(name|names|entry|entries|segment|segments|option|options)$/i.test(names[0])) names.shift();
      return names;
    }

    r.btnImportEntries.addEventListener('click', function(){ r.entryFileInput.click(); });
    r.entryFileInput.addEventListener('change', function(){
      var file = r.entryFileInput.files && r.entryFileInput.files[0];
      if(!file) return;
      var reader = new FileReader();
      reader.onload = function(){
        var names = parseEntryFile(reader.result, file.name);
        if(!names.length){ alert('No entries were found in the first column of that file.'); r.entryFileInput.value = ''; return; }
        var result = TW.addSegments ? TW.addSegments(names) : null;
        if(result && result.skipped > 0){
          alert('Imported ' + result.added.toLocaleString() + ' entries. ' + result.skipped.toLocaleString() + ' were skipped because this wheel supports up to 1,000 entries.');
        }
        r.entryFileInput.value = '';
      };
      reader.onerror = function(){ alert('That file could not be read. Please try CSV, TSV, or TXT.'); r.entryFileInput.value = ''; };
      reader.readAsText(file);
    });

    r.btnShuffle.addEventListener('click', function(){
      TW.shuffleSegments && TW.shuffleSegments();
    });
    r.btnSortAZ.addEventListener('click', function(){
      TW.sortSegments && TW.sortSegments(true);
    });
    r.btnSortZA.addEventListener('click', function(){
      TW.sortSegments && TW.sortSegments(false);
    });
    r.btnRemoveDuplicates.addEventListener('click', function(){
      TW.removeDuplicateSegments && TW.removeDuplicateSegments();
    });
    r.btnClearSegs.addEventListener('click', function(){
      TW.clearSegments && TW.clearSegments();
    });


    // =========================
    // Vortex AI V1 (client UI + safe formatting). Endpoint wiring required.
    // =========================
    (function initVortexAI(){
      if(!r.aiDetails) return;

      try{
        if(!document.querySelector('style[data-tw-ai-icons="1"]')){
          var aiSt = document.createElement('style');
          aiSt.setAttribute('data-tw-ai-icons','1');
          aiSt.textContent = [
            '.tw-aiBodyStack{display:flex;flex-direction:column;gap:18px;}',
            '.tw-aiSmartOptions{display:grid;grid-template-columns:minmax(0,1fr);align-items:start;row-gap:18px;width:100%;}.tw-aiSmartOptions>.tw-field{display:flex!important;flex-direction:column!important;align-items:stretch!important;width:100%!important;min-width:0;margin:0!important;}.tw-aiSmartOptions>.tw-field>label{display:block!important;height:auto!important;min-height:0!important;line-height:1.1!important;margin:0 0 7px!important;}.tw-aiSmartOptions .tw-selectWrap{display:block!important;width:100%!important;height:48px!important;min-height:48px!important;margin:0!important;}.tw-aiSmartOptions .tw-select,.tw-aiSmartOptions .tw-selectMenu{box-sizing:border-box!important;width:100%!important;height:48px!important;min-height:48px!important;margin:0!important;padding:11px 12px!important;border-radius:14px!important;font-size:14px!important;line-height:1.18!important;font-weight:800!important;}.tw-aiSmartOptions>.tw-field>.tw-mini{margin:9px 0 0!important;line-height:1.45!important;}',
            '.tw-aiTopic{box-sizing:border-box;height:132px;min-height:132px;max-height:132px;resize:none;}.tw-aiPromptTools{gap:10px!important;align-items:center;margin-top:9px!important;}.tw-aiPromptCount{margin-left:auto;}.tw-aiReview{display:grid;gap:14px;}.tw-aiReview[hidden]{display:none!important;}.tw-aiReviewCard{display:grid;grid-template-columns:18px minmax(0,1fr) 112px;gap:14px;align-items:start;padding:16px;border:1px solid rgba(64,18,104,.14);border-radius:14px;background:rgba(255,255,255,.72);}.tw-aiReviewSwatch{width:18px;height:18px;border-radius:999px;margin-top:18px;box-shadow:inset 0 0 0 1px rgba(0,0,0,.12);}.tw-aiReviewFields{display:grid;gap:18px;}.tw-aiEditField{display:flex!important;flex-direction:column!important;gap:10px!important;margin:0!important;padding:0!important;background:transparent!important;}.tw-aiEditField span{display:block;font-size:12px;line-height:1.1;font-weight:900;color:#2c0a71;letter-spacing:.4px;}.tw-aiEditField input,.tw-aiEditField textarea{width:100%;box-sizing:border-box;border:1px solid rgba(64,18,104,.18);border-radius:14px;background:#fff;color:#401268;padding:11px 12px;font:inherit;font-size:14px;line-height:1.3;font-weight:700;}.tw-aiEditField input{min-height:48px;}.tw-aiEditField textarea{resize:vertical;min-height:72px;}.tw-aiReviewSticker{display:grid;gap:9px;justify-items:center;font-size:12px;font-weight:800;color:#cc007e;text-align:center;}.tw-aiStickerPreview{width:80px;height:80px;object-fit:contain;border-radius:14px;background:rgba(255,255,255,.8);opacity:.58;transition:opacity .16s ease,box-shadow .16s ease,transform .16s ease;}.tw-aiReviewSticker.isSelected .tw-aiStickerPreview{opacity:1;box-shadow:0 0 0 3px #f77f00;transform:scale(1.03);}.tw-aiStickerChoice{min-height:40px!important;padding:8px 10px!important;font-size:12px!important;background:#fff!important;color:#401268!important;}.tw-aiStickerChoice.isSelected{background:#f77f00!important;color:#000!important;box-shadow:none!important;}.tw-aiStickerEmpty{font-size:12px;color:rgba(64,18,104,.65);padding-top:18px;}.tw-aiReviewPlaceholder{padding:16px;border:1px dashed rgba(64,18,104,.24);border-radius:14px;background:rgba(255,255,255,.48);}.tw-aiPlaceholderTitle{font-weight:900;color:#2c0a71;}.tw-aiPlaceholderText{font-size:13px;line-height:1.45;color:rgba(64,18,104,.72);margin-top:8px;}.tw-aiPlaceholderRows{display:grid;gap:9px;margin-top:14px;}.tw-aiPlaceholderRow{height:44px;border-radius:14px;background:linear-gradient(90deg,rgba(44,10,113,.07),rgba(204,0,126,.08),rgba(44,10,113,.07));}',
            '.tw-modal.hasVortexContent{width:min(94vw,720px);max-height:min(90vh,820px);overflow-y:auto;}.tw-vortexWinnerTitle{line-height:1!important;}.tw-vortexWinnerDetail{max-width:620px;margin-left:auto;margin-right:auto;overflow-wrap:anywhere;}.tw-vortexRevealBtn{display:flex!important;margin:2px auto 12px!important;justify-content:center;}',
            '.tw-aiDoctor{padding:13px 14px;border-radius:14px;background:linear-gradient(135deg,rgba(44,10,113,.96),rgba(204,0,126,.9));color:#fff8ee;}.tw-aiDoctorTitle{font-size:12px;font-weight:900;letter-spacing:.12em;}.tw-aiDoctorText{font-size:13px;line-height:1.45;margin-top:4px;}',
            '.tw-aiLaneDescription{position:relative;margin-top:18px;padding:20px;border-radius:16px;background:#fff8ee;border:1px solid rgba(44,10,113,.18);color:#401268;font-size:14px;line-height:1.5;font-weight:700;box-shadow:0 14px 30px rgba(44,10,113,.14);}.tw-aiLaneDescription[hidden]{display:none!important;}.tw-aiLaneDescription strong{display:block;font-size:19px;margin:0 42px 5px 0;}.tw-aiLaneChoiceActions{display:flex;gap:10px;margin-top:16px;}.tw-aiLaneClose{appearance:none!important;position:absolute!important;right:10px;top:10px;display:grid!important;place-items:center!important;box-sizing:border-box!important;inline-size:34px!important;block-size:34px!important;min-inline-size:34px!important;min-block-size:34px!important;max-inline-size:34px!important;max-block-size:34px!important;padding:0!important;margin:0!important;border:1px solid rgba(64,18,104,.18)!important;border-radius:50%!important;background:#fff!important;color:#401268!important;-webkit-text-fill-color:#401268!important;font:900 22px/1 Arial,sans-serif!important;box-shadow:0 5px 12px rgba(44,10,113,.12)!important;cursor:pointer!important;}.tw-aiLaneUse{background:#cc007e!important;color:#fff8ee!important;-webkit-text-fill-color:#fff8ee!important;}.tw-aiSuccess{padding:20px;border-radius:18px;background:linear-gradient(135deg,#fff8ee,#fff);border:2px solid rgba(204,0,126,.18);box-shadow:0 14px 34px rgba(44,10,113,.12);}.tw-aiSuccess[hidden]{display:none!important;}.tw-aiSuccessTitle{font-size:24px;line-height:1.15;font-weight:900;color:#2c0a71;}.tw-aiSuccessFacts{display:grid;gap:7px;margin:14px 0;color:#401268;font-weight:750;}.tw-aiSuccessFact::before{content:"✓";color:#1b8f52;font-weight:900;margin-right:8px;}.tw-aiSuccessActions{display:flex;gap:10px;flex-wrap:wrap;margin-top:16px;}.tw-aiSuccessActions .tw-btn{min-height:50px;font-size:15px;}.tw-aiSuccessActions .tw-btn:not(.tw-btnPrimary){background:#fff!important;color:#401268!important;-webkit-text-fill-color:#401268!important;border:1px solid rgba(64,18,104,.24)!important;}.tw-aiCheck{margin-top:14px;display:inline-flex;align-items:center;gap:7px;padding:8px 11px;border-radius:999px;background:#e8f8ef;color:#17653d;font-size:12px;font-weight:900;}.tw-aiReviewDetails{margin-top:14px;border:1px solid rgba(44,10,113,.14);border-radius:16px;background:rgba(255,255,255,.52);overflow:hidden;}.tw-aiReviewDetails[hidden]{display:none!important;}.tw-aiCardActions{grid-column:2;display:grid;grid-template-columns:repeat(3,minmax(0,1fr));align-items:stretch;gap:7px;margin-top:4px;width:100%;max-width:100%;}.tw-aiCardAction{width:100%!important;min-height:34px!important;padding:6px 7px!important;font-size:11px!important;background:#fff!important;color:#401268!important;-webkit-text-fill-color:#401268!important;border:1px solid rgba(64,18,104,.18)!important;}.tw-aiCardAction.isLocked{background:#2c0a71!important;color:#fff!important;-webkit-text-fill-color:#fff!important;}.tw-aiReviewCard.isLocked{outline:2px solid rgba(44,10,113,.42);}.tw-btnSurprise{background:linear-gradient(135deg,#ffd84d,#f77f00)!important;color:#24103d!important;}',
            '.tw-aiFieldStack{width:100%;margin:0;}',
            '.tw-aiQuickActions{padding:14px;border:1px solid rgba(64,18,104,.18);border-radius:16px;background:#fff8ee;color:#401268;box-shadow:0 10px 24px rgba(44,10,113,.09);}.tw-aiQuickActions>label{color:#401268!important;}.tw-aiPrimaryActionRow{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px!important;}.tw-aiAdvancedDetails{border:1px solid #401268;border-radius:16px;background:#fff8ee;overflow:hidden;box-shadow:0 12px 28px rgba(44,10,113,.14);}.tw-aiAdvancedDetails>summary{cursor:pointer;padding:17px 18px;background:linear-gradient(135deg,#401268,#2c0a71);color:#fff8ee!important;-webkit-text-fill-color:#fff8ee!important;font-weight:900;list-style:none;}.tw-aiAdvancedDetails>summary::-webkit-details-marker{display:none;}.tw-aiAdvancedDetails>summary::after{content:"+";float:right;color:#ffd84d;font-size:21px;line-height:1;}.tw-aiAdvancedDetails[open]>summary::after{content:"−";}.tw-aiAdvancedBody{display:grid;gap:18px;padding:4px 16px 18px;background:#fff8ee;color:#401268;}.tw-aiAdvancedBody .tw-aiSmartOptions{padding-top:14px;border-top:1px solid rgba(64,18,104,.16);}.tw-aiAdvancedBody label,.tw-aiAdvancedBody .tw-mini{color:#401268!important;-webkit-text-fill-color:#401268!important;}.tw-aiAdvancedBody .tw-select,.tw-aiAdvancedBody .tw-selectMenu,.tw-aiAdvancedBody .tw-selectWrap{background:#fff!important;color:#401268!important;-webkit-text-fill-color:#401268!important;}',
            '.tw-aiCountTools{margin-top:10px;display:flex;gap:12px;align-items:center;flex-wrap:wrap;}',
            '.tw-aiLaneSection{margin-top:14px;}',
            '.tw-aiLaneHeading{margin:0 0 18px 4px;font-size:12px;letter-spacing:.08em;text-transform:uppercase;opacity:.82;}',
            '.tw-aiLaneGrid{display:grid;grid-template-columns:repeat(auto-fit,minmax(168px,1fr));gap:24px 28px;align-items:start;overflow:visible;padding:0;}',
            '.tw-aiIconPill{position:relative;display:flex;align-items:center;justify-content:center;min-height:176px;padding:22px 12px 26px;border:0;background:transparent !important;box-shadow:none !important;font-family:Fredoka,system-ui,sans-serif;transition:transform .18s ease, filter .18s ease, opacity .18s ease;overflow:visible;}',
            '.tw-aiIconPill::before{content:"";position:absolute;left:50%;top:50%;width:104px;height:104px;border-radius:999px;background:radial-gradient(circle, rgba(242,140,140,0.44) 0%, rgba(242,140,140,0.20) 38%, rgba(242,140,140,0.00) 72%);transform:translate(-50%,-50%) scale(1);filter:blur(16px);opacity:.96;pointer-events:none;transition:transform .22s ease, opacity .22s ease, filter .22s ease;}',
            '.tw-aiIconPill:hover{transform:translateY(-4px) scale(1.045);filter:brightness(1.04);}',
            '.tw-aiIconPill:hover::before{transform:translate(-50%,-50%) scale(1.22);opacity:1;filter:blur(20px);}',
            '.tw-aiIconPill.isActive{transform:translateY(-3px) scale(1.065);}',
            '.tw-aiIconPill.isActive::before{width:132px;height:132px;background:radial-gradient(circle, rgba(242,140,140,0.74) 0%, rgba(242,140,140,0.34) 42%, rgba(242,140,140,0.00) 76%);opacity:1;filter:blur(22px);}',
            '.tw-aiIconImg{position:relative;z-index:1;width:148px;height:148px;display:block;object-fit:contain;filter:drop-shadow(0 16px 30px rgba(0,0,0,0.24));}',
            '.tw-aiIconText{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;}',
            '.tw-aiActionRow,.tw-aiApplyRow{gap:10px 12px;}.tw-aiActionRow .tw-btn:not(.tw-btnReport),.tw-aiApplyRow .tw-btn:not(.tw-btnPrimary){background:#fff!important;color:#401268!important;-webkit-text-fill-color:#401268!important;border-color:rgba(64,18,104,.20)!important;}',
            '.tw-aiFootnote{margin-top:2px;}',
            '.tw-aiThinking{position:fixed;inset:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;padding:0;border:0;background:transparent !important;box-shadow:none !important;backdrop-filter:none !important;-webkit-backdrop-filter:none !important;pointer-events:none;animation:twAiThinkPulse 1.75s ease-in-out infinite;}',
            '.tw-aiThinking::before{content:"";position:absolute;left:50%;top:50%;width:min(32vw, 320px);height:min(32vw, 320px);border-radius:50%;background:radial-gradient(circle, rgba(242,140,140,0.64) 0%, rgba(242,140,140,0.30) 38%, rgba(242,140,140,0.10) 58%, rgba(242,140,140,0.00) 78%);transform:translate(-50%,-50%) scale(1);filter:blur(22px);opacity:1;pointer-events:none;animation:twAiGlowPulse 1.75s ease-in-out infinite;}',
            '.tw-aiThinking[hidden]{display:none !important;}',
            '.tw-aiThinkingIcon{position:relative;z-index:1;width:clamp(156px, 18vw, 248px);height:clamp(156px, 18vw, 248px);display:block;object-fit:contain;filter:drop-shadow(0 18px 34px rgba(0,0,0,0.24));animation:twAiWiggle 1.2s ease-in-out infinite;transform-origin:50% 56%;}',
            '.tw-aiThinkingText{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;}',
            '@keyframes twAiWiggle{0%,100%{transform:rotate(-4deg) scale(1);}50%{transform:rotate(4deg) scale(1.06);}}',
            '@keyframes twAiThinkPulse{0%,100%{opacity:1;}50%{opacity:1;}}',
            '@keyframes twAiGlowPulse{0%,100%{opacity:.92;transform:translate(-50%,-50%) scale(1);}50%{opacity:1;transform:translate(-50%,-50%) scale(1.14);}}',
            '@media (max-width:980px){.tw-aiLaneGrid{grid-template-columns:repeat(4,minmax(0,1fr));gap:16px 18px;}.tw-aiIconPill{min-height:156px;padding:14px 8px 18px;}.tw-aiIconImg{width:132px;height:132px;}}',
            '@media (max-width:640px){.tw-aiReviewCard{grid-template-columns:18px minmax(0,1fr);}.tw-aiReviewSticker{grid-column:2;grid-template-columns:80px auto;align-items:center;justify-content:start;}.tw-aiSmartOptions>.tw-field{width:100%;}}',
            '@media (max-width:640px){.tw-aiSmartOptions{grid-template-columns:1fr;}.tw-aiBodyStack{gap:16px;}.tw-aiLaneGrid{grid-template-columns:repeat(3,minmax(0,1fr));gap:10px 10px;}.tw-aiIconPill{min-height:106px;padding:8px 2px 10px;}.tw-aiIconPill::before{width:68px;height:68px;filter:blur(12px);}.tw-aiIconPill.isActive::before{width:88px;height:88px;filter:blur(16px);}.tw-aiIconImg{width:84px;height:84px;}.tw-aiLaneHeading{margin:0 0 12px 2px;}.tw-aiCountTools{gap:10px;}.tw-aiThinking::before{width:min(58vw, 240px);height:min(58vw, 240px);}.tw-aiThinkingIcon{width:clamp(132px, 34vw, 196px);height:clamp(132px, 34vw, 196px);}}@media (max-width:430px){.tw-aiLaneGrid{grid-template-columns:repeat(3,minmax(0,1fr)) !important;gap:8px 8px;}.tw-aiIconPill{min-height:92px;padding:6px 1px 8px;}.tw-aiIconPill::before{width:58px;height:58px;filter:blur(11px);}.tw-aiIconPill.isActive::before{width:76px;height:76px;filter:blur(14px);}.tw-aiIconImg{width:72px;height:72px;}.tw-aiPrimaryActionRow{grid-template-columns:1fr 1fr;}.tw-aiThinking::before{width:min(64vw, 220px);height:min(64vw, 220px);}.tw-aiThinkingIcon{width:clamp(118px, 32vw, 172px);height:clamp(118px, 32vw, 172px);}}',
          ].join('');
          document.head.appendChild(aiSt);
        }
      }catch(e){}

      var isPro = (TW.isPro && TW.isPro());
      function setDisabled(dis){
        var els = [r.aiTopic, r.aiCountCustom, r.btnAIGenerate, r.btnAIRefine, r.btnAIMakeShorter, r.btnAIMakeHarder, r.btnAIReport, r.aiOut, r.btnAIApplyReplace, r.btnAIApplyAdd];
        for(var i=0;i<els.length;i++){
          if(!els[i]) continue;
          if(dis) els[i].setAttribute('disabled',''); else els[i].removeAttribute('disabled');
        }
        // pills
        var modeEls = r.aiModeWrap ? r.aiModeWrap.querySelectorAll('button') : [];
        for(var j=0;j<modeEls.length;j++) modeEls[j].disabled = dis;
        var pillEls = r.aiToneWrap ? r.aiToneWrap.querySelectorAll('button') : [];
        for(var jj=0;jj<pillEls.length;jj++) pillEls[jj].disabled = dis;
        var cntPills = r.aiCountWrap ? r.aiCountWrap.querySelectorAll('button') : [];
        for(var k=0;k<cntPills.length;k++) cntPills[k].disabled = dis;
      }

      // Build count pills
      var countPresets = [4,6,8,10,12];
      var selectedCount = 6;
      function clampCount(n){
        n = parseInt(n,10);
        if(!isFinite(n) || n<1) n=1;
        var maxN = 12;
        if(n>maxN) n=maxN;
        return n;
      }
      function syncCountPills(){
        if(r.aiCountWrap){
          var btns = r.aiCountWrap.querySelectorAll('button');
          for(var i=0;i<btns.length;i++){
            var v = parseInt(btns[i].getAttribute('data-count')||'0',10);
            if(v === selectedCount) btns[i].classList.add('isActive');
            else btns[i].classList.remove('isActive');
          }
        }
      }
      function setCount(n, opts){
        opts = opts || {};
        selectedCount = clampCount(n);
        if(r.aiCountCustom && opts.updateInput !== false) r.aiCountCustom.value = String(selectedCount);
        syncCountPills();
      }
      function commitCustomCount(){
        if(!r.aiCountCustom) return;
        var raw = String(r.aiCountCustom.value || '').trim();
        if(raw === ''){
          setCount(selectedCount || 1);
          return;
        }
        setCount(raw);
      }
      if(r.aiCountWrap){
        r.aiCountWrap.innerHTML='';
        countPresets.forEach(function(n){
          var b = U.el('button',{ class:'tw-pill', type:'button' }, [String(n)]);
          b.setAttribute('data-count', String(n));
          b.addEventListener('click', function(){
            r.aiCountCustom.style.display='none';
            setCount(n);
          });
          r.aiCountWrap.appendChild(b);
        });
      }
      if(r.aiCountCustomLink){
        r.aiCountCustomLink.addEventListener('click', function(){
          r.aiCountCustom.style.display = (r.aiCountCustom.style.display==='none'?'block':'none');
          r.aiCountCustom.focus();
          r.aiCountCustom.select && r.aiCountCustom.select();
        });
      }
      if(r.aiCountCustom){
        r.aiCountCustom.addEventListener('input', function(){
          var raw = String(r.aiCountCustom.value || '').trim();
          if(raw === ''){
            selectedCount = null;
            syncCountPills();
            return;
          }
          var parsed = parseInt(raw, 10);
          if(!isFinite(parsed)){
            selectedCount = null;
            syncCountPills();
            return;
          }
          selectedCount = clampCount(parsed);
          syncCountPills();
        });
        r.aiCountCustom.addEventListener('blur', commitCustomCount);
        r.aiCountCustom.addEventListener('keydown', function(ev){
          if(ev && ev.key === 'Enter'){
            commitCustomCount();
            try{ r.aiCountCustom.blur(); }catch(_){ }
          }
        });
      }
      setCount(selectedCount);

      // Lane pills (choose one mode OR one personality)
      var modeLanes = [
        { id:'direct', label:'Direct Mode', icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexaidirectmodeicon_5db73e0c-eb62-4506-b3be-853787b218d9.png?v=1774379953' },
        { id:'math', label:'Math Mode', icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexaimathmodeicon_cb838199-6555-4dfb-ada9-07f837189fad.png?v=1774379939' },
        { id:'teacher', label:'Teacher Mode', icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexaiteachermodeicon_6ac9a7bc-ab7c-4eef-9668-f118c7f2b4cd.png?v=1774379962' },
        { id:'study', label:'Study Mode', icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexaistudymodeicon_47ff1782-c83c-4ac1-ae10-8887d42d6d08.png?v=1774379975' },
        { id:'creative', label:'Creative Mode', icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexaicreativeicon_c3b4a7f9-f5d6-483a-8ab2-421d2b781fd5.png?v=1774457041' }
      ];
      var personalityLanes = [
        { id:'showman', label:'Showman', icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexaishowmanicon_373cf4de-f1c5-438f-9607-e3efb91eb876.png?v=1774376751' },
        { id:'scholar', label:'Scholar', icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexaischolaricon_9d9c68df-5537-476f-9fc8-8f2e4780a5a2.png?v=1774376652' },
        { id:'poet', label:'Poet', icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexaipoeticon_60453f25-536a-4426-8020-0175cfb04614.png?v=1774376529' },
        { id:'trickster', label:'Trickster', icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexaitrickstericon_e6530f51-dab9-4fca-9df3-d4389949a216.png?v=1774376770' },
        { id:'ringmaster', label:'Ringmaster', icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexairingmastericon_ea74f832-0b0e-46a2-aa2c-ab4f35252db4.png?v=1774376541' },
        { id:'alchemist', label:'Alchemist', icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexaialchemisticon_61505dcd-c9d0-41c7-b612-d8b490271810.png?v=1774376011' },
        { id:'cartographer', label:'Cartographer', icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexaicartographericon_2c4bc2c4-464e-4efd-97f1-7ea2877e4862.png?v=1774377336' },
        { id:'arcadebrain', label:'Arcade Brain', icon:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexaiarcadeicon.png?v=1774377354' }
      ];
      var laneDescriptionMap = {
        direct:'Fast, practical results with clear, immediately usable wording.',
        study:'Learning-oriented content built for recall and review.',
        teacher:'Classroom-ready wheels with practical, age-aware prompts.',
        math:'Correct problems, practice items, and verified answer reveals.',
        creative:'Imaginative concepts that stay coherent and on topic.',
        showman:'High-energy, crowd-pleasing results for lively reveals.',
        scholar:'Precise, polished content with thoughtful distinctions.',
        poet:'Vivid, expressive language that keeps the meaning clear.',
        trickster:'Witty, surprising twists that remain useful and safe.',
        ringmaster:'Theatrical, event-ready wording with dramatic momentum.',
        alchemist:'Transforms ordinary ideas into richer, more inventive concepts.',
        cartographer:'Structured, practical results with clear coverage.',
        arcadebrain:'Snappy, game-like challenges with bold, compact phrasing.'
      };
      var laneLabelMap = {};
      modeLanes.concat(personalityLanes).forEach(function(item){ laneLabelMap[item.id] = item.label; });
      function makeLaneButton(item){
        var description = laneDescriptionMap[item.id] || '';
        return U.el('button',{ class:'tw-pill tw-aiIconPill', type:'button', title:item.label + (description ? ' — ' + description : ''), 'aria-label':item.label + (description ? ': ' + description : '') }, [
          U.el('img', { class:'tw-aiIconImg', alt:item.label, src:item.icon }),
          U.el('span', { class:'tw-aiIconText', text:item.label })
        ]);
      }
      var selectedLaneType = 'mode';
      var selectedLane = 'direct';
      function setLane(type, id){
        selectedLaneType = type || 'mode';
        selectedLane = id || 'direct';
        if(r.aiModeWrap){
          var modeBtns = r.aiModeWrap.querySelectorAll('button');
          for(var i=0;i<modeBtns.length;i++){
            var v = modeBtns[i].getAttribute('data-lane');
            if(selectedLaneType === 'mode' && v === selectedLane) modeBtns[i].classList.add('isActive');
            else modeBtns[i].classList.remove('isActive');
          }
        }
        if(r.aiToneWrap){
          var toneBtns = r.aiToneWrap.querySelectorAll('button');
          for(var j=0;j<toneBtns.length;j++){
            var t = toneBtns[j].getAttribute('data-lane');
            if(selectedLaneType === 'personality' && t === selectedLane) toneBtns[j].classList.add('isActive');
            else toneBtns[j].classList.remove('isActive');
          }
        }
      }
      function openLaneChoice(type, item){
        if(!r.aiLaneDescription) return;
        r.aiLaneDescription.innerHTML = '';
        var close = U.el('button', { class:'tw-aiLaneClose', type:'button', 'aria-label':'Close mode details' }, ['×']);
        var use = U.el('button', { class:'tw-btn tw-aiLaneUse', type:'button' }, ['Use this mode']);
        close.addEventListener('click', function(){ r.aiLaneDescription.setAttribute('hidden',''); });
        use.addEventListener('click', function(){
          setLane(type, item.id);
          resetAIContext(false);
          r.aiLaneDescription.setAttribute('hidden','');
        });
        r.aiLaneDescription.appendChild(close);
        r.aiLaneDescription.appendChild(U.el('strong', { text:item.label }));
        r.aiLaneDescription.appendChild(U.el('div', { text:laneDescriptionMap[item.id] || '' }));
        r.aiLaneDescription.appendChild(U.el('div', { class:'tw-aiLaneChoiceActions' }, [use]));
        r.aiLaneDescription.removeAttribute('hidden');
        use.focus();
      }
      function resetAIContext(clearPreview){
        if(clearPreview){
          r.aiLastWheelPackage = null;
          r.aiLastStickerIdeas = [];
          r.aiLastOutputAfter = '';
        }
        if(clearPreview && r.aiOut) r.aiOut.value = '';
        if(clearPreview && r.aiReview) renderAIReview();
        setStatus('', false);
      }
      if(r.aiModeWrap){
        r.aiModeWrap.innerHTML='';
        modeLanes.forEach(function(m){
          var b = makeLaneButton(m);
          b.setAttribute('data-lane', m.id);
          b.addEventListener('click', function(){ openLaneChoice('mode', m); });
          r.aiModeWrap.appendChild(b);
        });
      }
      if(r.aiToneWrap){
        r.aiToneWrap.innerHTML='';
        personalityLanes.forEach(function(t){
          var b = makeLaneButton(t);
          b.setAttribute('data-lane', t.id);
          b.addEventListener('click', function(){ openLaneChoice('personality', t); });
          r.aiToneWrap.appendChild(b);
        });
      }
      setLane('mode', 'direct');
      var aiFirstRealPromptPending = true;
      function applyFirstPromptDefaults(){
        if(!aiFirstRealPromptPending) return;
        aiFirstRealPromptPending = false;
        setLane('mode', 'direct');
        setCount(6);
        [[r.aiColorMode,'follow'],[r.aiStickerMode,'off'],[r.aiPrizeExperience,'standard'],[r.aiAudience,'mixed'],[r.aiReadingLevel,'standard'],[r.aiApplyPlan,'replace'],[r.aiRevealMode,'standard']].forEach(function(pair){
          if(!pair[0]) return;
          pair[0].value = pair[1];
          if(pair[0]._twMenuSyncLabel) pair[0]._twMenuSyncLabel();
        });
      }
      r.applyAIPresetDefaults = function(force){
        if(force) aiFirstRealPromptPending = true;
        applyFirstPromptDefaults();
      };
      function syncPromptTools(){
        var length = String(r.aiTopic && r.aiTopic.value || '').length;
        if(r.aiPromptCount) r.aiPromptCount.textContent = length + ' / 300';
      }
      if(r.aiTopic){
        r.aiTopic.addEventListener('input', function(){
          if(String(r.aiTopic.value || '').trim() && aiFirstRealPromptPending) applyFirstPromptDefaults();
          syncPromptTools();
          resetAIContext(false);
        });
      }
      if(r.btnAIClearTopic){
        r.btnAIClearTopic.addEventListener('click', function(){
          if(aiFirstRealPromptPending) applyFirstPromptDefaults();
          r.aiTopic.value='';
          resetAIContext(true);
          syncPromptTools();
          r.aiTopic.focus();
        });
      }
      syncPromptTools();

      // Helper: parse textarea into labels
      function parseLines(raw){
        raw = (raw||'').replace(/\r/g,'');
        var lines = raw.split('\n')
          .map(function(s){ return (s||'').trim(); })
          .filter(Boolean);
        // remove numbering like "1. " or "1) "
        lines = lines.map(function(s){
          return s.replace(/^\s*\d+\s*(?:[\)\.:]|-\s+(?=[A-Za-z]))\s*/,'').trim();
        }).filter(Boolean);
        // de-dupe
        var seen = {};
        var out = [];
        for(var i=0;i<lines.length;i++){
          var key = lines[i].toLowerCase();
          if(seen[key]) continue;
          seen[key]=1;
          out.push(lines[i]);
        }
        return out;
      }

      function smartTrimLabel(s, maxLen){
        s = String(s || '');
        s = s.replace(/[“”]/g,'"').replace(/[‘’]/g,"'");
        s = s.replace(/[,:;!?]+/g,'').replace(/\s+/g,' ').trim();
        s = s.replace(/^\b(the|a|an)\b\s+/i, '');
        s = s.replace(/\bversus\b/gi, 'vs');
        s = s.replace(/\bminutes\b/gi, 'min');
        s = s.replace(/\bminute\b/gi, 'min');
        s = s.replace(/\s+/g,' ').trim();
        if(s.length <= maxLen) return s;

        var words = s.split(' ').filter(Boolean);
        var out = [];
        for(var i=0;i<words.length;i++){
          var test = (out.length ? out.join(' ') + ' ' : '') + words[i];
          if(test.length <= maxLen) out.push(words[i]);
          else break;
        }

        var tailDrop = { 'for':1,'to':1,'of':1,'the':1,'a':1,'an':1,'and':1,'with':1,'in':1,'on':1,'at':1,'from':1,'into':1,'by':1,'or':1 };
        while(out.length && tailDrop[(out[out.length-1] || '').toLowerCase()]) out.pop();

        var candidate = out.join(' ').trim();
        if(candidate && candidate.length <= maxLen) return candidate;

        if(words.length > 1){
          var two = words.slice(0,2).join(' ').trim();
          if(two && two.length <= maxLen) return two;
        }

        return s.slice(0, maxLen).replace(/\s+\S*$/,'').trim() || s.slice(0, maxLen).trim();
      }

      function labelLimitForTotal(total){
        total = Math.max(2, Math.min(12, parseInt(total,10) || 2));
        if(total <= 6) return 15;
        if(total === 7) return 13;
        if(total === 8) return 11;
        if(total === 9) return 9;
        if(total === 10) return 8;
        return 20;
      }

      function enforceLengths(lines, finalTotal){
        var maxLen = labelLimitForTotal(finalTotal || lines.length || 2);
        return lines.map(function(s){
          s = (s||'').replace(/\s+/g,' ').trim();
          if(!s) return '';
          return smartTrimLabel(s, maxLen);
        }).filter(Boolean);
      }

      function findQualityFlags(lines, opts){
        opts = opts || {};
        if(opts.directMode) return [];
        var weakExact = {
          'jump in':1,
          'go for it':1,
          'try one':1,
          'good one':1,
          'have fun':1,
          'do it':1,
          'pick one':1,
          'take one':1
        };
        var weakSolo = {
          'jump':1,
          'start':1,
          'begin':1,
          'go':1,
          'play':1,
          'try':1
        };
        var flags = [];
        for(var i=0;i<lines.length;i++){
          var raw = String(lines[i] || '').trim();
          var s = raw.toLowerCase();
          if(!s) continue;
          if(weakExact[s]) flags.push(raw);
          else if(weakSolo[s]) flags.push(raw);
          else if(raw.split(/\s+/).length === 1 && raw.length <= 4 && !/^[a-z0-9]$/i.test(raw)) flags.push(raw);
        }
        return flags;
      }

      function setStatus(msg, isErr){
        if(r.aiMsg) r.aiMsg.textContent = isErr ? '' : (msg||'');
        if(r.aiErr) r.aiErr.textContent = isErr ? (msg||'') : '';
      }

      function existingSegmentCount(){
        return Math.max(0, (TW.state && Array.isArray(TW.state.segments)) ? TW.state.segments.length : 0);
      }

      function renderAISuccess(){
        if(!r.aiSuccess) return;
        var wheel = r.aiLastWheelPackage;
        if(!wheel || !Array.isArray(wheel.segments) || !wheel.segments.length){
          r.aiSuccess.setAttribute('hidden','');
          return;
        }
        var segments = wheel.segments;
        var clueCount = segments.filter(function(s){ return !!String(s.revealClue || '').trim(); }).length;
        var stickerCount = segments.filter(function(s){ return !!(s._stickerUrl || (TW.findStickerSuggestion && TW.findStickerSuggestion(s.stickerSearch || ''))); }).length;
        var paletteText = String(r.aiColorMode && r.aiColorMode.value || 'follow') === 'curate' ? 'Curated color palette' : 'Wheel color palette';
        var prizeLabel = r.aiPrizeExperience && r.aiPrizeExperience.options[r.aiPrizeExperience.selectedIndex] ? r.aiPrizeExperience.options[r.aiPrizeExperience.selectedIndex].text : 'Standard Wheel';
        var checks = wheel.quality && wheel.quality.checks ? wheel.quality.checks : {};
        var normalizedLabels = segments.map(function(s){ return String(s.displayLabel || '').toLowerCase().replace(/\W/g,''); });
        var checkResults = [
          checks.noDuplicates !== false && (new Set(normalizedLabels)).size === normalizedLabels.length,
          checks.labelsFit !== false && segments.every(function(s){ return String(s.displayLabel || '').length <= labelLimitForTotal(r.aiLastFinalSegmentCount || segments.length); }),
          checks.cluesProtectAnswers !== false && segments.every(function(s){ return !s.revealAnswer || String(s.revealClue || '').toLowerCase().indexOf(String(s.revealAnswer || '').toLowerCase()) === -1; }),
          checks.stickersMatchSubjects !== false,
          checks.readingLevelAppropriate !== false,
          checks.colorContrastChecked !== false
        ];
        var checkPassed = checkResults.every(Boolean);
        var title = String(wheel.title || r.aiLastTopic || 'Wheel').replace(/\s+Wheel$/i,'') + ' Wheel Ready';
        var preview = U.el('button', { class:'tw-btn', type:'button' }, ['Preview Wheel']);
        var apply = U.el('button', { class:'tw-btn tw-btnPrimary', type:'button' }, ['Apply to Wheel']);
        preview.addEventListener('click', function(){
          var reviewField = r.aiReview && r.aiReview.parentNode;
          if(reviewField) reviewField.scrollIntoView({behavior:'smooth',block:'start'});
        });
        apply.addEventListener('click', function(){
          if(String(r.aiApplyPlan && r.aiApplyPlan.value || 'replace') === 'add') r.btnAIApplyAdd.click();
          else r.btnAIApplyReplace.click();
        });
        r.aiSuccess.innerHTML = '';
        r.aiSuccess.appendChild(U.el('div', { class:'tw-aiSuccessTitle', text:title }));
        var facts = U.el('div', { class:'tw-aiSuccessFacts' }, [
          U.el('div', { class:'tw-aiSuccessFact', text:segments.length + ' segments' }),
          U.el('div', { class:'tw-aiSuccessFact', text:paletteText }),
          U.el('div', { class:'tw-aiSuccessFact', text:clueCount + ' hidden-answer clue' + (clueCount === 1 ? '' : 's') }),
          U.el('div', { class:'tw-aiSuccessFact', text:stickerCount + ' sticker' + (stickerCount === 1 ? '' : 's') + ' matched' }),
          U.el('div', { class:'tw-aiSuccessFact', text:prizeLabel + ' experience' })
        ]);
        r.aiSuccess.appendChild(facts);
        r.aiSuccess.appendChild(U.el('div', { class:'tw-aiCheck', text:checkPassed ? '✓ Wheel Check Passed' : 'Wheel Check Needs Review' }));
        r.aiSuccess.appendChild(U.el('div', { class:'tw-mini', text:'No duplicate segments • Labels fit the wheel • Clues protect answers • Stickers match subjects • Reading level fits • Color contrast checked' }));
        r.aiSuccess.appendChild(U.el('div', { class:'tw-aiSuccessActions' }, [preview, apply]));
        r.aiSuccess.removeAttribute('hidden');
      }

      function renderAIReview(){
        if(!r.aiReview) return;
        var wheel = r.aiLastWheelPackage;
        r.aiReview.innerHTML = '';
        if(!wheel || !Array.isArray(wheel.segments) || !wheel.segments.length){
          var emptyProfessor = U.el('div', { class:'tw-aiDoctor' }, [
            U.el('div', { class:'tw-aiDoctorTitle', text:'WHEEL PROFESSOR' }),
            U.el('div', { class:'tw-aiDoctorText', text:'After generation, Wheel Professor will review clarity, variety, balance, and presentation readiness here.' })
          ]);
          var placeholder = U.el('div', { class:'tw-aiReviewPlaceholder' }, [
            U.el('div', { class:'tw-aiPlaceholderTitle', text:'Presentation View' }),
            U.el('div', { class:'tw-aiPlaceholderText', text:'Your editable wheel labels, popup titles, popup text, clues, answers, colors, and sticker choices will appear here before anything is applied.' }),
            U.el('div', { class:'tw-aiPlaceholderRows' }, [
              U.el('div', { class:'tw-aiPlaceholderRow' }),
              U.el('div', { class:'tw-aiPlaceholderRow' }),
              U.el('div', { class:'tw-aiPlaceholderRow' })
            ])
          ]);
          r.aiReview.appendChild(emptyProfessor);
          r.aiReview.appendChild(placeholder);
          r.aiReview.removeAttribute('hidden');
          return;
        }
        var doctorText = [];
        if(wheel.balance && wheel.balance.summary) doctorText.push(String(wheel.balance.summary));
        if(wheel.quality && wheel.quality.notes) doctorText.push(String(wheel.quality.notes));
        var doctor = U.el('div', { class:'tw-aiDoctor' });
        doctor.appendChild(U.el('div', { class:'tw-aiDoctorTitle', text:'WHEEL PROFESSOR' }));
        doctor.appendChild(U.el('div', { class:'tw-aiDoctorText', text:doctorText.join(' ') || ('Reviewed ' + wheel.segments.length + ' distinct results for clarity and balance.') }));
        r.aiReview.appendChild(doctor);
        var colors = wheel.visualTheme && Array.isArray(wheel.visualTheme.colors) ? wheel.visualTheme.colors : [];
        function editField(label, value, max, multiline, onChange){
          var control = U.el(multiline ? 'textarea' : 'input', multiline ? { maxlength:String(max), rows:'2' } : { type:'text', maxlength:String(max) });
          control.value = String(value || '');
          control.addEventListener('input', function(){ onChange(String(control.value || '')); });
          return U.el('label', { class:'tw-aiEditField' }, [U.el('span', { text:label }), control]);
        }
        function syncHiddenLabels(){
          if(r.aiOut) r.aiOut.value = wheel.segments.map(function(item){ return String(item.displayLabel || ''); }).join('\n');
        }
        wheel.segments.forEach(function(segment, index){
          var stickerMode = String(r.aiStickerMode && r.aiStickerMode.value || 'off');
          var sticker = stickerMode === 'off' ? null : (segment._stickerUrl ? { id:String(segment._stickerId || ''), url:String(segment._stickerUrl) } : (TW.findStickerSuggestion ? TW.findStickerSuggestion(segment.stickerSearch || '') : null));
          if(stickerMode === 'off'){
            segment.stickerSearch = '';
            segment._stickerId = '';
            segment._stickerUrl = '';
            segment._useSticker = false;
          }
          var card = U.el('div', { class:'tw-aiReviewCard' });
          card.classList.toggle('isLocked', !!segment._locked);
          card.appendChild(U.el('span', { class:'tw-aiReviewSwatch', style:'background:' + (colors[index % Math.max(1,colors.length)] || '#ddd') + ';' }));
          var copy = U.el('div', { class:'tw-aiReviewFields' });
          copy.appendChild(editField('ON WHEEL', segment.displayLabel, labelLimitForTotal(r.aiLastFinalSegmentCount || wheel.segments.length), false, function(value){ segment.displayLabel=value; syncHiddenLabels(); }));
          copy.appendChild(editField('POPUP TITLE', segment.resultLabel || segment.displayLabel, 55, false, function(value){ segment.resultLabel=value; }));
          copy.appendChild(editField('POPUP TEXT', segment.fullText, 500, true, function(value){ segment.fullText=value; }));
          if(segment.revealClue || segment.revealAnswer){
            copy.appendChild(editField('CLUE', segment.revealClue, 90, true, function(value){ segment.revealClue=value; }));
            copy.appendChild(editField('REVEAL ANSWER', segment.revealAnswer, 70, false, function(value){ segment.revealAnswer=value; }));
          }
          card.appendChild(copy);
          var stickerBox = U.el('div', { class:'tw-aiReviewSticker' });
          if(sticker && sticker.url){
            var useSticker = String(r.aiStickerMode && r.aiStickerMode.value || 'apply') === 'apply';
            segment._stickerId = sticker.id;
            segment._stickerUrl = sticker.url;
            segment._useSticker = useSticker;
            stickerBox.appendChild(U.el('img', { class:'tw-aiStickerPreview', src:sticker.url, alt:'Suggested sticker' }));
            var stickerChoice = U.el('button', { class:'tw-btn tw-aiStickerChoice', type:'button', 'aria-pressed':useSticker ? 'true' : 'false' }, [useSticker ? 'Sticker selected' : 'Use sticker']);
            function syncStickerChoice(){
              stickerBox.classList.toggle('isSelected', !!segment._useSticker);
              stickerChoice.classList.toggle('isSelected', !!segment._useSticker);
              stickerChoice.setAttribute('aria-pressed', segment._useSticker ? 'true' : 'false');
              stickerChoice.textContent = segment._useSticker ? 'Sticker selected' : 'Use sticker';
            }
            stickerChoice.addEventListener('click', function(){ segment._useSticker = !segment._useSticker; syncStickerChoice(); });
            stickerBox.appendChild(stickerChoice);
            syncStickerChoice();
          }else{
            segment._useSticker = false;
            stickerBox.appendChild(U.el('div', { class:'tw-aiStickerEmpty', text:'No sticker match' }));
          }
          card.appendChild(stickerBox);
          var actions = U.el('div', { class:'tw-aiCardActions' });
          var remix = U.el('button', { class:'tw-btn tw-aiCardAction', type:'button' }, ['Remix']);
          var simplify = U.el('button', { class:'tw-btn tw-aiCardAction', type:'button' }, ['Simplify']);
          var elevate = U.el('button', { class:'tw-btn tw-aiCardAction', type:'button' }, ['Elevate']);
          var edit = U.el('button', { class:'tw-btn tw-aiCardAction', type:'button' }, ['Edit']);
          var remove = U.el('button', { class:'tw-btn tw-aiCardAction', type:'button' }, ['Remove']);
          var lock = U.el('button', { class:'tw-btn tw-aiCardAction' + (segment._locked ? ' isLocked' : ''), type:'button', 'aria-pressed':segment._locked ? 'true' : 'false' }, [segment._locked ? 'Locked' : 'Lock']);
          remix.addEventListener('click', function(){ callVortexAI('refine', index); });
          simplify.addEventListener('click', function(){ callVortexAI('shorter', index); });
          elevate.addEventListener('click', function(){ callVortexAI('harder', index); });
          edit.addEventListener('click', function(){ var field = copy.querySelector('input,textarea'); if(field){ field.focus(); field.select && field.select(); } });
          remove.addEventListener('click', function(){ wheel.segments.splice(index,1); renderAIReview(); renderAISuccess(); });
          lock.addEventListener('click', function(){ segment._locked=!segment._locked; renderAIReview(); });
          [remix, simplify, elevate, edit, remove, lock].forEach(function(button){ actions.appendChild(button); });
          card.appendChild(actions);
          r.aiReview.appendChild(card);
        });
        syncHiddenLabels();
        r.aiReview.removeAttribute('hidden');
        renderAISuccess();
      }

      function setBusy(b){
        if(r.aiThinking){
          if(b) r.aiThinking.removeAttribute('hidden');
          else r.aiThinking.setAttribute('hidden','');
        }
        if(b){
          setStatus('Vortex Is Thinking…', false);
        }
        // disable action buttons while busy
        var els = [r.btnAIGenerate, r.btnAISurprise, r.btnAIRefine, r.btnAIMakeShorter, r.btnAIMakeHarder, r.btnAIReport, r.btnAIApplyReplace, r.btnAIApplyAdd];
        for(var i=0;i<els.length;i++){
          if(!els[i]) continue;
          els[i].disabled = !!b;
        }
      }


      function getVortexCustomerIdentity(){
        var out = { customerId:'', customerEmail:'' };
        try{
          var access = window.TOKI_WHEEL_ACCESS || window.__TW_ACCESS || {};
          var customer = window.TOKI_WHEEL_CUSTOMER || window.__TW_CUSTOMER || {};

          out.customerId = String(
            window.TOKI_WHEEL_CUSTOMER_ID ||
            window.__TW_CUSTOMER_ID ||
            access.customerId ||
            access.customer_id ||
            access.shopifyCustomerId ||
            customer.id ||
            customer.customerId ||
            ''
          ).trim();

          out.customerEmail = String(
            window.TOKI_WHEEL_CUSTOMER_EMAIL ||
            window.__TW_CUSTOMER_EMAIL ||
            access.customerEmail ||
            access.customer_email ||
            access.email ||
            customer.email ||
            customer.customerEmail ||
            ''
          ).trim().toLowerCase();

          /* Shopify sometimes exposes a customer id here. Email usually requires Liquid. */
          if(!out.customerId && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page){
            out.customerId = String(window.ShopifyAnalytics.meta.page.customerId || '').trim();
          }
        }catch(_){ }
        return out;
      }

      function regenerateAISegment(index){
        var wheel = r.aiLastWheelPackage;
        if(!wheel || !Array.isArray(wheel.segments) || !wheel.segments[index]) return;
        callVortexAI('refine', index);
      }

      async function callVortexAI(mode, targetIndex){
        // mode: generate | refine | shorter(simplify) | harder(elevate)
        var topic = (r.aiTopic && r.aiTopic.value || '').trim();
        if(!topic){
          setStatus('Add a topic first.', true);
          return;
        }
        var count = clampCount(selectedCount);
        var endpoint = (TW.ai && TW.ai.endpoint) ? TW.ai.endpoint : 'https://vortex-ai.johnniedropmx.workers.dev/generate';

        var currentLines = parseLines(r.aiOut && r.aiOut.value || '').slice(0, 120);
        var needsCurrent = (mode === 'refine' || mode === 'shorter' || mode === 'harder' || typeof targetIndex === 'number');
        var isFreshMode = mode === 'generate';
        if(needsCurrent && !currentLines.length){
          setStatus('Generate a list first, then transform the current list.', true);
          return;
        }

        var laneGuideMap = {
          showman: [
            'Lane: Showman personality.',
            'Priority: energy.',
            'Voice: big, lively, crowd-pleasing, punchy, playful.',
            'Do: make segments fun, immediate, and broadly appealing.',
            'Avoid: academic stiffness, abstract weirdness, flat wording.'
          ].join(' '),
          scholar: [
            'Lane: Scholar personality.',
            'Priority: precision.',
            'Voice: polished, intelligent, organized, thoughtful.',
            'Do: use refined, credible, well-formed wording.',
            'Avoid: goofy randomness, slangy messiness, theatrical excess.'
          ].join(' '),
          poet: [
            'Lane: Poet personality.',
            'Priority: imagery.',
            'Voice: vivid, elegant, atmospheric, expressive.',
            'Do: make ordinary prompts feel more evocative while staying clear.',
            'Avoid: vague prettiness, obscure references, lost meaning.'
          ].join(' '),
          trickster: [
            'Lane: Trickster personality.',
            'Priority: surprise.',
            'Voice: witty, quirky, mischievous, unexpected.',
            'Do: add playful twists that still make sense on their own.',
            'Avoid: random nonsense, inside jokes, childish gibberish.'
          ].join(' '),
          ringmaster: [
            'Lane: Ringmaster personality.',
            'Priority: drama.',
            'Voice: theatrical, commanding, high-energy, event-ready.',
            'Do: make segments feel bigger, more exciting, more reveal-worthy.',
            'Avoid: dry language, timid phrasing, subtle understatement.'
          ].join(' '),
          alchemist: [
            'Lane: Alchemist personality.',
            'Priority: transformation.',
            'Voice: inventive, upgraded, premium, cleverly transformed.',
            'Do: turn ordinary ideas into richer, more compelling concepts without changing the topic.',
            'Avoid: drifting off-theme, over-poetic abstraction, artificial phrasing.'
          ].join(' '),
          cartographer: [
            'Lane: Cartographer personality.',
            'Priority: clarity.',
            'Voice: structured, practical, logical, organized.',
            'Do: make outputs easy to scan, neatly grounded, and useful.',
            'Avoid: drama, poetic excess, weird detours, unnecessary flair.'
          ].join(' '),
          arcade: [
            'Lane: Arcade Brain personality.',
            'Priority: punch.',
            'Voice: snappy, modern, game-like, bold, fast.',
            'Do: use compact, catchy, challenge-friendly phrasing.',
            'Avoid: formal stiffness, slow soft wording, poetic drift.'
          ].join(' '),
          direct: [
            'Lane: Direct Mode.',
            'Priority: accuracy.',
            'Voice: plain, factual, structured, instructional.',
            'Do: answer directly with clean reference-style output.',
            'Avoid: drama, playfulness, mystery, poetic wording, and themed embellishment.'
          ].join(' '),
          math: [
            'Lane: Math Mode.',
            'Priority: correctness.',
            'Voice: compact, symbolic, mathematically correct.',
            'Do: return real equations, expressions, inequalities, examples, and practice items instead of prose.',
            'Avoid: explanatory fluff, playful wording, and non-math filler.'
          ].join(' '),
          teacher: [
            'Lane: Teacher Mode.',
            'Priority: classroom usefulness.',
            'Voice: practical, age-aware, structured, classroom-ready.',
            'Do: generate prompts, jobs, rewards, routines, review items, and teaching lists teachers can use right away.',
            'Avoid: theatrical styling, vagueness, and off-classroom drift.'
          ].join(' '),
          study: [
            'Lane: Study Mode.',
            'Priority: study usefulness.',
            'Voice: factual, organized, review-friendly.',
            'Do: generate key terms, examples, prompts, review lists, and study-ready content.',
            'Avoid: decorative wording, mystery, and low-information filler.'
          ].join(' ')
        };

        var checklistParts = [
          'Universal output standard:',
          '1) Match the topic or the CURRENT list.',
          '2) Every line must express one clear, complete idea that makes sense by itself.',
          '3) Every line must sound natural and intentional, never vague, generic, or robotic.',
          '4) Obey the supplied labelCharLimit exactly, including spaces.',
          '5) Never cut a phrase midway. Rewrite instead of truncating.',
          '6) Avoid dangling endings such as for, to, with, of, and, the, your, my.',
          '7) Avoid filler like Jump In, Go For It, Try One, Good One, Have Fun unless the topic clearly demands it.',
          '8) Keep the set varied, on-theme, and free of near-duplicates.',
          '9) Popup descriptions may use up to two complete sentences. Never return a cut-off or unfinished sentence.'
        ].join(' ');

        var actionGuide = '';
        if(mode === 'generate'){
          actionGuide = 'Action: Generate. Create a fresh list from the topic using the selected personality. Stay on topic.';
        }else if(mode === 'refine'){
          actionGuide = 'Action: Remix. Use the current list as contrast. Preserve locked segments exactly and replace every unlocked segment with a genuinely different concept from the same topic. Reordering or synonym swapping does not count.';
        }else if(mode === 'shorter'){
          actionGuide = 'Action: Simplify Current. Rewrite the CURRENT list into clearer, plainer, more everyday language. Preserve each line\'s core meaning. Change style, not meaning.';
        }else if(mode === 'harder'){
          actionGuide = 'Action: Elevate Current. Rewrite the CURRENT list into more polished, expressive, academic, or sophisticated language. Preserve each line\'s core meaning. Change style, not meaning.';
        }

        var transformCount = needsCurrent && currentLines.length ? currentLines.length : count;
        var buildPlan = String(r.aiApplyPlan && r.aiApplyPlan.value || 'replace');
        if(buildPlan === 'add'){
          var remainingSlots = Math.max(0, 12 - existingSegmentCount());
          if(remainingSlots < 2){ setStatus('This wheel already has the 12-segment AI maximum. Choose Replace instead.', true); return; }
          transformCount = Math.min(transformCount, remainingSlots);
        }
        var finalSegmentCount = buildPlan === 'add' ? Math.min(12, existingSegmentCount() + transformCount) : transformCount;
        var requestLabelLimit = labelLimitForTotal(finalSegmentCount);
        var existingLabels = buildPlan === 'add' && TW.state && Array.isArray(TW.state.segments) ? TW.state.segments.map(function(segment){ return String(segment && segment.label || ''); }).filter(Boolean).slice(0,12) : [];
        var sendCurrentSegments = needsCurrent ? currentLines.slice(0, 12) : [];
        var sendCurrentText = needsCurrent ? sendCurrentSegments.join('\n') : '';
        var lengthRule = 'Return exactly ' + transformCount + ' segment labels. One label per line. No numbering, bullets, commentary, quotes, or headings.';
        var selfCheckRule = 'Before finalizing, silently review every label and rewrite anything that is unclear, incomplete, off-theme, repetitive, not wheel-ready, or unnatural.';
        var promptParts = [
          'TOPIC: ' + topic,
          '',
          (laneGuideMap[selectedLane] || laneGuideMap.direct),
          actionGuide,
          checklistParts,
          lengthRule,
          selfCheckRule
        ];

        if(needsCurrent){
          promptParts.push('', 'CURRENT LIST TO TRANSFORM:', currentLines.join('\n'));
        }
        if(typeof targetIndex === 'number'){
          promptParts.push('', 'SURGICAL REGENERATION:', 'Replace only segment ' + (targetIndex + 1) + '. Preserve every other segment exactly.');
        }
        if(isFreshMode){
          promptParts.push('', 'STATE RULE:', 'Ignore any earlier preview output. Use only the new topic for this request.');
        }

        r.aiLastAction = mode;
        r.aiLastCount = transformCount;
        r.aiLastFinalSegmentCount = finalSegmentCount;
        r.aiLastTopic = topic;
        r.aiLastLaneType = selectedLaneType;
        r.aiLastLane = selectedLane;
        r.aiLastLaneLabel = laneLabelMap[selectedLane] || aiTitleCaseWords(selectedLane || 'Direct Mode');
        r.aiLastOutput = String(r.aiOut && r.aiOut.value || '').trim();
        var variantSeed = Date.now() + Math.floor(Math.random() * 100000);
        var payload = {
          prompt: promptParts.join('\n'),
          rawPrompt: topic,
          topic: topic,
          lane: selectedLane,
          laneType: selectedLaneType,
          utilityMode: (selectedLaneType === 'mode' ? selectedLane : ''),
          tone: selectedLane,
          personality: selectedLane,
          persona: selectedLane,
          mode: mode,
          action: mode,
          count: transformCount,
          uiCount: count,
          currentSegments: sendCurrentSegments,
          currentText: sendCurrentText,
          currentWheel: r.aiLastWheelPackage || null,
          lockedSegments: r.aiLastWheelPackage && Array.isArray(r.aiLastWheelPackage.segments) ? r.aiLastWheelPackage.segments.map(function(segment, index){ return !!segment._locked || (typeof targetIndex === 'number' && index !== targetIndex); }) : [],
          regenerateIndex: typeof targetIndex === 'number' ? targetIndex : null,
          previousPreviewSegments: currentLines.slice(0, 12),
          previousPreviewText: currentLines.join('\n'),
          stateIsolation: isFreshMode ? 'fresh' : 'transform',
          variantSeed: variantSeed,
          seed: variantSeed,
          customerId: getVortexCustomerIdentity().customerId,
          customerEmail: getVortexCustomerIdentity().customerEmail,
          availablePalette: (window.TOKI_WHEEL_PRESET && Array.isArray(window.TOKI_WHEEL_PRESET.palette)) ? window.TOKI_WHEEL_PRESET.palette.slice(0,40) : [],
          colorMode: String(r.aiColorMode && r.aiColorMode.value || 'follow'),
          stickerMode: String(r.aiStickerMode && r.aiStickerMode.value || 'suggest')
          ,finalSegmentCount: finalSegmentCount
          ,labelCharLimit: requestLabelLimit
          ,revealMode: String(r.aiRevealMode && r.aiRevealMode.value || 'standard')
          ,existingLabels: existingLabels
          ,prizeExperience: String(r.aiPrizeExperience && r.aiPrizeExperience.value || 'standard')
          ,audience: String(r.aiAudience && r.aiAudience.value || 'mixed')
          ,readingLevel: String(r.aiReadingLevel && r.aiReadingLevel.value || 'standard')
        };

        // Store the exact request context so the Report AI Issue form can send useful debugging clues.
        r.aiLastPrompt = payload.prompt || '';
        r.aiLastCurrentText = sendCurrentText || '';
        r.aiLastRequestPayload = payload;

        setBusy(true);
        try{
          var sessionRes = await fetch('/apps/vortex/session', {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-store'
          });
          var sessionData = null;
          try{ sessionData = await sessionRes.json(); }catch(_){ }
          if(!sessionRes.ok || !sessionData || !sessionData.token){
            throw new Error((sessionData && sessionData.error) || 'Sign in with Vortex Pro to continue.');
          }
          var res = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type':'application/json',
              'Authorization':'Bearer ' + sessionData.token
            },
            body: JSON.stringify(payload)
          });

          var data = null;
          var rawErrorText = '';
          try{ data = await res.json(); }
          catch(_){
            try{ rawErrorText = await res.text(); }catch(__){}
          }

          if(!res.ok){
            var limitType = '';
            try{
              var blob = data || {};
              var joined = [
                blob.limitType, blob.limit, blob.type, blob.code, blob.reason, blob.message, blob.error,
                rawErrorText
              ].join(' ').toLowerCase();
              if(joined.indexOf('month') !== -1 || joined.indexOf('300') !== -1) limitType = 'monthly';
              else if(joined.indexOf('day') !== -1 || joined.indexOf('daily') !== -1 || joined.indexOf('40') !== -1) limitType = 'daily';
            }catch(_){ }
            if(res.status === 429 || limitType){
              TW.openAILimitPopup && TW.openAILimitPopup(limitType || 'daily');
              setStatus(limitType === 'monthly' ? 'Monthly AI limit reached.' : 'Daily AI limit reached.', true);
              return;
            }
            throw new Error((data && (data.message || data.error)) ? (data.message || data.error) : 'AI request failed ('+res.status+').');
          }

          if(data && (data.limitReached || data.limitExceeded || data.aiLimitReached)){
            var k = String(data.limitType || data.limit || data.type || data.message || '').toLowerCase();
            TW.openAILimitPopup && TW.openAILimitPopup(k.indexOf('month') !== -1 ? 'monthly' : 'daily');
            setStatus(k.indexOf('month') !== -1 ? 'Monthly AI limit reached.' : 'Daily AI limit reached.', true);
            return;
          }

          r.aiLastRequestId = String(data && data.requestId || '').trim();

          // Accept Vortex AI 2 structured wheels plus legacy line responses.
          var lines = [];
          if(data && data.wheel && Array.isArray(data.wheel.segments)){
            var previousWheel = r.aiLastWheelPackage;
            if(previousWheel && Array.isArray(previousWheel.segments)){
              data.wheel.segments = data.wheel.segments.map(function(segment, index){
                var prior = previousWheel.segments[index];
                if(prior && (prior._locked || (typeof targetIndex === 'number' && index !== targetIndex))) return prior;
                return segment;
              });
            }
            lines = data.wheel.segments.map(function(segment){ return segment.displayLabel || ''; });
            r.aiLastWheelPackage = data.wheel;
            if(String(r.aiStickerMode && r.aiStickerMode.value || 'suggest') === 'suggest' && TW.findStickerSuggestion){
              var ideas = data.wheel.segments.map(function(segment){
                var hit = TW.findStickerSuggestion(segment.stickerSearch || segment.fullText || segment.displayLabel);
                return hit ? (segment.displayLabel + ' → ' + hit.name) : '';
              }).filter(Boolean).slice(0,6);
              r.aiLastStickerIdeas = ideas;
            }
          }
          else if(Array.isArray(data.lines)) lines = data.lines;
          else if(typeof data.text === 'string') lines = parseLines(data.text);
          else if(typeof data === 'string') lines = parseLines(data);

          lines = parseLines(lines.join('\n'));
          lines = enforceLengths(lines, finalSegmentCount);

          // Ensure exact count if possible
          if(lines.length > transformCount) lines = lines.slice(0, transformCount);

          var qualityFlags = findQualityFlags(lines, { directMode: !!(data && data.directMode) || selectedLaneType === 'mode' });
          if(lines.length < transformCount){
            setStatus('AI returned '+lines.length+' of '+transformCount+'. Try Remix.', true);
          }else{
            var doneMsg = 'Generated ' + transformCount + ' segments.';
            if(mode === 'refine') doneMsg = 'Remixed the topic.';
            else if(mode === 'shorter') doneMsg = 'Simplified the current list.';
            else if(mode === 'harder') doneMsg = 'Elevated the current list.';
            if(data && data.wheel && data.wheel.quality && data.wheel.quality.transformCheck && data.wheel.quality.transformCheck.required){
              var tc = data.wheel.quality.transformCheck;
              doneMsg += ' Verified ' + Number(tc.changed || 0) + ' of ' + Number(tc.unlocked || tc.expected || 0) + ' unlocked segment changes.';
            }
            if(data && data.directMode) doneMsg += ' Direct Mode applied.';
            if(qualityFlags.length) doneMsg += ' Review ' + qualityFlags.length + ' vague label' + (qualityFlags.length===1?'':'s') + ' in preview.';
            setStatus(doneMsg, false);
            if(r.aiLastStickerIdeas && r.aiLastStickerIdeas.length && r.aiMsg){
              r.aiMsg.textContent += ' Sticker ideas: ' + r.aiLastStickerIdeas.join(' • ');
            }
          }

          if(r.aiOut) r.aiOut.value = lines.join('\n');
          renderAIReview();
          r.aiLastOutput = lines.join('\n');
          r.aiLastOutputAfter = lines.join('\n');
          if(lines.length){
            TW.track && TW.track('ai_generation_complete', {
              ai_mode: String(mode || 'generate'),
              output_count: lines.length,
              plan: TW.access && TW.access.getUserPlan ? TW.access.getUserPlan() : 'free'
            });
          }
        }catch(err){
          setStatus((err && err.message) ? err.message : 'AI error. Try again.', true);
        }finally{
          setBusy(false);
        }
      }

      // Apply buttons
      function getPreviewLines(applyMode){
        var raw = parseLines(r.aiOut && r.aiOut.value || '');
        if(applyMode === 'add') raw = raw.slice(0, Math.max(0, 12 - existingSegmentCount()));
        var finalTotal = applyMode === 'add' ? Math.min(12, existingSegmentCount() + raw.length) : raw.length;
        var lines = enforceLengths(raw, finalTotal);
        var cnt = clampCount(selectedCount);
        if(lines.length > cnt) lines = lines.slice(0,cnt);
        return lines;
      }

      function getVortexApplyOptions(){
        var wheel = r.aiLastWheelPackage;
        if(!wheel || !Array.isArray(wheel.segments)) return {};
        return {
          colors: wheel.visualTheme && Array.isArray(wheel.visualTheme.colors) ? wheel.visualTheme.colors.slice(0) : [],
          details: wheel.segments.map(function(segment){
            return {
              fullText: String(segment.fullText || segment.displayLabel || ''),
              resultLabel: String(segment.resultLabel || segment.fullText || segment.displayLabel || ''),
              category: String(segment.category || ''),
              weight: Number(segment.weight || 1),
              stickerSearch: String(segment.stickerSearch || segment.fullText || segment.displayLabel || '')
              ,revealClue: String(segment.revealClue || '')
              ,revealAnswer: String(segment.revealAnswer || '')
              ,useSticker: !!segment._useSticker
              ,stickerId: String(segment._stickerId || '')
              ,stickerUrl: String(segment._stickerUrl || '')
            };
          }),
          winnerExperience: wheel.winnerExperience || null,
          stickerMode: String(r.aiStickerMode && r.aiStickerMode.value || 'suggest')
        };
      }

      if(r.btnAIApplyReplace){
        r.btnAIApplyReplace.addEventListener('click', function(){
          var lines = getPreviewLines('replace');
          if(!lines.length) return;
          if(TW.setSegments) TW.setSegments(lines, getVortexApplyOptions());
          else {
            // fallback: clear without confirm by direct set
            TW.pushUndo && TW.pushUndo();
            TW.state.segments = [];
            TW.addSegmentsNoUndo ? TW.addSegmentsNoUndo(lines) : (TW.addSegments && TW.addSegments(lines));
          }
          setStatus('Applied: replaced wheel segments.', false);
        });
      }
      if(r.btnAIApplyAdd){
        r.btnAIApplyAdd.addEventListener('click', function(){
          var lines = getPreviewLines('add');
          if(!lines.length) return;
          if(TW.addSegmentsNoUndo) TW.addSegmentsNoUndo(lines, getVortexApplyOptions());
          else if(TW.addSegments) TW.addSegments(lines);
          setStatus('Applied: added '+lines.length+' segments.', false);
        });
      }

      function openAIPreviewUpsell(mode){
        var topicVal = String(r.aiTopic && r.aiTopic.value || '').trim();
        var previewTopic = topicVal || 'your topic';
        var safePreviewTopic = previewTopic.toUpperCase().slice(0,15).replace(/[&<>"']/g, function(ch){
          return ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' })[ch];
        });
        var previewHtml = '<div class="tw-blurLine">' + safePreviewTopic + '</div><div class="tw-blurLine">SMART REMIX</div>';
        setBusy(true);
        setTimeout(function(){
          setBusy(false);
          TW.openPlanUpsell && TW.openPlanUpsell('vortex_pro', {
            title:'🧠 Inventor Lab is ready…',
            message:'Unlock instant wheel creation with Vortex Pro. Create games, lessons, or content in seconds.',
            subtext:'AI wheel creation • smart remixes • faster setup',
            previewHtml: previewHtml,
            href:'https://spinthewheellab.com/pages/vortexpro'
          });
        }, 900);
      }

      // Main actions
      if(r.btnAIGenerate) r.btnAIGenerate.addEventListener('click', function(){ if(!isPro){ openAIPreviewUpsell('generate'); return; } callVortexAI('generate'); });
      if(r.btnAISurprise) r.btnAISurprise.addEventListener('click', function(){
        if(!isPro){ openAIPreviewUpsell('generate'); return; }
        function randomItem(items){
          var value = 0;
          try{ value = crypto.getRandomValues(new Uint32Array(1))[0]; }catch(_){ value = Math.floor(Math.random() * 4294967296); }
          return items[value % items.length];
        }
        var prizeMode = String(r.aiPrizeExperience && r.aiPrizeExperience.value || 'standard');
        var revealMode = String(r.aiRevealMode && r.aiRevealMode.value || 'standard');
        var laneChoices = revealMode === 'reveal' ? ['study','teacher','math','direct','creative'] : ['direct','study','teacher','math','creative'];
        var subjects = revealMode === 'reveal' ? [
          'strange animal superpowers','space discoveries','world landmarks','movie genres','music instruments','inventors and inventions','ocean mysteries','mythical creatures','science surprises','foods from around the world','hidden objects','word riddles','weather phenomena','ancient civilizations','sports facts','famous works of art'
        ] : [
          'tiny adventures for a rainy day','unexpected pizza inventions','dream travel destinations','creative photo challenges','wild museum exhibit ideas','cozy weekend rituals','future gadgets','mini storytelling prompts','color-inspired activities','festival themes','five-minute creative dares','unusual hobby samplers','fantasy café menu ideas','backyard discoveries','music mood missions','silly product inventions','micro acts of kindness','movie-night themes','design challenges','conversation sparks','impossible vacation ideas','chef challenge ingredients','character-building prompts','nature scavenger hunts'
        ];
        var formats = revealMode === 'reveal' ? [
          'Create intriguing clues that conceal the answer until Reveal','Build a fast mystery quiz with clever but fair clues','Turn this into a guess-what-it-is wheel','Create surprising questions with satisfying answer reveals','Make a visual-friendly trivia wheel whose labels never expose answers'
        ] : [
          'Create a polished wheel of distinct choices','Turn this into playful, immediately usable prompts','Build a surprising wheel with strong variety','Create bold, memorable mini challenges','Make each segment open a genuinely different direction','Turn this into an imaginative pick-and-play wheel'
        ];
        var prizeDirections = {
          standard:'',
          giveaway:' Make every outcome feel like an exciting audience-facing giveaway win using fun, realistic low-stakes rewards and celebratory language.',
          competition:' Make every outcome a fair, exciting competition result such as points, an advantage, recognition, a bonus attempt, or a playful challenge.',
          classroom:' Make every outcome an inclusive classroom reward, privilege, recognition moment, or teacher-ready bonus.',
          custom:' Make this a flexible prize wheel and clearly address the winner; do not invent monetary values, legal terms, or redemption rules.'
        };
        var topic = randomItem(formats) + ' about ' + randomItem(subjects) + '.' + (prizeDirections[prizeMode] || '');
        var attempts = 0;
        while(topic === r.aiLastSurpriseTopic && attempts < 6){ topic = randomItem(formats) + ' about ' + randomItem(subjects) + '.' + (prizeDirections[prizeMode] || ''); attempts++; }
        r.aiLastSurpriseTopic = topic;
        r.aiTopic.value=topic; syncPromptTools(); setLane('mode',randomItem(laneChoices)); setCount(randomItem([4,6,6,8,8,10,12]));
        if(r.aiColorMode) r.aiColorMode.value='curate';
        if(r.aiStickerMode) r.aiStickerMode.value='apply';
        callVortexAI('generate');
      });
      if(r.btnAIRefine) r.btnAIRefine.addEventListener('click', function(){ if(!isPro){ openAIPreviewUpsell('refine'); return; } callVortexAI('refine'); });
      if(r.btnAIMakeShorter) r.btnAIMakeShorter.addEventListener('click', function(){ if(!isPro){ openAIPreviewUpsell('shorter'); return; } callVortexAI('shorter'); });
      if(r.btnAIMakeHarder) r.btnAIMakeHarder.addEventListener('click', function(){ if(!isPro){ openAIPreviewUpsell('harder'); return; } callVortexAI('harder'); });
      if(r.btnAIApplyReplace) r.btnAIApplyReplace.addEventListener('click', function(){ if(!isPro){ openAIPreviewUpsell('apply_replace'); return; } });
      if(r.btnAIApplyAdd) r.btnAIApplyAdd.addEventListener('click', function(){ if(!isPro){ openAIPreviewUpsell('apply_add'); return; } });

      // Pro gate
      setDisabled(false);
      if(r.aiOut) r.aiOut.removeAttribute('readonly');
      if(true){
        r.aiTopic.value = 'Pizza toppings';
        syncPromptTools();
        setCount(6);
        if(r.aiColorMode){ r.aiColorMode.value='curate'; r.aiColorMode.dispatchEvent(new Event('change',{bubbles:true})); }
        if(r.aiStickerMode){ r.aiStickerMode.value='apply'; r.aiStickerMode.dispatchEvent(new Event('change',{bubbles:true})); }
        if(r.aiApplyPlan){ r.aiApplyPlan.value='replace'; r.aiApplyPlan.dispatchEvent(new Event('change',{bubbles:true})); }
        if(r.aiRevealMode){ r.aiRevealMode.value='reveal'; r.aiRevealMode.dispatchEvent(new Event('change',{bubbles:true})); }
        r.aiLastFinalSegmentCount = 6;
        r.aiLastWheelPackage = {
          title:'Pizza Topping Mystery',
          balance:{summary:'Six familiar pizza favorites with varied flavors and clear mystery clues.'},
          quality:{notes:'Labels are short, answers stay hidden, and every popup can be reviewed before applying.'},
          visualTheme:{colors:['#4E342E','#FF3D2E','#E65100','#FFD84D','#2ECC71','#1B5E20']},
          segments:[
            {displayLabel:'Classic Pick',resultLabel:'Pepperoni',fullText:'A savory favorite with crisp, spicy edges.',revealClue:'These small red rounds are a classic pizza choice.',revealAnswer:'Pepperoni',stickerSearch:'pepperoni pizza',_stickerId:'pepperoni',_stickerUrl:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/pepperoni.png?v=1776702252'},
            {displayLabel:'Garden Pick',resultLabel:'Mushrooms',fullText:'Earthy slices that add a rich, savory bite.',revealClue:'This forest favorite becomes tender in the oven.',revealAnswer:'Mushrooms',stickerSearch:'mushroom pizza',_stickerId:'mushrooms',_stickerUrl:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/mushrooms.png?v=1776702250'},
            {displayLabel:'Sunny Pick',resultLabel:'Pineapple',fullText:'Sweet golden pieces with a bright tropical flavor.',revealClue:'A tropical fruit that makes pizza debates erupt.',revealAnswer:'Pineapple',stickerSearch:'pineapple pizza',_stickerId:'pineapple',_stickerUrl:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/pineapple.png?v=1776702251'},
            {displayLabel:'Green Pick',resultLabel:'Bell Peppers',fullText:'Colorful, crunchy strips with gentle sweetness.',revealClue:'These crisp garden strips can be red, yellow, or green.',revealAnswer:'Bell Peppers',stickerSearch:'pepper pizza',_stickerId:'peppers',_stickerUrl:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/peppers.png?v=1776702252'},
            {displayLabel:'Smoky Pick',resultLabel:'Bacon',fullText:'Crisp, smoky pieces that add a rich savory crunch.',revealClue:'These smoky breakfast pieces become extra crisp in the oven.',revealAnswer:'Bacon',stickerSearch:'bacon pizza',_stickerId:'bacon',_stickerUrl:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/bacon.png?v=1776702252'},
            {displayLabel:'Cheesy Pick',resultLabel:'Extra Cheese',fullText:'A gooey extra layer for maximum cheese pull.',revealClue:'This topping doubles down on the melty main event.',revealAnswer:'Extra Cheese',stickerSearch:'cheese pizza',_stickerId:'cheese',_stickerUrl:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/cheese.png?v=1776702251'}
          ]
        };
        setTimeout(function(){ renderAIReview(); }, 60);
        setStatus(isPro ? 'Pizza Toppings example — edit it, remix it, or generate your own.' : 'Sample Vortex response — sign in with Vortex Pro to create your own.', false);
      }else{
        renderAIReview();
      }

    })();


    // pins
    r.btnClearPins.addEventListener('click', function(){
      TW.pushUndo();
      TW.state.pins = [];
      TW.renderPins && TW.renderPins();
      TW.saveSoon && TW.saveSoon();
    });

    // dashboard / share / overlay
    r.btnDashboardSave.addEventListener('click', function(){
      TW.saveToDashboard && TW.saveToDashboard();
    });

    r.btnShare.addEventListener('click', function(){
      TW.openShare && TW.openShare();
      try{ closeMoreMenu(); }catch(_){ }
    });
    r.btnOverlay.addEventListener('click', function(){
      TW.toggleOverlay && TW.toggleOverlay();
      try{ closeMoreMenu(); }catch(_){}
    });
    function closeMoreMenu(){
      if(!r.morePanel) return;
      r.morePanel.hidden = true;
      r.btnMore && r.btnMore.setAttribute('aria-expanded', 'false');
    }

    function openMoreMenu(){
      if(!r.morePanel || !r.btnMore) return;
      r.morePanel.hidden = false;
      placeMenuPanel(r.btnMore, r.morePanel);
      r.btnMore.setAttribute('aria-expanded', 'true');
    }

    if(r.btnMore){
      r.btnMore.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        if(!r.morePanel) return;
        if(r.morePanel.hidden) openMoreMenu();
        else closeMoreMenu();
      });
      document.addEventListener('click', function(ev){
        if(!r.morePanel || r.morePanel.hidden) return;
        if(ev.target === r.btnMore || (r.btnMore && r.btnMore.contains(ev.target))) return;
        if(r.morePanel.contains && r.morePanel.contains(ev.target)) return;
        closeMoreMenu();
      });
      window.addEventListener('resize', closeMoreMenu, { passive:true });
      window.addEventListener('scroll', closeMoreMenu, { passive:true });
    }

    // header reset
    r.btnResetAllTop.addEventListener('click', function(){
      TW.resetAll && TW.resetAll();
      try{ closeMoreMenu(); }catch(_){ }
    });

    // header elimination toggle
    r.btnElimTop.addEventListener('click', function(){
      TW.pushUndo();
      TW.state.ui.eliminateOn = (TW.state.ui.eliminateOn === 'yes') ? 'no' : 'yes';
      var on = TW.state.ui.eliminateOn === 'yes';
      var sp = r.btnElimTop.querySelector('.tw-btnLabel');
      if(sp) sp.textContent = T('Eliminate');
      r.btnElimTop.classList.toggle('isOn', on);
      r.btnElimTop.setAttribute('aria-pressed', on ? 'true' : 'false');
      r.btnElimTop.setAttribute('title', on ? 'Eliminate winner is on' : 'Eliminate winner is off');
      TW.renderAll && TW.renderAll();
      TW.saveSoon && TW.saveSoon();
    });

    // center badge controls
    var CENTER_VORTEX_CDN = 'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/';
    var CENTER_VORTEX_FILES = [
      'luckycalleraltvortex.png?v=1786112954','buildbattlealtvortex.png?v=1786112954','weekendwhirlaltvortex.png?v=1786112954',
      'tapetwistaltvortex.png?v=1786112955','blindbuzzaltvortex.png?v=1786112955','brightcircuitaltvortex.png?v=1786112955',
      'jackpotparadealtvortex.png?v=1786112955','emeraldluckaltvortex.png?v=1786112955','fidgetwheelaltvortex.png?v=1786112955',
      'midnightsparkaltvortex.png?v=1786112955','sweetspinaltvortex.png?v=1786112955','candydarealtvortex.png?v=1786112956',
      'quickquirkaltvortex.png?v=1786112956','identityinkaltvortex.png?v=1786112956','rosesugaraltvortex.png?v=1786112956',
      'crittercirclealtvortex.png?v=1786112956','dailybrewaltvortex.png?v=1786112956','timetanglealtvortex.png?v=1786112957',
      'traveltwistaltvortex.png?v=1786112957','batterblastaltvortex.png?v=1786112957','pastelbloomaltvortex.png?v=1786112957',
      'candycauldronaltvortex2.png?v=1786112957','motionmapaltvortex.png?v=1786112957',
      'frostfixaltvortex.png?v=1786112958','candycauldronaltvortex1.png?v=1786112957','fractionflashaltvortex.png?v=1786112957',
      'grindglowaltvortex.png?v=1786112958','varsityspinaltvortex.png?v=1786112958','blushbundlealtvortex.png?v=1786112957',
      'pulseplayaltvortex.png?v=1786112958','velvetwinkaltvortex.png?v=1786112958','customwheelaltvortex.png?v=1786112958',
      'gymdodgealtvortex.png?v=1786112958','playgroundpopaltvortex.png?v=1786112958','flavorflexaltvortex.png?v=1786112958',
      'bullseyeblitzvortex_7cb459e1-3bc3-4e55-ae0f-7508d1059c7d.png?v=1786112958','petalglowaltvortex.png?v=1786112958',
      'slatesparkaltvortex.png?v=1786112958','globalglidealtvortex.png?v=1786112958','yearjackpotaltvortex.png?v=1786112958',
      'helloglobealtvortex.png?v=1786112958','fitnessflipaltvortex.png?v=1786112958','dailydriftaltvortex.png?v=1786112958',
      'victoryvibealtvortex.png?v=1786112958','pizzapickeraltvortex2.png?v=1786112958','prizepopaltvortex.png?v=1786112958',
      'coastalchoicealtvortex.png?v=1786112958','meadowsignalaltvortex.png?v=1786112958','landmarkloopaltvortex.png?v=1786112958',
      'pizzapickeraltvortex1.png?v=1786112958','pizzapickeraltvortex3.png?v=1786112958'
    ];
    var CENTER_VORTEX_ADDITIONS = [
      { id:'center-vortex-1', name:'Center Vortex 1', tier:'vortex_pro', url:CENTER_VORTEX_CDN + 'centervortex1.png?v=1788622132' },
      { id:'center-vortex-2', name:'Center Vortex 2', tier:'vortex_pro', url:CENTER_VORTEX_CDN + 'centervortex2.png?v=1788622132' },
      { id:'center-vortex-3', name:'Center Vortex 3', tier:'vortex_pro', url:CENTER_VORTEX_CDN + 'centervortex3.png?v=1788622133' },
      { id:'wasteland-wheel-center', name:'Wasteland Wheel Center Vortex', tier:'vortex_pro', url:CENTER_VORTEX_CDN + 'wastelandwheelcentervortex.png?v=1788622198' },
      { id:'canvas-craze-center', name:'Canvas Craze Center Vortex', tier:'vortex_pro', url:CENTER_VORTEX_CDN + 'canvascrazecentervortex.png?v=1788622217' },
      { id:'marigold-night-center', name:'Marigold Night Center Vortex', tier:'vortex_pro', url:CENTER_VORTEX_CDN + 'marigoldnightcentervortex.png?v=1788622238' },
      { id:'free-neon-metal-center', name:'Neon Metal Center Vortex', tier:'free', url:CENTER_VORTEX_CDN + 'freecentervortexmetalwithneon.png?v=1788622772' },
      { id:'free-grass-fence-center', name:'Grass and White Fence Center Vortex', tier:'free', url:CENTER_VORTEX_CDN + 'freecentervortexgrasswhitefence.png?v=1788622772' },
      { id:'free-glitter-balloons-center', name:'Glitter Balloons Center Vortex', tier:'free', url:CENTER_VORTEX_CDN + 'freecentervortexglitterballoons.png?v=1788622772' },
      { id:'free-what-to-do-center', name:'What to Do Center Vortex', tier:'free', url:CENTER_VORTEX_CDN + 'homepagewhattodowheelcentervortex.png?v=1789906932' }
    ];
    var CENTER_VORTEX_PACKS = [
      { id:'classroom-quest-center', name:'Classroom Quest Center Vortex', tier:'vortex_pro', packTag:'pack_lab_classroom_quest', packName:'Classroom Quest Lab Pack', url:CENTER_VORTEX_CDN + 'classroomquestcentervortex.png?v=1788619021' },
      { id:'snack-attack-center', name:'Snack Attack Center Vortex', tier:'vortex_pro', packTag:'pack_lab_snack_attack', packName:'Snack Attack Lab Pack', url:CENTER_VORTEX_CDN + 'snackattackcentervortex.png?v=1788618905' },
      { id:'decision-center', name:'Decision Lab Center Vortex', tier:'vortex_pro', packTag:'pack_lab_decision', packName:'Decision Lab Pack', url:CENTER_VORTEX_CDN + 'decisionlabcentervortex.png?v=1788618896' },
      { id:'sugar-rush-center', name:'Sugar Rush Center Vortex', tier:'vortex_pro', packTag:'pack_lab_sugar_rush', packName:'Sugar Rush Lab Pack', url:CENTER_VORTEX_CDN + 'sugarrushcentervortex.png?v=1788618495' },
      { id:'calavera-center', name:'Calavera Lab Center Vortex', tier:'vortex_pro', packTag:'pack_lab_calavera', packName:'Calavera Lab Pack', url:CENTER_VORTEX_CDN + 'calaveralabcentervortex.png?v=1788618378' },
      { id:'chaos-challenge-center', name:'Chaos Challenge Center Vortex', tier:'vortex_pro', packTag:'pack_lab_chaos_challenge', packName:'Chaos Challenge Lab Pack', url:CENTER_VORTEX_CDN + 'chaoschallengecentervortex.png?v=1788618171' },
      { id:'festive-center', name:'Festive Lab Center Vortex', tier:'vortex_pro', packTag:'pack_lab_festive', packName:'Festive Lab Pack', url:CENTER_VORTEX_CDN + 'festivelabcentervortex.png?v=1788617874' },
      { id:'creator-center', name:'Creator Lab Center Vortex', tier:'vortex_pro', packTag:'pack_lab_creator', packName:'Creator Lab Pack', url:CENTER_VORTEX_CDN + 'creatorlabcentervortex.png?v=1788617763' },
      { id:'reward-quest-center', name:'Reward Quest Center Vortex', tier:'vortex_pro', packTag:'pack_lab_reward_quest', packName:'Reward Quest Lab Pack', url:CENTER_VORTEX_CDN + 'rewardquestcentervortex.png?v=1788617630' },
      { id:'party-blast-center', name:'Party Blast Center Vortex', tier:'vortex_pro', packTag:'pack_lab_party_blast', packName:'Party Blast Lab Pack', url:CENTER_VORTEX_CDN + 'partyblastcentervortex.png?v=1788617505' },
      { id:'midway-munch-center', name:'Midway Munch Center Vortex', tier:'vortex_pro', packTag:'pack_lab_midway_munch', packName:'Midway Munch Lab Pack', url:CENTER_VORTEX_CDN + 'midwaymunchcentervortex.png?v=1788617406' },
      { id:'pizza-lab-center', name:'Pizza Lab Center Vortex', tier:'vortex_pro', packTag:'pack_lab_pizza_lab', packName:'Pizza Lab Pack', url:CENTER_VORTEX_CDN + 'pizzapickercentervortex.png?v=1788617399' },
      { id:'bird-quest-center', name:'Bird Quest Center Vortex', tier:'vortex_pro', packTag:'pack_lab_bird_quest', packName:'Bird Quest Lab Pack', url:CENTER_VORTEX_CDN + 'birdquestcentervortex.png?v=1788617144' },
      { id:'hive-quest-center', name:'Hive Quest Center Vortex', tier:'vortex_pro', packTag:'pack_lab_hive_quest', packName:'Hive Quest Lab Pack', url:CENTER_VORTEX_CDN + 'hivequestcentervortex.png?v=1788617047' }
    ];
    TW.CENTER_VORTEXES = [{
      id:'homepage', name:'Classic Center Vortex', tier:'free',
      url:CENTER_VORTEX_CDN + 'homepagewheelcentervortex.png?v=1784580749'
    }].concat(CENTER_VORTEX_FILES.map(function(file, index){
      var id = file.split('?')[0].replace(/\.png$/,'').replace(/altvortex[123]?$/,'').replace(/vortex_.+$/,'');
      return { id:id || ('premium-' + index), name:'Premium Center Vortex ' + (index + 1), tier:'vortex_pro', url:CENTER_VORTEX_CDN + file };
    })).concat(CENTER_VORTEX_ADDITIONS, CENTER_VORTEX_PACKS, Array.isArray(window.TOKI_CENTER_VORTEX_PACKS) ? window.TOKI_CENTER_VORTEX_PACKS : []);

    function closeCenterVortexPicker(){
      var existing = document.getElementById('twCenterVortexBack');
      if(existing && existing.parentNode) existing.parentNode.removeChild(existing);
      try{ document.body.classList.remove('twCenterVortexOpen'); }catch(_){ }
    }

    function applyCenterVortex(item){
      TW.pushUndo();
      TW.state.ui.centerBadgeUrl = item.url;
      TW.state.ui.centerBadgeMask = 'circle';
      TW.state.ui.centerBadgeOffX = 0;
      TW.state.ui.centerBadgeOffY = 0;
      TW.state.ui.centerBadgeScale = 1;
      TW.state.ui.centerBadgeEditOn = 'no';
      r.badgeUrl.value = item.url;
      r.selBadgeMask.value = 'circle';
      r.rangeBadgeScale.value = '1';
      r.btnBadgeEdit.textContent = 'Edit badge: Off';
      TW.renderWheel && TW.renderWheel();
      TW.saveSoon && TW.saveSoon();
      closeCenterVortexPicker();
    }

    function openCenterVortexPicker(){
      closeCenterVortexPicker();
      var ownedOnly = false;
      var back = U.el('div', { class:'tw-centerVortexBack', id:'twCenterVortexBack' });
      var dialog = U.el('div', { class:'tw-centerVortexDialog tw-imagePopover', role:'dialog', 'aria-modal':'true', 'aria-label':'Center vortex picker' });
      var browseBtn = U.el('button', { class:'tw-btn tw-stickerAccessBtn', type:'button', 'aria-pressed':'false', text:'Browse Your Images' });
      var expandBtn = U.el('button', { class:'tw-stickerExpandBtn tw-centerVortexExpand', type:'button', 'aria-expanded':'false', text:'Expand Vortex Workspace' });
      var grid = U.el('div', { class:'tw-centerVortexGrid tw-palette' });
      var plusIcon = 'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexproglassesicon.png?v=1789304505';

      function placeVortexPicker(){
        if(dialog.classList.contains('isExpanded')) return;
        if(TW.placePopoverFixed){ TW.placePopoverFixed(r.btnBadgeVortex, dialog); return; }
        var rect = r.btnBadgeVortex.getBoundingClientRect();
        var width = Math.min(280, Math.max(200, (window.innerWidth || 320) - 24));
        var left = Math.max(12, Math.min(rect.left, (window.innerWidth || width) - width - 12));
        var below = rect.bottom + 10;
        var availableBelow = (window.innerHeight || 700) - below - 12;
        dialog.style.width = width + 'px';
        dialog.style.maxWidth = width + 'px';
        dialog.style.left = left + 'px';
        dialog.style.top = (availableBelow >= 300 ? below : Math.max(12, rect.top - 348)) + 'px';
      }

      function renderTiles(){
        grid.innerHTML = '';
        (TW.CENTER_VORTEXES || []).forEach(function(item){
          var canUse = (TW.access && TW.access.canUseStickerItem)
            ? TW.access.canUseStickerItem(item)
            : (item.tier === 'free' || !(TW.access && TW.access.hasPlan) || TW.access.hasPlan('vortex_pro'));
          if(ownedOnly && !canUse) return;
          var tile = U.el('button', { class:'tw-palBtn tw-stickerTile tw-centerVortexTile', type:'button', 'aria-label':item.name + (canUse ? '' : ' — Vortex Pro') });
          tile.appendChild(U.el('img', { class:'tw-stickerImg', src:item.url, alt:item.name, loading:'lazy', draggable:'false' }));
          if(item.tier !== 'free') tile.appendChild(U.el('span', { class:'tw-planPill tw-planPillTile tw-planPillPro', html:'<img src="' + plusIcon + '" alt="Vortex Pro">' }));
          tile.addEventListener('click', function(){
            var reviewPlan = function(){
              closeCenterVortexPicker();
              if(item.packTag && TW.openStickerPackUpsell){
                TW.openStickerPackUpsell(item);
                return;
              }
              TW.openPlanUpsell && TW.openPlanUpsell('vortex_pro', {
                title:'Unlock every Center Vortex',
                message:'Vortex Pro unlocks the complete Center Vortex collection.',
                subtext:'Center Vortex library • premium wheels • complete sticker library',
                href:'https://spinthewheellab.com/pages/vortexpro'
              });
            };
            if(TW.openImagePreview){
              TW.openImagePreview(item, canUse, function(){ applyCenterVortex(item); }, {
                imageAlt:'Center vortex preview',
                chooseText:'Use This Center Vortex',
                lockedText:'View Vortex Pro',
                useHint:'Review the larger vortex, then choose it or continue browsing.',
                lockedHint:item.packName ? ('This center vortex is available with ' + item.packName + ' or Vortex Pro.') : 'This center vortex is available with Vortex Pro.',
                cancelText:'Continue Browsing',
                onLocked:reviewPlan
              });
            }else if(canUse){ applyCenterVortex(item); }
            else reviewPlan();
          });
          grid.appendChild(tile);
        });
      }

      browseBtn.addEventListener('click', function(){
        ownedOnly = !ownedOnly;
        browseBtn.textContent = ownedOnly ? 'Browse All Images' : 'Browse Your Images';
        browseBtn.setAttribute('aria-pressed', ownedOnly ? 'true' : 'false');
        renderTiles();
      });
      expandBtn.addEventListener('click', function(){
        var expanded = !dialog.classList.contains('isExpanded');
        dialog.classList.toggle('isExpanded', expanded);
        expandBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        expandBtn.textContent = expanded ? 'Compact Vortex Workspace' : 'Expand Vortex Workspace';
        if(expanded){
          var expandedWidth = Math.min(1060, Math.max(700, (window.innerWidth || 1100) - 32));
          dialog.style.width = expandedWidth + 'px';
          dialog.style.maxWidth = expandedWidth + 'px';
          dialog.style.left = Math.max(12, Math.round(((window.innerWidth || expandedWidth) - expandedWidth) / 2)) + 'px';
          dialog.style.top = '16px';
        }else{
          placeVortexPicker();
        }
      });
      back.addEventListener('click', function(ev){ if(ev.target === back) closeCenterVortexPicker(); });
      dialog.addEventListener('keydown', function(ev){ if(ev.key === 'Escape') closeCenterVortexPicker(); });
      dialog.appendChild(U.el('div', { class:'tw-mini tw-centerVortexCopy', text:'Select a ready-made vortex to replace the wheel center. Premium designs are included with Vortex Pro.' }));
      dialog.appendChild(U.el('div', { class:'tw-centerVortexActions' }, [browseBtn]));
      dialog.appendChild(expandBtn);
      dialog.appendChild(grid); back.appendChild(dialog); document.body.appendChild(back);
      document.body.classList.add('twCenterVortexOpen'); renderTiles(); placeVortexPicker();
    }

    r.btnBadgeVortex.addEventListener('click', openCenterVortexPicker);

    r.badgeUrl.addEventListener('change', function(){
      TW.pushUndo();
      var v = (r.badgeUrl.value || '').trim();
      v = U.safeImageSource ? U.safeImageSource(v) : v;
      r.badgeUrl.value = v;
      TW.state.ui.centerBadgeUrl = v;
      TW.renderWheel && TW.renderWheel();
      TW.saveSoon && TW.saveSoon();
    });

    r.badgeFile.addEventListener('change', function(){
      var f = (r.badgeFile.files && r.badgeFile.files[0]) ? r.badgeFile.files[0] : null;
      if(!f) return;
      if(!U.prepareImageFile){ rejectUnsafeImageFile(r.badgeFile, new Error('The image processor is still loading. Please refresh and try again.')); return; }
      U.prepareImageFile(f, {
        maxDimension:800,
        targetBytes:250 * 1024
      }).then(function(safeImage){
        TW.pushUndo();
        TW.state.ui.centerBadgeUrl = safeImage;
        TW.state.ui.centerBadgeOffX = 0;
        TW.state.ui.centerBadgeOffY = 0;
        TW.state.ui.centerBadgeScale = 1;
        r.badgeUrl.value = '';
        TW.renderWheel && TW.renderWheel();
        TW.saveSoon && TW.saveSoon();
      }).catch(function(error){ rejectUnsafeImageFile(r.badgeFile, error); });
    });

    r.selBadgeMask.addEventListener('change', function(){
      TW.pushUndo();
      TW.state.ui.centerBadgeMask = r.selBadgeMask.value || 'circle';
      TW.renderWheel && TW.renderWheel();
      TW.saveSoon && TW.saveSoon();
    });

    r.rangeBadgeScale.addEventListener('input', function(){
      var v = parseFloat(r.rangeBadgeScale.value);
      if(!(v > 0)) v = 1;
      TW.state.ui.centerBadgeScale = U.clamp(v, 0.25, 2.5);
      TW.renderWheel && TW.renderWheel();
      TW.saveSoon && TW.saveSoon();
    });

    r.btnBadgeReset.addEventListener('click', function(){
      // ✅ SURGICAL: preserve the CURRENT badge URL exactly (do NOT change image)
      var keepUrl = (TW.state && TW.state.ui) ? TW.state.ui.centerBadgeUrl : '';

      TW.pushUndo();

      // keep the badge image exactly as-is
      TW.state.ui.centerBadgeUrl = keepUrl;

      // reset position/scale only
      TW.state.ui.centerBadgeOffX = 0;
      TW.state.ui.centerBadgeOffY = 0;
      TW.state.ui.centerBadgeScale = 1;

      if(r.rangeBadgeScale) r.rangeBadgeScale.value = '1';
      TW.renderWheel && TW.renderWheel();
      TW.saveSoon && TW.saveSoon();
    });

    r.btnBadgeDefault.addEventListener('click', function(){
      TW.pushUndo();
      var preset = TW._pagePreset || {};
      var defaultUrl = (preset.centerBadgeUrl != null) ? String(preset.centerBadgeUrl || '') : '';
      var defaultMask = (preset.centerBadgeMask != null) ? String(preset.centerBadgeMask || 'circle') : 'circle';
      var defaultScale = (preset.centerBadgeScale != null && parseFloat(preset.centerBadgeScale) > 0) ? parseFloat(preset.centerBadgeScale) : 1;
      var defaultOffX = (preset.centerBadgeOffX != null && isFinite(preset.centerBadgeOffX)) ? parseFloat(preset.centerBadgeOffX) : 0;
      var defaultOffY = (preset.centerBadgeOffY != null && isFinite(preset.centerBadgeOffY)) ? parseFloat(preset.centerBadgeOffY) : 0;
      TW.state.ui.centerBadgeUrl = defaultUrl;
      TW.state.ui.centerBadgeMask = defaultMask;
      TW.state.ui.centerBadgeOffX = defaultOffX;
      TW.state.ui.centerBadgeOffY = defaultOffY;
      TW.state.ui.centerBadgeScale = defaultScale;
      TW.state.ui.centerBadgeEditOn = 'no';
      if(r.rangeBadgeScale) r.rangeBadgeScale.value = String(defaultScale);
      r.badgeUrl.value = '';
      try{ r.badgeFile.value = ''; }catch(_){}
      r.btnBadgeEdit.textContent = 'Edit badge: Off';
      TW.renderWheel && TW.renderWheel();
      TW.saveSoon && TW.saveSoon();
    });

    r.btnBadgeClear.addEventListener('click', function(){
      TW.pushUndo();

      // ✅ Clear badge => show the white reset circle image
      TW.state.ui.centerBadgeUrl = RESET_BADGE_URL;

      TW.state.ui.centerBadgeMask = 'circle';
      TW.state.ui.centerBadgeOffX = 0;
      TW.state.ui.centerBadgeOffY = 0;
      TW.state.ui.centerBadgeScale = 1;
      TW.state.ui.centerBadgeEditOn = 'no';

      r.badgeUrl.value = '';
      try{ r.badgeFile.value = ''; }catch(_){}
      if(r.rangeBadgeScale) r.rangeBadgeScale.value = '1';
      r.btnBadgeEdit.textContent = 'Edit badge: Off';

      TW.renderWheel && TW.renderWheel();
      TW.saveSoon && TW.saveSoon();
    });

    r.btnBadgeEdit.addEventListener('click', function(){
      TW.pushUndo();
      TW.state.ui.centerBadgeEditOn = (TW.state.ui.centerBadgeEditOn === 'yes') ? 'no' : 'yes';
      r.btnBadgeEdit.textContent = 'Edit badge: ' + (TW.state.ui.centerBadgeEditOn === 'yes' ? 'On' : 'Off');
      TW.renderAll && TW.renderAll();
      TW.saveSoon && TW.saveSoon();
    });

    // teams
    r.btnAddTeam.addEventListener('click', function(){
      var name = (r.teamName.value||'').trim();
      if(!name) return;
      TW.addTeam && TW.addTeam(name);
      r.teamName.value = '';
    });
    r.btnResetPts.addEventListener('click', function(){
      TW.resetPoints && TW.resetPoints();
    });
    r.btnClearTeams.addEventListener('click', function(){
      TW.clearTeams && TW.clearTeams();
    });

    // history
    r.btnCSV.addEventListener('click', function(){
      TW.downloadCSV && TW.downloadCSV();
    });
    r.btnClearHist.addEventListener('click', function(){
      TW.pushUndo();
      TW.state.history = [];
      TW.renderHistory && TW.renderHistory();
      TW.saveSoon && TW.saveSoon();
    });
  }

  TW.enhanceSelectMenu = enhanceSelectMenu;

  /* iPhone/iPad Safari focus zoom guard. Arm before the control receives
     focus, then restore the site's original viewport policy after editing. */
  (function installSafariFocusZoomGuard(){
    if(TW._safariFocusZoomGuardBound) return;
    var nav = window.navigator || {};
    var appleTouch = /iPad|iPhone|iPod/.test(nav.userAgent || '') || (nav.platform === 'MacIntel' && Number(nav.maxTouchPoints || 0) > 1);
    if(!appleTouch) return;
    TW._safariFocusZoomGuardBound = true;
    var meta = document.querySelector('meta[name="viewport"]');
    var created = false;
    var original = meta ? meta.getAttribute('content') : null;
    var restoreTimer = 0;

    function isTextControl(target){
      if(!target || !target.matches) return false;
      return target.matches('textarea,select,input:not([type="range"]):not([type="color"]):not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="file"])');
    }
    function arm(){
      if(restoreTimer){ clearTimeout(restoreTimer); restoreTimer = 0; }
      if(!meta){
        meta = document.createElement('meta');
        meta.setAttribute('name','viewport');
        meta.setAttribute('content','width=device-width, initial-scale=1');
        document.head.appendChild(meta);
        created = true;
      }
      var content = String(meta.getAttribute('content') || 'width=device-width, initial-scale=1');
      content = content.replace(/\s*,?\s*(maximum-scale|user-scalable)\s*=\s*[^,]+/gi,'');
      meta.setAttribute('content', content.replace(/^\s*,|,\s*$/g,'') + ', maximum-scale=1, user-scalable=no');
    }
    function restore(){
      if(created && meta && meta.parentNode){ meta.parentNode.removeChild(meta); meta = null; created = false; }
      else if(meta){
        if(original == null) meta.removeAttribute('content');
        else meta.setAttribute('content', original);
      }
    }
    function prepare(ev){ if(isTextControl(ev.target)) arm(); }
    document.addEventListener('touchstart', prepare, { passive:true, capture:true });
    document.addEventListener('pointerdown', prepare, { passive:true, capture:true });
    document.addEventListener('focusin', prepare, true);
    document.addEventListener('focusout', function(){
      restoreTimer = setTimeout(function(){
        if(!isTextControl(document.activeElement)) restore();
      }, 400);
    }, true);
  })();

  // expose init
  TW.buildUI = build;

  // boot when DOM ready
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', build);
  }else{
    build();
  }
})();
